/* eslint-disable */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT
// Regenerate the file by running 'yarn compile:ajv'
'use strict';
import { fullFormats } from 'ajv-formats/dist/formats';
const formatWrapper = { ...fullFormats };
function ucs2length(str) {
    const len = str.length;
    let length = 0;
    let pos = 0;
    let value;
    while (pos < len) {
        length++;
        value = str.charCodeAt(pos++);
        if (value >= 0xd800 && value <= 0xdbff && pos < len) {
            value = str.charCodeAt(pos);
            if ((value & 0xfc00) === 0xdc00)
                pos++;
        }
    }
    return length;
}
function padString(input) {
    var segmentLength = 4;
    var stringLength = input.length;
    var diff = stringLength % segmentLength;
    if (!diff) {
        return input;
    }
    var position = stringLength;
    var padLength = segmentLength - diff;
    var paddedStringLength = stringLength + padLength;
    var buffer = Buffer.alloc(paddedStringLength);
    buffer.write(input);
    while (padLength--) {
        buffer.write('=', position++);
    }
    return buffer.toString();
}
function toBase64(base64url) {
    base64url = base64url.toString();
    return padString(base64url).replace(/\-/g, '+').replace(/_/g, '/');
}
function base64urlToBuffer(base64url) {
    return Buffer.from(toBase64(base64url), 'base64');
}
function fromBase64(base64) {
    return base64.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
function base64urlEncode(input, encoding) {
    if (encoding === void 0) {
        encoding = 'utf8';
    }
    if (Buffer.isBuffer(input)) {
        return fromBase64(input.toString('base64'));
    }
    return fromBase64(Buffer.from(input, encoding).toString('base64'));
}
export const agentSyncAuthSchemaValidation = validate12;
const schema29 = {
    $id: 'urn:wisepipe-common-connection:AgentSyncAuth',
    type: 'object',
    properties: {
        key: { type: 'string', minLength: 1 },
        secret: { type: 'string', minLength: 1 },
        useSandbox: { type: 'boolean' }
    },
    required: ['key', 'secret', 'useSandbox']
};
const func2 = ucs2length;
function validate12(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:AgentSyncAuth" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.key === undefined && (missing0 = 'key')) ||
                (data.secret === undefined && (missing0 = 'secret')) ||
                (data.useSandbox === undefined && (missing0 = 'useSandbox'))) {
                validate12.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.key !== undefined) {
                    let data0 = data.key;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate12.errors = [
                                    {
                                        instancePath: instancePath + '/key',
                                        schemaPath: '#/properties/key/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate12.errors = [
                                {
                                    instancePath: instancePath + '/key',
                                    schemaPath: '#/properties/key/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.secret !== undefined) {
                        let data1 = data.secret;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate12.errors = [
                                        {
                                            instancePath: instancePath + '/secret',
                                            schemaPath: '#/properties/secret/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate12.errors = [
                                    {
                                        instancePath: instancePath + '/secret',
                                        schemaPath: '#/properties/secret/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.useSandbox !== undefined) {
                            const _errs5 = errors;
                            if (typeof data.useSandbox !== 'boolean') {
                                validate12.errors = [
                                    {
                                        instancePath: instancePath + '/useSandbox',
                                        schemaPath: '#/properties/useSandbox/type',
                                        keyword: 'type',
                                        params: { type: 'boolean' },
                                        message: 'must be boolean'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate12.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate12.errors = vErrors;
    return errors === 0;
}
export const agentSyncConnectionSchemaValidation = validate13;
const schema30 = {
    $id: 'urn:wisepipe-common-connection:AgentSyncConnection',
    type: 'object',
    properties: { useSandbox: { type: 'boolean' } },
    required: ['useSandbox']
};
function validate13(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:AgentSyncConnection" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.useSandbox === undefined && (missing0 = 'useSandbox')) {
                validate13.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.useSandbox !== undefined) {
                    if (typeof data.useSandbox !== 'boolean') {
                        validate13.errors = [
                            {
                                instancePath: instancePath + '/useSandbox',
                                schemaPath: '#/properties/useSandbox/type',
                                keyword: 'type',
                                params: { type: 'boolean' },
                                message: 'must be boolean'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        else {
            validate13.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate13.errors = vErrors;
    return errors === 0;
}
export const amazonAuroraAuthSchemaValidation = validate14;
const schema31 = {
    $id: 'urn:wisepipe-common-connection:AmazonAuroraAuth',
    type: 'object',
    properties: { engineType: { type: 'string', enum: ['mySql', 'msSql', 'postgreSql'] } },
    required: []
};
function validate14(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:AmazonAuroraAuth" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.engineType !== undefined) {
                let data0 = data.engineType;
                if (typeof data0 !== 'string') {
                    validate14.errors = [
                        {
                            instancePath: instancePath + '/engineType',
                            schemaPath: '#/properties/engineType/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string'
                        }
                    ];
                    return false;
                }
                if (!(data0 === 'mySql' || data0 === 'msSql' || data0 === 'postgreSql')) {
                    validate14.errors = [
                        {
                            instancePath: instancePath + '/engineType',
                            schemaPath: '#/properties/engineType/enum',
                            keyword: 'enum',
                            params: { allowedValues: schema31.properties.engineType.enum },
                            message: 'must be equal to one of the allowed values'
                        }
                    ];
                    return false;
                }
            }
        }
        else {
            validate14.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate14.errors = vErrors;
    return errors === 0;
}
export const amazonAuroraConnectionSchemaValidation = validate15;
const schema32 = {
    $id: 'urn:wisepipe-common-connection:AmazonAuroraConnection',
    type: 'object',
    properties: { engineType: { type: 'string', enum: ['mySql', 'msSql', 'postgreSql'] } },
    required: ['engineType']
};
function validate15(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:AmazonAuroraConnection" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.engineType === undefined && (missing0 = 'engineType')) {
                validate15.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.engineType !== undefined) {
                    let data0 = data.engineType;
                    if (typeof data0 !== 'string') {
                        validate15.errors = [
                            {
                                instancePath: instancePath + '/engineType',
                                schemaPath: '#/properties/engineType/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'mySql' || data0 === 'msSql' || data0 === 'postgreSql')) {
                        validate15.errors = [
                            {
                                instancePath: instancePath + '/engineType',
                                schemaPath: '#/properties/engineType/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema32.properties.engineType.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        else {
            validate15.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate15.errors = vErrors;
    return errors === 0;
}
export const amazonRedshiftAuthSchemaValidation = validate16;
const schema33 = {
    $id: 'urn:wisepipe-common-connection:AmazonRedshiftAuth',
    type: 'object',
    properties: {},
    required: []
};
function validate16(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:AmazonRedshiftAuth" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate16.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate16.errors = vErrors;
    return errors === 0;
}
export const amazonRedshiftConnectionSchemaValidation = validate17;
const schema34 = {
    $id: 'urn:wisepipe-common-connection:AmazonRedshiftConnection',
    type: 'object',
    properties: {},
    required: []
};
function validate17(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:AmazonRedshiftConnection" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate17.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate17.errors = vErrors;
    return errors === 0;
}
export const amazonS3AuthSchemaValidation = validate18;
const schema35 = {
    $id: 'urn:wisepipe-common-connection:AmazonS3Auth',
    type: 'object',
    properties: {
        bucket: { type: 'string' },
        roleToAssume: { $ref: 'urn:wisepipe-common-connection:AwsRoleAssumption' },
        region: {
            type: 'string',
            enum: [
                'us-east-2',
                'us-east-1',
                'us-west-1',
                'us-west-2',
                'af-south-1',
                'ap-east-1',
                'ap-south-2',
                'ap-southeast-3',
                'ap-southeast-4',
                'ap-south-1',
                'ap-northeast-3',
                'ap-northeast-2',
                'ap-southeast-1',
                'ap-southeast-2',
                'ap-northeast-1',
                'ca-central-1',
                'eu-central-1',
                'eu-west-1',
                'eu-west-2',
                'eu-south-1',
                'eu-west-3',
                'eu-south-2',
                'eu-north-1',
                'eu-central-2',
                'me-south-1',
                'me-central-1',
                'sa-east-1',
                'us-gov-east-1',
                'us-gov-west-1'
            ]
        }
    },
    required: ['bucket', 'roleToAssume']
};
const schema36 = {
    $id: 'urn:wisepipe-common-connection:AwsRoleAssumption',
    type: 'object',
    properties: {
        accountID: { type: 'string', minLength: 12 },
        externalID: { type: 'string', minLength: 1 },
        roleName: { type: 'string', minLength: 1 }
    },
    required: ['accountID', 'externalID', 'roleName']
};
function validate18(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:AmazonS3Auth" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.bucket === undefined && (missing0 = 'bucket')) ||
                (data.roleToAssume === undefined && (missing0 = 'roleToAssume'))) {
                validate18.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.bucket !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.bucket !== 'string') {
                        validate18.errors = [
                            {
                                instancePath: instancePath + '/bucket',
                                schemaPath: '#/properties/bucket/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.roleToAssume !== undefined) {
                        let data1 = data.roleToAssume;
                        const _errs3 = errors;
                        const _errs4 = errors;
                        if (errors === _errs4) {
                            if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                let missing1;
                                if ((data1.accountID === undefined && (missing1 = 'accountID')) ||
                                    (data1.externalID === undefined && (missing1 = 'externalID')) ||
                                    (data1.roleName === undefined && (missing1 = 'roleName'))) {
                                    validate18.errors = [
                                        {
                                            instancePath: instancePath + '/roleToAssume',
                                            schemaPath: 'urn:wisepipe-common-connection:AwsRoleAssumption/required',
                                            keyword: 'required',
                                            params: { missingProperty: missing1 },
                                            message: "must have required property '" + missing1 + "'"
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (data1.accountID !== undefined) {
                                        let data2 = data1.accountID;
                                        const _errs6 = errors;
                                        if (errors === _errs6) {
                                            if (typeof data2 === 'string') {
                                                if (func2(data2) < 12) {
                                                    validate18.errors = [
                                                        {
                                                            instancePath: instancePath + '/roleToAssume/accountID',
                                                            schemaPath: 'urn:wisepipe-common-connection:AwsRoleAssumption/properties/accountID/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 12 },
                                                            message: 'must NOT have fewer than 12 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate18.errors = [
                                                    {
                                                        instancePath: instancePath + '/roleToAssume/accountID',
                                                        schemaPath: 'urn:wisepipe-common-connection:AwsRoleAssumption/properties/accountID/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid2 = _errs6 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                    if (valid2) {
                                        if (data1.externalID !== undefined) {
                                            let data3 = data1.externalID;
                                            const _errs8 = errors;
                                            if (errors === _errs8) {
                                                if (typeof data3 === 'string') {
                                                    if (func2(data3) < 1) {
                                                        validate18.errors = [
                                                            {
                                                                instancePath: instancePath + '/roleToAssume/externalID',
                                                                schemaPath: 'urn:wisepipe-common-connection:AwsRoleAssumption/properties/externalID/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate18.errors = [
                                                        {
                                                            instancePath: instancePath + '/roleToAssume/externalID',
                                                            schemaPath: 'urn:wisepipe-common-connection:AwsRoleAssumption/properties/externalID/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid2 = _errs8 === errors;
                                        }
                                        else {
                                            var valid2 = true;
                                        }
                                        if (valid2) {
                                            if (data1.roleName !== undefined) {
                                                let data4 = data1.roleName;
                                                const _errs10 = errors;
                                                if (errors === _errs10) {
                                                    if (typeof data4 === 'string') {
                                                        if (func2(data4) < 1) {
                                                            validate18.errors = [
                                                                {
                                                                    instancePath: instancePath + '/roleToAssume/roleName',
                                                                    schemaPath: 'urn:wisepipe-common-connection:AwsRoleAssumption/properties/roleName/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate18.errors = [
                                                            {
                                                                instancePath: instancePath + '/roleToAssume/roleName',
                                                                schemaPath: 'urn:wisepipe-common-connection:AwsRoleAssumption/properties/roleName/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid2 = _errs10 === errors;
                                            }
                                            else {
                                                var valid2 = true;
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                validate18.errors = [
                                    {
                                        instancePath: instancePath + '/roleToAssume',
                                        schemaPath: 'urn:wisepipe-common-connection:AwsRoleAssumption/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.region !== undefined) {
                            let data5 = data.region;
                            const _errs12 = errors;
                            if (typeof data5 !== 'string') {
                                validate18.errors = [
                                    {
                                        instancePath: instancePath + '/region',
                                        schemaPath: '#/properties/region/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            if (!(data5 === 'us-east-2' ||
                                data5 === 'us-east-1' ||
                                data5 === 'us-west-1' ||
                                data5 === 'us-west-2' ||
                                data5 === 'af-south-1' ||
                                data5 === 'ap-east-1' ||
                                data5 === 'ap-south-2' ||
                                data5 === 'ap-southeast-3' ||
                                data5 === 'ap-southeast-4' ||
                                data5 === 'ap-south-1' ||
                                data5 === 'ap-northeast-3' ||
                                data5 === 'ap-northeast-2' ||
                                data5 === 'ap-southeast-1' ||
                                data5 === 'ap-southeast-2' ||
                                data5 === 'ap-northeast-1' ||
                                data5 === 'ca-central-1' ||
                                data5 === 'eu-central-1' ||
                                data5 === 'eu-west-1' ||
                                data5 === 'eu-west-2' ||
                                data5 === 'eu-south-1' ||
                                data5 === 'eu-west-3' ||
                                data5 === 'eu-south-2' ||
                                data5 === 'eu-north-1' ||
                                data5 === 'eu-central-2' ||
                                data5 === 'me-south-1' ||
                                data5 === 'me-central-1' ||
                                data5 === 'sa-east-1' ||
                                data5 === 'us-gov-east-1' ||
                                data5 === 'us-gov-west-1')) {
                                validate18.errors = [
                                    {
                                        instancePath: instancePath + '/region',
                                        schemaPath: '#/properties/region/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema35.properties.region.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs12 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate18.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate18.errors = vErrors;
    return errors === 0;
}
export const amazonS3ConnectionSchemaValidation = validate19;
const schema37 = {
    $id: 'urn:wisepipe-common-connection:AmazonS3Connection',
    type: 'object',
    properties: {
        bucket: { type: 'string' },
        region: {
            type: 'string',
            enum: [
                'us-east-2',
                'us-east-1',
                'us-west-1',
                'us-west-2',
                'af-south-1',
                'ap-east-1',
                'ap-south-2',
                'ap-southeast-3',
                'ap-southeast-4',
                'ap-south-1',
                'ap-northeast-3',
                'ap-northeast-2',
                'ap-southeast-1',
                'ap-southeast-2',
                'ap-northeast-1',
                'ca-central-1',
                'eu-central-1',
                'eu-west-1',
                'eu-west-2',
                'eu-south-1',
                'eu-west-3',
                'eu-south-2',
                'eu-north-1',
                'eu-central-2',
                'me-south-1',
                'me-central-1',
                'sa-east-1',
                'us-gov-east-1',
                'us-gov-west-1'
            ]
        }
    },
    required: ['bucket']
};
function validate19(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:AmazonS3Connection" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.bucket === undefined && (missing0 = 'bucket')) {
                validate19.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.bucket !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.bucket !== 'string') {
                        validate19.errors = [
                            {
                                instancePath: instancePath + '/bucket',
                                schemaPath: '#/properties/bucket/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.region !== undefined) {
                        let data1 = data.region;
                        const _errs3 = errors;
                        if (typeof data1 !== 'string') {
                            validate19.errors = [
                                {
                                    instancePath: instancePath + '/region',
                                    schemaPath: '#/properties/region/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data1 === 'us-east-2' ||
                            data1 === 'us-east-1' ||
                            data1 === 'us-west-1' ||
                            data1 === 'us-west-2' ||
                            data1 === 'af-south-1' ||
                            data1 === 'ap-east-1' ||
                            data1 === 'ap-south-2' ||
                            data1 === 'ap-southeast-3' ||
                            data1 === 'ap-southeast-4' ||
                            data1 === 'ap-south-1' ||
                            data1 === 'ap-northeast-3' ||
                            data1 === 'ap-northeast-2' ||
                            data1 === 'ap-southeast-1' ||
                            data1 === 'ap-southeast-2' ||
                            data1 === 'ap-northeast-1' ||
                            data1 === 'ca-central-1' ||
                            data1 === 'eu-central-1' ||
                            data1 === 'eu-west-1' ||
                            data1 === 'eu-west-2' ||
                            data1 === 'eu-south-1' ||
                            data1 === 'eu-west-3' ||
                            data1 === 'eu-south-2' ||
                            data1 === 'eu-north-1' ||
                            data1 === 'eu-central-2' ||
                            data1 === 'me-south-1' ||
                            data1 === 'me-central-1' ||
                            data1 === 'sa-east-1' ||
                            data1 === 'us-gov-east-1' ||
                            data1 === 'us-gov-west-1')) {
                            validate19.errors = [
                                {
                                    instancePath: instancePath + '/region',
                                    schemaPath: '#/properties/region/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema37.properties.region.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate19.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate19.errors = vErrors;
    return errors === 0;
}
export const amazonS3ExportAuthSchemaValidation = validate20;
const schema38 = {
    $id: 'urn:wisepipe-common-connection:AmazonS3ExportAuth',
    type: 'object',
    properties: {
        bucket: { type: 'string' },
        roleToAssume: { $ref: 'urn:wisepipe-common-connection:AwsRoleAssumption' },
        region: {
            type: 'string',
            enum: [
                'us-east-2',
                'us-east-1',
                'us-west-1',
                'us-west-2',
                'af-south-1',
                'ap-east-1',
                'ap-south-2',
                'ap-southeast-3',
                'ap-southeast-4',
                'ap-south-1',
                'ap-northeast-3',
                'ap-northeast-2',
                'ap-southeast-1',
                'ap-southeast-2',
                'ap-northeast-1',
                'ca-central-1',
                'eu-central-1',
                'eu-west-1',
                'eu-west-2',
                'eu-south-1',
                'eu-west-3',
                'eu-south-2',
                'eu-north-1',
                'eu-central-2',
                'me-south-1',
                'me-central-1',
                'sa-east-1',
                'us-gov-east-1',
                'us-gov-west-1'
            ]
        }
    },
    required: ['bucket', 'roleToAssume']
};
function validate20(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:AmazonS3ExportAuth" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.bucket === undefined && (missing0 = 'bucket')) ||
                (data.roleToAssume === undefined && (missing0 = 'roleToAssume'))) {
                validate20.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.bucket !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.bucket !== 'string') {
                        validate20.errors = [
                            {
                                instancePath: instancePath + '/bucket',
                                schemaPath: '#/properties/bucket/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.roleToAssume !== undefined) {
                        let data1 = data.roleToAssume;
                        const _errs3 = errors;
                        const _errs4 = errors;
                        if (errors === _errs4) {
                            if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                let missing1;
                                if ((data1.accountID === undefined && (missing1 = 'accountID')) ||
                                    (data1.externalID === undefined && (missing1 = 'externalID')) ||
                                    (data1.roleName === undefined && (missing1 = 'roleName'))) {
                                    validate20.errors = [
                                        {
                                            instancePath: instancePath + '/roleToAssume',
                                            schemaPath: 'urn:wisepipe-common-connection:AwsRoleAssumption/required',
                                            keyword: 'required',
                                            params: { missingProperty: missing1 },
                                            message: "must have required property '" + missing1 + "'"
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (data1.accountID !== undefined) {
                                        let data2 = data1.accountID;
                                        const _errs6 = errors;
                                        if (errors === _errs6) {
                                            if (typeof data2 === 'string') {
                                                if (func2(data2) < 12) {
                                                    validate20.errors = [
                                                        {
                                                            instancePath: instancePath + '/roleToAssume/accountID',
                                                            schemaPath: 'urn:wisepipe-common-connection:AwsRoleAssumption/properties/accountID/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 12 },
                                                            message: 'must NOT have fewer than 12 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate20.errors = [
                                                    {
                                                        instancePath: instancePath + '/roleToAssume/accountID',
                                                        schemaPath: 'urn:wisepipe-common-connection:AwsRoleAssumption/properties/accountID/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid2 = _errs6 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                    if (valid2) {
                                        if (data1.externalID !== undefined) {
                                            let data3 = data1.externalID;
                                            const _errs8 = errors;
                                            if (errors === _errs8) {
                                                if (typeof data3 === 'string') {
                                                    if (func2(data3) < 1) {
                                                        validate20.errors = [
                                                            {
                                                                instancePath: instancePath + '/roleToAssume/externalID',
                                                                schemaPath: 'urn:wisepipe-common-connection:AwsRoleAssumption/properties/externalID/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate20.errors = [
                                                        {
                                                            instancePath: instancePath + '/roleToAssume/externalID',
                                                            schemaPath: 'urn:wisepipe-common-connection:AwsRoleAssumption/properties/externalID/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid2 = _errs8 === errors;
                                        }
                                        else {
                                            var valid2 = true;
                                        }
                                        if (valid2) {
                                            if (data1.roleName !== undefined) {
                                                let data4 = data1.roleName;
                                                const _errs10 = errors;
                                                if (errors === _errs10) {
                                                    if (typeof data4 === 'string') {
                                                        if (func2(data4) < 1) {
                                                            validate20.errors = [
                                                                {
                                                                    instancePath: instancePath + '/roleToAssume/roleName',
                                                                    schemaPath: 'urn:wisepipe-common-connection:AwsRoleAssumption/properties/roleName/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate20.errors = [
                                                            {
                                                                instancePath: instancePath + '/roleToAssume/roleName',
                                                                schemaPath: 'urn:wisepipe-common-connection:AwsRoleAssumption/properties/roleName/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid2 = _errs10 === errors;
                                            }
                                            else {
                                                var valid2 = true;
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                validate20.errors = [
                                    {
                                        instancePath: instancePath + '/roleToAssume',
                                        schemaPath: 'urn:wisepipe-common-connection:AwsRoleAssumption/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.region !== undefined) {
                            let data5 = data.region;
                            const _errs12 = errors;
                            if (typeof data5 !== 'string') {
                                validate20.errors = [
                                    {
                                        instancePath: instancePath + '/region',
                                        schemaPath: '#/properties/region/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            if (!(data5 === 'us-east-2' ||
                                data5 === 'us-east-1' ||
                                data5 === 'us-west-1' ||
                                data5 === 'us-west-2' ||
                                data5 === 'af-south-1' ||
                                data5 === 'ap-east-1' ||
                                data5 === 'ap-south-2' ||
                                data5 === 'ap-southeast-3' ||
                                data5 === 'ap-southeast-4' ||
                                data5 === 'ap-south-1' ||
                                data5 === 'ap-northeast-3' ||
                                data5 === 'ap-northeast-2' ||
                                data5 === 'ap-southeast-1' ||
                                data5 === 'ap-southeast-2' ||
                                data5 === 'ap-northeast-1' ||
                                data5 === 'ca-central-1' ||
                                data5 === 'eu-central-1' ||
                                data5 === 'eu-west-1' ||
                                data5 === 'eu-west-2' ||
                                data5 === 'eu-south-1' ||
                                data5 === 'eu-west-3' ||
                                data5 === 'eu-south-2' ||
                                data5 === 'eu-north-1' ||
                                data5 === 'eu-central-2' ||
                                data5 === 'me-south-1' ||
                                data5 === 'me-central-1' ||
                                data5 === 'sa-east-1' ||
                                data5 === 'us-gov-east-1' ||
                                data5 === 'us-gov-west-1')) {
                                validate20.errors = [
                                    {
                                        instancePath: instancePath + '/region',
                                        schemaPath: '#/properties/region/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema38.properties.region.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs12 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate20.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate20.errors = vErrors;
    return errors === 0;
}
export const amazonS3ExportConnectionSchemaValidation = validate21;
const schema40 = {
    $id: 'urn:wisepipe-common-connection:AmazonS3ExportConnection',
    type: 'object',
    properties: {
        bucket: { type: 'string' },
        region: {
            type: 'string',
            enum: [
                'us-east-2',
                'us-east-1',
                'us-west-1',
                'us-west-2',
                'af-south-1',
                'ap-east-1',
                'ap-south-2',
                'ap-southeast-3',
                'ap-southeast-4',
                'ap-south-1',
                'ap-northeast-3',
                'ap-northeast-2',
                'ap-southeast-1',
                'ap-southeast-2',
                'ap-northeast-1',
                'ca-central-1',
                'eu-central-1',
                'eu-west-1',
                'eu-west-2',
                'eu-south-1',
                'eu-west-3',
                'eu-south-2',
                'eu-north-1',
                'eu-central-2',
                'me-south-1',
                'me-central-1',
                'sa-east-1',
                'us-gov-east-1',
                'us-gov-west-1'
            ]
        }
    },
    required: ['bucket']
};
function validate21(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:AmazonS3ExportConnection" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.bucket === undefined && (missing0 = 'bucket')) {
                validate21.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.bucket !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.bucket !== 'string') {
                        validate21.errors = [
                            {
                                instancePath: instancePath + '/bucket',
                                schemaPath: '#/properties/bucket/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.region !== undefined) {
                        let data1 = data.region;
                        const _errs3 = errors;
                        if (typeof data1 !== 'string') {
                            validate21.errors = [
                                {
                                    instancePath: instancePath + '/region',
                                    schemaPath: '#/properties/region/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data1 === 'us-east-2' ||
                            data1 === 'us-east-1' ||
                            data1 === 'us-west-1' ||
                            data1 === 'us-west-2' ||
                            data1 === 'af-south-1' ||
                            data1 === 'ap-east-1' ||
                            data1 === 'ap-south-2' ||
                            data1 === 'ap-southeast-3' ||
                            data1 === 'ap-southeast-4' ||
                            data1 === 'ap-south-1' ||
                            data1 === 'ap-northeast-3' ||
                            data1 === 'ap-northeast-2' ||
                            data1 === 'ap-southeast-1' ||
                            data1 === 'ap-southeast-2' ||
                            data1 === 'ap-northeast-1' ||
                            data1 === 'ca-central-1' ||
                            data1 === 'eu-central-1' ||
                            data1 === 'eu-west-1' ||
                            data1 === 'eu-west-2' ||
                            data1 === 'eu-south-1' ||
                            data1 === 'eu-west-3' ||
                            data1 === 'eu-south-2' ||
                            data1 === 'eu-north-1' ||
                            data1 === 'eu-central-2' ||
                            data1 === 'me-south-1' ||
                            data1 === 'me-central-1' ||
                            data1 === 'sa-east-1' ||
                            data1 === 'us-gov-east-1' ||
                            data1 === 'us-gov-west-1')) {
                            validate21.errors = [
                                {
                                    instancePath: instancePath + '/region',
                                    schemaPath: '#/properties/region/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema40.properties.region.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate21.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate21.errors = vErrors;
    return errors === 0;
}
export const apiKeySchemaValidation = validate22;
const schema41 = {
    $id: 'urn:wisepipe-common-connection:ApiKey',
    type: 'object',
    properties: { value: { type: 'string', minLength: 1 } },
    required: ['value']
};
function validate22(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:ApiKey" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.value === undefined && (missing0 = 'value')) {
                validate22.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.value !== undefined) {
                    let data0 = data.value;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate22.errors = [
                                    {
                                        instancePath: instancePath + '/value',
                                        schemaPath: '#/properties/value/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate22.errors = [
                                {
                                    instancePath: instancePath + '/value',
                                    schemaPath: '#/properties/value/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate22.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate22.errors = vErrors;
    return errors === 0;
}
export const awsRoleAssumptionSchemaValidation = validate23;
function validate23(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:AwsRoleAssumption" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.accountID === undefined && (missing0 = 'accountID')) ||
                (data.externalID === undefined && (missing0 = 'externalID')) ||
                (data.roleName === undefined && (missing0 = 'roleName'))) {
                validate23.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.accountID !== undefined) {
                    let data0 = data.accountID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 12) {
                                validate23.errors = [
                                    {
                                        instancePath: instancePath + '/accountID',
                                        schemaPath: '#/properties/accountID/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 12 },
                                        message: 'must NOT have fewer than 12 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate23.errors = [
                                {
                                    instancePath: instancePath + '/accountID',
                                    schemaPath: '#/properties/accountID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.externalID !== undefined) {
                        let data1 = data.externalID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate23.errors = [
                                        {
                                            instancePath: instancePath + '/externalID',
                                            schemaPath: '#/properties/externalID/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate23.errors = [
                                    {
                                        instancePath: instancePath + '/externalID',
                                        schemaPath: '#/properties/externalID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.roleName !== undefined) {
                            let data2 = data.roleName;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate23.errors = [
                                            {
                                                instancePath: instancePath + '/roleName',
                                                schemaPath: '#/properties/roleName/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate23.errors = [
                                        {
                                            instancePath: instancePath + '/roleName',
                                            schemaPath: '#/properties/roleName/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate23.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate23.errors = vErrors;
    return errors === 0;
}
export const connectionAuthSchemaValidation = validate24;
const schema43 = {
    $id: 'urn:wisepipe-common-connection:ConnectionAuth',
    type: 'object',
    properties: {
        connectionType: {
            type: 'string',
            enum: [
                'google',
                'gsheetsImport',
                'gsheetsExport',
                'shopify',
                'salesForce',
                'postgreSql',
                'icm',
                'tq-postgres',
                'mySql',
                'msSql',
                'oracle',
                'amazonRedshift',
                'amazonAurora',
                'amazonS3',
                'amazonS3Export',
                'tqp',
                'hubspot',
                'symon',
                'snowflake',
                'dynamics',
                'agentSync',
                'workday',
                'workdayRaaS',
                'workdayExport',
                'tableau',
                'sftp',
                'powerbi',
                'rest',
                'gong',
                'netSuite',
                'oneDrive',
                'oneDriveExport',
                'sapSuccessFactors',
                'sapCrm',
                'ukg',
                'oracleHcm',
                'Adp',
                'dynamics365Sales',
                'ceridianDayforce',
                'oracleCrm',
                'oracleErpCloud',
                'sageIntacct',
                'bambooHr',
                'sapErp',
                'googleCloudPlatformCloudStorage',
                'sas',
                'dropbox',
                'googleDrive',
                'jira',
                'monday',
                'zuora',
                'adobeAnalytics',
                'zoomInfo',
                'marketo',
                'activeCampaign',
                'mailchimp',
                'infor',
                'cornerstoneOnDemand',
                'gusto',
                'paychexFlex',
                'zendesk',
                'serviceNow',
                'zohoCrm',
                'pipedrive',
                'quickBooks',
                'xero',
                'freshbooks',
                'zohoBooks',
                'waveFinancial'
            ]
        },
        nonce: { type: 'string', minLength: 1 },
        source: { type: 'string', minLength: 1 }
    },
    required: ['connectionType', 'nonce']
};
function validate24(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:ConnectionAuth" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.connectionType === undefined && (missing0 = 'connectionType')) ||
                (data.nonce === undefined && (missing0 = 'nonce'))) {
                validate24.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.connectionType !== undefined) {
                    let data0 = data.connectionType;
                    const _errs1 = errors;
                    if (typeof data0 !== 'string') {
                        validate24.errors = [
                            {
                                instancePath: instancePath + '/connectionType',
                                schemaPath: '#/properties/connectionType/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'google' ||
                        data0 === 'gsheetsImport' ||
                        data0 === 'gsheetsExport' ||
                        data0 === 'shopify' ||
                        data0 === 'salesForce' ||
                        data0 === 'postgreSql' ||
                        data0 === 'icm' ||
                        data0 === 'tq-postgres' ||
                        data0 === 'mySql' ||
                        data0 === 'msSql' ||
                        data0 === 'oracle' ||
                        data0 === 'amazonRedshift' ||
                        data0 === 'amazonAurora' ||
                        data0 === 'amazonS3' ||
                        data0 === 'amazonS3Export' ||
                        data0 === 'tqp' ||
                        data0 === 'hubspot' ||
                        data0 === 'symon' ||
                        data0 === 'snowflake' ||
                        data0 === 'dynamics' ||
                        data0 === 'agentSync' ||
                        data0 === 'workday' ||
                        data0 === 'workdayRaaS' ||
                        data0 === 'workdayExport' ||
                        data0 === 'tableau' ||
                        data0 === 'sftp' ||
                        data0 === 'powerbi' ||
                        data0 === 'rest' ||
                        data0 === 'gong' ||
                        data0 === 'netSuite' ||
                        data0 === 'oneDrive' ||
                        data0 === 'oneDriveExport' ||
                        data0 === 'sapSuccessFactors' ||
                        data0 === 'sapCrm' ||
                        data0 === 'ukg' ||
                        data0 === 'oracleHcm' ||
                        data0 === 'Adp' ||
                        data0 === 'dynamics365Sales' ||
                        data0 === 'ceridianDayforce' ||
                        data0 === 'oracleCrm' ||
                        data0 === 'oracleErpCloud' ||
                        data0 === 'sageIntacct' ||
                        data0 === 'bambooHr' ||
                        data0 === 'sapErp' ||
                        data0 === 'googleCloudPlatformCloudStorage' ||
                        data0 === 'sas' ||
                        data0 === 'dropbox' ||
                        data0 === 'googleDrive' ||
                        data0 === 'jira' ||
                        data0 === 'monday' ||
                        data0 === 'zuora' ||
                        data0 === 'adobeAnalytics' ||
                        data0 === 'zoomInfo' ||
                        data0 === 'marketo' ||
                        data0 === 'activeCampaign' ||
                        data0 === 'mailchimp' ||
                        data0 === 'infor' ||
                        data0 === 'cornerstoneOnDemand' ||
                        data0 === 'gusto' ||
                        data0 === 'paychexFlex' ||
                        data0 === 'zendesk' ||
                        data0 === 'serviceNow' ||
                        data0 === 'zohoCrm' ||
                        data0 === 'pipedrive' ||
                        data0 === 'quickBooks' ||
                        data0 === 'xero' ||
                        data0 === 'freshbooks' ||
                        data0 === 'zohoBooks' ||
                        data0 === 'waveFinancial')) {
                        validate24.errors = [
                            {
                                instancePath: instancePath + '/connectionType',
                                schemaPath: '#/properties/connectionType/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema43.properties.connectionType.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.nonce !== undefined) {
                        let data1 = data.nonce;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate24.errors = [
                                        {
                                            instancePath: instancePath + '/nonce',
                                            schemaPath: '#/properties/nonce/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate24.errors = [
                                    {
                                        instancePath: instancePath + '/nonce',
                                        schemaPath: '#/properties/nonce/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.source !== undefined) {
                            let data2 = data.source;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate24.errors = [
                                            {
                                                instancePath: instancePath + '/source',
                                                schemaPath: '#/properties/source/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate24.errors = [
                                        {
                                            instancePath: instancePath + '/source',
                                            schemaPath: '#/properties/source/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate24.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate24.errors = vErrors;
    return errors === 0;
}
export const connectionInfoEntrySchemaValidation = validate25;
const schema44 = {
    $id: 'urn:wisepipe-common-connection:ConnectionInfoEntry',
    type: 'object',
    properties: { clientID: { type: 'string', minLength: 1 } },
    required: ['clientID']
};
function validate25(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:ConnectionInfoEntry" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.clientID === undefined && (missing0 = 'clientID')) {
                validate25.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.clientID !== undefined) {
                    let data0 = data.clientID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate25.errors = [
                                    {
                                        instancePath: instancePath + '/clientID',
                                        schemaPath: '#/properties/clientID/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate25.errors = [
                                {
                                    instancePath: instancePath + '/clientID',
                                    schemaPath: '#/properties/clientID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate25.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate25.errors = vErrors;
    return errors === 0;
}
export const connectionInfoSchemaValidation = validate26;
const schema45 = {
    $id: 'urn:wisepipe-common-connection:ConnectionInfo',
    type: 'object',
    properties: {
        google: { $ref: 'urn:wisepipe-common-connection:ConnectionInfoEntry' },
        gsheetsImport: { $ref: 'urn:wisepipe-common-connection:ConnectionInfoEntry' },
        gsheetsExport: { $ref: 'urn:wisepipe-common-connection:ConnectionInfoEntry' },
        shopify: { $ref: 'urn:wisepipe-common-connection:ConnectionInfoEntry' },
        salesForce: { $ref: 'urn:wisepipe-common-connection:ConnectionInfoEntry' },
        hubspot: { $ref: 'urn:wisepipe-common-connection:ConnectionInfoEntry' },
        dynamics: { $ref: 'urn:wisepipe-common-connection:ConnectionInfoEntry' },
        powerbi: { $ref: 'urn:wisepipe-common-connection:ConnectionInfoEntry' },
        tqp: { $ref: 'urn:wisepipe-common-connection:TqpConnectionInfoEntry' },
        onedrive: { $ref: 'urn:wisepipe-common-connection:ConnectionInfoEntry' },
        onedriveExport: { $ref: 'urn:wisepipe-common-connection:ConnectionInfoEntry' }
    },
    required: [
        'google',
        'gsheetsImport',
        'gsheetsExport',
        'shopify',
        'salesForce',
        'hubspot',
        'dynamics',
        'powerbi',
        'tqp',
        'onedrive',
        'onedriveExport'
    ]
};
const schema54 = {
    $id: 'urn:wisepipe-common-connection:TqpConnectionInfoEntry',
    type: 'object',
    properties: { url: { type: 'string', minLength: 1 } },
    required: ['url']
};
function validate26(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:ConnectionInfo" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.google === undefined && (missing0 = 'google')) ||
                (data.gsheetsImport === undefined && (missing0 = 'gsheetsImport')) ||
                (data.gsheetsExport === undefined && (missing0 = 'gsheetsExport')) ||
                (data.shopify === undefined && (missing0 = 'shopify')) ||
                (data.salesForce === undefined && (missing0 = 'salesForce')) ||
                (data.hubspot === undefined && (missing0 = 'hubspot')) ||
                (data.dynamics === undefined && (missing0 = 'dynamics')) ||
                (data.powerbi === undefined && (missing0 = 'powerbi')) ||
                (data.tqp === undefined && (missing0 = 'tqp')) ||
                (data.onedrive === undefined && (missing0 = 'onedrive')) ||
                (data.onedriveExport === undefined && (missing0 = 'onedriveExport'))) {
                validate26.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.google !== undefined) {
                    let data0 = data.google;
                    const _errs1 = errors;
                    const _errs2 = errors;
                    if (errors === _errs2) {
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            let missing1;
                            if (data0.clientID === undefined && (missing1 = 'clientID')) {
                                validate26.errors = [
                                    {
                                        instancePath: instancePath + '/google',
                                        schemaPath: 'urn:wisepipe-common-connection:ConnectionInfoEntry/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing1 },
                                        message: "must have required property '" + missing1 + "'"
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0.clientID !== undefined) {
                                    let data1 = data0.clientID;
                                    const _errs4 = errors;
                                    if (errors === _errs4) {
                                        if (typeof data1 === 'string') {
                                            if (func2(data1) < 1) {
                                                validate26.errors = [
                                                    {
                                                        instancePath: instancePath + '/google/clientID',
                                                        schemaPath: 'urn:wisepipe-common-connection:ConnectionInfoEntry/properties/clientID/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate26.errors = [
                                                {
                                                    instancePath: instancePath + '/google/clientID',
                                                    schemaPath: 'urn:wisepipe-common-connection:ConnectionInfoEntry/properties/clientID/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate26.errors = [
                                {
                                    instancePath: instancePath + '/google',
                                    schemaPath: 'urn:wisepipe-common-connection:ConnectionInfoEntry/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.gsheetsImport !== undefined) {
                        let data2 = data.gsheetsImport;
                        const _errs6 = errors;
                        const _errs7 = errors;
                        if (errors === _errs7) {
                            if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                let missing2;
                                if (data2.clientID === undefined && (missing2 = 'clientID')) {
                                    validate26.errors = [
                                        {
                                            instancePath: instancePath + '/gsheetsImport',
                                            schemaPath: 'urn:wisepipe-common-connection:ConnectionInfoEntry/required',
                                            keyword: 'required',
                                            params: { missingProperty: missing2 },
                                            message: "must have required property '" + missing2 + "'"
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (data2.clientID !== undefined) {
                                        let data3 = data2.clientID;
                                        const _errs9 = errors;
                                        if (errors === _errs9) {
                                            if (typeof data3 === 'string') {
                                                if (func2(data3) < 1) {
                                                    validate26.errors = [
                                                        {
                                                            instancePath: instancePath + '/gsheetsImport/clientID',
                                                            schemaPath: 'urn:wisepipe-common-connection:ConnectionInfoEntry/properties/clientID/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate26.errors = [
                                                    {
                                                        instancePath: instancePath + '/gsheetsImport/clientID',
                                                        schemaPath: 'urn:wisepipe-common-connection:ConnectionInfoEntry/properties/clientID/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                validate26.errors = [
                                    {
                                        instancePath: instancePath + '/gsheetsImport',
                                        schemaPath: 'urn:wisepipe-common-connection:ConnectionInfoEntry/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs6 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.gsheetsExport !== undefined) {
                            let data4 = data.gsheetsExport;
                            const _errs11 = errors;
                            const _errs12 = errors;
                            if (errors === _errs12) {
                                if (data4 && typeof data4 == 'object' && !Array.isArray(data4)) {
                                    let missing3;
                                    if (data4.clientID === undefined && (missing3 = 'clientID')) {
                                        validate26.errors = [
                                            {
                                                instancePath: instancePath + '/gsheetsExport',
                                                schemaPath: 'urn:wisepipe-common-connection:ConnectionInfoEntry/required',
                                                keyword: 'required',
                                                params: { missingProperty: missing3 },
                                                message: "must have required property '" + missing3 + "'"
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        if (data4.clientID !== undefined) {
                                            let data5 = data4.clientID;
                                            const _errs14 = errors;
                                            if (errors === _errs14) {
                                                if (typeof data5 === 'string') {
                                                    if (func2(data5) < 1) {
                                                        validate26.errors = [
                                                            {
                                                                instancePath: instancePath + '/gsheetsExport/clientID',
                                                                schemaPath: 'urn:wisepipe-common-connection:ConnectionInfoEntry/properties/clientID/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate26.errors = [
                                                        {
                                                            instancePath: instancePath + '/gsheetsExport/clientID',
                                                            schemaPath: 'urn:wisepipe-common-connection:ConnectionInfoEntry/properties/clientID/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate26.errors = [
                                        {
                                            instancePath: instancePath + '/gsheetsExport',
                                            schemaPath: 'urn:wisepipe-common-connection:ConnectionInfoEntry/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs11 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.shopify !== undefined) {
                                let data6 = data.shopify;
                                const _errs16 = errors;
                                const _errs17 = errors;
                                if (errors === _errs17) {
                                    if (data6 && typeof data6 == 'object' && !Array.isArray(data6)) {
                                        let missing4;
                                        if (data6.clientID === undefined && (missing4 = 'clientID')) {
                                            validate26.errors = [
                                                {
                                                    instancePath: instancePath + '/shopify',
                                                    schemaPath: 'urn:wisepipe-common-connection:ConnectionInfoEntry/required',
                                                    keyword: 'required',
                                                    params: { missingProperty: missing4 },
                                                    message: "must have required property '" + missing4 + "'"
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            if (data6.clientID !== undefined) {
                                                let data7 = data6.clientID;
                                                const _errs19 = errors;
                                                if (errors === _errs19) {
                                                    if (typeof data7 === 'string') {
                                                        if (func2(data7) < 1) {
                                                            validate26.errors = [
                                                                {
                                                                    instancePath: instancePath + '/shopify/clientID',
                                                                    schemaPath: 'urn:wisepipe-common-connection:ConnectionInfoEntry/properties/clientID/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate26.errors = [
                                                            {
                                                                instancePath: instancePath + '/shopify/clientID',
                                                                schemaPath: 'urn:wisepipe-common-connection:ConnectionInfoEntry/properties/clientID/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate26.errors = [
                                            {
                                                instancePath: instancePath + '/shopify',
                                                schemaPath: 'urn:wisepipe-common-connection:ConnectionInfoEntry/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs16 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.salesForce !== undefined) {
                                    let data8 = data.salesForce;
                                    const _errs21 = errors;
                                    const _errs22 = errors;
                                    if (errors === _errs22) {
                                        if (data8 && typeof data8 == 'object' && !Array.isArray(data8)) {
                                            let missing5;
                                            if (data8.clientID === undefined && (missing5 = 'clientID')) {
                                                validate26.errors = [
                                                    {
                                                        instancePath: instancePath + '/salesForce',
                                                        schemaPath: 'urn:wisepipe-common-connection:ConnectionInfoEntry/required',
                                                        keyword: 'required',
                                                        params: { missingProperty: missing5 },
                                                        message: "must have required property '" + missing5 + "'"
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (data8.clientID !== undefined) {
                                                    let data9 = data8.clientID;
                                                    const _errs24 = errors;
                                                    if (errors === _errs24) {
                                                        if (typeof data9 === 'string') {
                                                            if (func2(data9) < 1) {
                                                                validate26.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/salesForce/clientID',
                                                                        schemaPath: 'urn:wisepipe-common-connection:ConnectionInfoEntry/properties/clientID/minLength',
                                                                        keyword: 'minLength',
                                                                        params: { limit: 1 },
                                                                        message: 'must NOT have fewer than 1 characters'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate26.errors = [
                                                                {
                                                                    instancePath: instancePath + '/salesForce/clientID',
                                                                    schemaPath: 'urn:wisepipe-common-connection:ConnectionInfoEntry/properties/clientID/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate26.errors = [
                                                {
                                                    instancePath: instancePath + '/salesForce',
                                                    schemaPath: 'urn:wisepipe-common-connection:ConnectionInfoEntry/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs21 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.hubspot !== undefined) {
                                        let data10 = data.hubspot;
                                        const _errs26 = errors;
                                        const _errs27 = errors;
                                        if (errors === _errs27) {
                                            if (data10 && typeof data10 == 'object' && !Array.isArray(data10)) {
                                                let missing6;
                                                if (data10.clientID === undefined && (missing6 = 'clientID')) {
                                                    validate26.errors = [
                                                        {
                                                            instancePath: instancePath + '/hubspot',
                                                            schemaPath: 'urn:wisepipe-common-connection:ConnectionInfoEntry/required',
                                                            keyword: 'required',
                                                            params: { missingProperty: missing6 },
                                                            message: "must have required property '" + missing6 + "'"
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    if (data10.clientID !== undefined) {
                                                        let data11 = data10.clientID;
                                                        const _errs29 = errors;
                                                        if (errors === _errs29) {
                                                            if (typeof data11 === 'string') {
                                                                if (func2(data11) < 1) {
                                                                    validate26.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/hubspot/clientID',
                                                                            schemaPath: 'urn:wisepipe-common-connection:ConnectionInfoEntry/properties/clientID/minLength',
                                                                            keyword: 'minLength',
                                                                            params: { limit: 1 },
                                                                            message: 'must NOT have fewer than 1 characters'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            else {
                                                                validate26.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/hubspot/clientID',
                                                                        schemaPath: 'urn:wisepipe-common-connection:ConnectionInfoEntry/properties/clientID/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate26.errors = [
                                                    {
                                                        instancePath: instancePath + '/hubspot',
                                                        schemaPath: 'urn:wisepipe-common-connection:ConnectionInfoEntry/type',
                                                        keyword: 'type',
                                                        params: { type: 'object' },
                                                        message: 'must be object'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs26 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.dynamics !== undefined) {
                                            let data12 = data.dynamics;
                                            const _errs31 = errors;
                                            const _errs32 = errors;
                                            if (errors === _errs32) {
                                                if (data12 && typeof data12 == 'object' && !Array.isArray(data12)) {
                                                    let missing7;
                                                    if (data12.clientID === undefined && (missing7 = 'clientID')) {
                                                        validate26.errors = [
                                                            {
                                                                instancePath: instancePath + '/dynamics',
                                                                schemaPath: 'urn:wisepipe-common-connection:ConnectionInfoEntry/required',
                                                                keyword: 'required',
                                                                params: { missingProperty: missing7 },
                                                                message: "must have required property '" + missing7 + "'"
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        if (data12.clientID !== undefined) {
                                                            let data13 = data12.clientID;
                                                            const _errs34 = errors;
                                                            if (errors === _errs34) {
                                                                if (typeof data13 === 'string') {
                                                                    if (func2(data13) < 1) {
                                                                        validate26.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/dynamics/clientID',
                                                                                schemaPath: 'urn:wisepipe-common-connection:ConnectionInfoEntry/properties/clientID/minLength',
                                                                                keyword: 'minLength',
                                                                                params: { limit: 1 },
                                                                                message: 'must NOT have fewer than 1 characters'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                else {
                                                                    validate26.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/dynamics/clientID',
                                                                            schemaPath: 'urn:wisepipe-common-connection:ConnectionInfoEntry/properties/clientID/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate26.errors = [
                                                        {
                                                            instancePath: instancePath + '/dynamics',
                                                            schemaPath: 'urn:wisepipe-common-connection:ConnectionInfoEntry/type',
                                                            keyword: 'type',
                                                            params: { type: 'object' },
                                                            message: 'must be object'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs31 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.powerbi !== undefined) {
                                                let data14 = data.powerbi;
                                                const _errs36 = errors;
                                                const _errs37 = errors;
                                                if (errors === _errs37) {
                                                    if (data14 && typeof data14 == 'object' && !Array.isArray(data14)) {
                                                        let missing8;
                                                        if (data14.clientID === undefined && (missing8 = 'clientID')) {
                                                            validate26.errors = [
                                                                {
                                                                    instancePath: instancePath + '/powerbi',
                                                                    schemaPath: 'urn:wisepipe-common-connection:ConnectionInfoEntry/required',
                                                                    keyword: 'required',
                                                                    params: { missingProperty: missing8 },
                                                                    message: "must have required property '" + missing8 + "'"
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            if (data14.clientID !== undefined) {
                                                                let data15 = data14.clientID;
                                                                const _errs39 = errors;
                                                                if (errors === _errs39) {
                                                                    if (typeof data15 === 'string') {
                                                                        if (func2(data15) < 1) {
                                                                            validate26.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/powerbi/clientID',
                                                                                    schemaPath: 'urn:wisepipe-common-connection:ConnectionInfoEntry/properties/clientID/minLength',
                                                                                    keyword: 'minLength',
                                                                                    params: { limit: 1 },
                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate26.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/powerbi/clientID',
                                                                                schemaPath: 'urn:wisepipe-common-connection:ConnectionInfoEntry/properties/clientID/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate26.errors = [
                                                            {
                                                                instancePath: instancePath + '/powerbi',
                                                                schemaPath: 'urn:wisepipe-common-connection:ConnectionInfoEntry/type',
                                                                keyword: 'type',
                                                                params: { type: 'object' },
                                                                message: 'must be object'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid0 = _errs36 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.tqp !== undefined) {
                                                    let data16 = data.tqp;
                                                    const _errs41 = errors;
                                                    const _errs42 = errors;
                                                    if (errors === _errs42) {
                                                        if (data16 && typeof data16 == 'object' && !Array.isArray(data16)) {
                                                            let missing9;
                                                            if (data16.url === undefined && (missing9 = 'url')) {
                                                                validate26.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/tqp',
                                                                        schemaPath: 'urn:wisepipe-common-connection:TqpConnectionInfoEntry/required',
                                                                        keyword: 'required',
                                                                        params: { missingProperty: missing9 },
                                                                        message: "must have required property '" + missing9 + "'"
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                if (data16.url !== undefined) {
                                                                    let data17 = data16.url;
                                                                    const _errs44 = errors;
                                                                    if (errors === _errs44) {
                                                                        if (typeof data17 === 'string') {
                                                                            if (func2(data17) < 1) {
                                                                                validate26.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/tqp/url',
                                                                                        schemaPath: 'urn:wisepipe-common-connection:TqpConnectionInfoEntry/properties/url/minLength',
                                                                                        keyword: 'minLength',
                                                                                        params: { limit: 1 },
                                                                                        message: 'must NOT have fewer than 1 characters'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        else {
                                                                            validate26.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/tqp/url',
                                                                                    schemaPath: 'urn:wisepipe-common-connection:TqpConnectionInfoEntry/properties/url/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                        else {
                                                            validate26.errors = [
                                                                {
                                                                    instancePath: instancePath + '/tqp',
                                                                    schemaPath: 'urn:wisepipe-common-connection:TqpConnectionInfoEntry/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'object' },
                                                                    message: 'must be object'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid0 = _errs41 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                                if (valid0) {
                                                    if (data.onedrive !== undefined) {
                                                        let data18 = data.onedrive;
                                                        const _errs46 = errors;
                                                        const _errs47 = errors;
                                                        if (errors === _errs47) {
                                                            if (data18 && typeof data18 == 'object' && !Array.isArray(data18)) {
                                                                let missing10;
                                                                if (data18.clientID === undefined && (missing10 = 'clientID')) {
                                                                    validate26.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/onedrive',
                                                                            schemaPath: 'urn:wisepipe-common-connection:ConnectionInfoEntry/required',
                                                                            keyword: 'required',
                                                                            params: { missingProperty: missing10 },
                                                                            message: "must have required property '" + missing10 + "'"
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                else {
                                                                    if (data18.clientID !== undefined) {
                                                                        let data19 = data18.clientID;
                                                                        const _errs49 = errors;
                                                                        if (errors === _errs49) {
                                                                            if (typeof data19 === 'string') {
                                                                                if (func2(data19) < 1) {
                                                                                    validate26.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/onedrive/clientID',
                                                                                            schemaPath: 'urn:wisepipe-common-connection:ConnectionInfoEntry/properties/clientID/minLength',
                                                                                            keyword: 'minLength',
                                                                                            params: { limit: 1 },
                                                                                            message: 'must NOT have fewer than 1 characters'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            else {
                                                                                validate26.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/onedrive/clientID',
                                                                                        schemaPath: 'urn:wisepipe-common-connection:ConnectionInfoEntry/properties/clientID/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                            else {
                                                                validate26.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/onedrive',
                                                                        schemaPath: 'urn:wisepipe-common-connection:ConnectionInfoEntry/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'object' },
                                                                        message: 'must be object'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid0 = _errs46 === errors;
                                                    }
                                                    else {
                                                        var valid0 = true;
                                                    }
                                                    if (valid0) {
                                                        if (data.onedriveExport !== undefined) {
                                                            let data20 = data.onedriveExport;
                                                            const _errs51 = errors;
                                                            const _errs52 = errors;
                                                            if (errors === _errs52) {
                                                                if (data20 && typeof data20 == 'object' && !Array.isArray(data20)) {
                                                                    let missing11;
                                                                    if (data20.clientID === undefined && (missing11 = 'clientID')) {
                                                                        validate26.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/onedriveExport',
                                                                                schemaPath: 'urn:wisepipe-common-connection:ConnectionInfoEntry/required',
                                                                                keyword: 'required',
                                                                                params: { missingProperty: missing11 },
                                                                                message: "must have required property '" + missing11 + "'"
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    else {
                                                                        if (data20.clientID !== undefined) {
                                                                            let data21 = data20.clientID;
                                                                            const _errs54 = errors;
                                                                            if (errors === _errs54) {
                                                                                if (typeof data21 === 'string') {
                                                                                    if (func2(data21) < 1) {
                                                                                        validate26.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/onedriveExport/clientID',
                                                                                                schemaPath: 'urn:wisepipe-common-connection:ConnectionInfoEntry/properties/clientID/minLength',
                                                                                                keyword: 'minLength',
                                                                                                params: { limit: 1 },
                                                                                                message: 'must NOT have fewer than 1 characters'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    validate26.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/onedriveExport/clientID',
                                                                                            schemaPath: 'urn:wisepipe-common-connection:ConnectionInfoEntry/properties/clientID/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'string' },
                                                                                            message: 'must be string'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                                else {
                                                                    validate26.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/onedriveExport',
                                                                            schemaPath: 'urn:wisepipe-common-connection:ConnectionInfoEntry/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'object' },
                                                                            message: 'must be object'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid0 = _errs51 === errors;
                                                        }
                                                        else {
                                                            var valid0 = true;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate26.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate26.errors = vErrors;
    return errors === 0;
}
export const connectionSchemaValidation = validate27;
const schema57 = {
    $id: 'urn:wisepipe-common-connection:Connection',
    type: 'object',
    properties: {
        connectionID: { type: 'string', uid: 9 },
        connectionType: {
            type: 'string',
            enum: [
                'google',
                'gsheetsImport',
                'gsheetsExport',
                'shopify',
                'salesForce',
                'postgreSql',
                'icm',
                'tq-postgres',
                'mySql',
                'msSql',
                'oracle',
                'amazonRedshift',
                'amazonAurora',
                'amazonS3',
                'amazonS3Export',
                'tqp',
                'hubspot',
                'symon',
                'snowflake',
                'dynamics',
                'agentSync',
                'workday',
                'workdayRaaS',
                'workdayExport',
                'tableau',
                'sftp',
                'powerbi',
                'rest',
                'gong',
                'netSuite',
                'oneDrive',
                'oneDriveExport',
                'sapSuccessFactors',
                'sapCrm',
                'ukg',
                'oracleHcm',
                'Adp',
                'dynamics365Sales',
                'ceridianDayforce',
                'oracleCrm',
                'oracleErpCloud',
                'sageIntacct',
                'bambooHr',
                'sapErp',
                'googleCloudPlatformCloudStorage',
                'sas',
                'dropbox',
                'googleDrive',
                'jira',
                'monday',
                'zuora',
                'adobeAnalytics',
                'zoomInfo',
                'marketo',
                'activeCampaign',
                'mailchimp',
                'infor',
                'cornerstoneOnDemand',
                'gusto',
                'paychexFlex',
                'zendesk',
                'serviceNow',
                'zohoCrm',
                'pipedrive',
                'quickBooks',
                'xero',
                'freshbooks',
                'zohoBooks',
                'waveFinancial'
            ]
        },
        name: { type: 'string', minLength: 1 },
        source: { type: 'string', minLength: 1 },
        failedOnLastTry: { type: 'boolean' },
        isDiscoveryFail: { type: 'boolean' },
        verificationErrorMessage: { type: 'string' }
    },
    required: ['connectionType', 'name']
};
const func28 = ucs2length;
const func29 = base64urlToBuffer;
const func30 = base64urlEncode;
const func31 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate27(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:Connection" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.connectionType === undefined && (missing0 = 'connectionType')) ||
                (data.name === undefined && (missing0 = 'name'))) {
                validate27.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.connectionID !== undefined) {
                    let data0 = data.connectionID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 9) / 3);
                            const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                            if (func28(data0) < b64min0 || func28(data0) > b64max0) {
                                validate27.errors = [
                                    {
                                        instancePath: instancePath + '/connectionID',
                                        schemaPath: '#/properties/connectionID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func28(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func28(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func29(data0);
                                if (decoded0.length !== 9) {
                                    validate27.errors = [
                                        {
                                            instancePath: instancePath + '/connectionID',
                                            schemaPath: '#/properties/connectionID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 9 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func30(decoded0);
                                    if (func31(encoded0) !== func31(data0)) {
                                        validate27.errors = [
                                            {
                                                instancePath: instancePath + '/connectionID',
                                                schemaPath: '#/properties/connectionID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate27.errors = [
                                {
                                    instancePath: instancePath + '/connectionID',
                                    schemaPath: '#/properties/connectionID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.connectionType !== undefined) {
                        let data1 = data.connectionType;
                        const _errs3 = errors;
                        if (typeof data1 !== 'string') {
                            validate27.errors = [
                                {
                                    instancePath: instancePath + '/connectionType',
                                    schemaPath: '#/properties/connectionType/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data1 === 'google' ||
                            data1 === 'gsheetsImport' ||
                            data1 === 'gsheetsExport' ||
                            data1 === 'shopify' ||
                            data1 === 'salesForce' ||
                            data1 === 'postgreSql' ||
                            data1 === 'icm' ||
                            data1 === 'tq-postgres' ||
                            data1 === 'mySql' ||
                            data1 === 'msSql' ||
                            data1 === 'oracle' ||
                            data1 === 'amazonRedshift' ||
                            data1 === 'amazonAurora' ||
                            data1 === 'amazonS3' ||
                            data1 === 'amazonS3Export' ||
                            data1 === 'tqp' ||
                            data1 === 'hubspot' ||
                            data1 === 'symon' ||
                            data1 === 'snowflake' ||
                            data1 === 'dynamics' ||
                            data1 === 'agentSync' ||
                            data1 === 'workday' ||
                            data1 === 'workdayRaaS' ||
                            data1 === 'workdayExport' ||
                            data1 === 'tableau' ||
                            data1 === 'sftp' ||
                            data1 === 'powerbi' ||
                            data1 === 'rest' ||
                            data1 === 'gong' ||
                            data1 === 'netSuite' ||
                            data1 === 'oneDrive' ||
                            data1 === 'oneDriveExport' ||
                            data1 === 'sapSuccessFactors' ||
                            data1 === 'sapCrm' ||
                            data1 === 'ukg' ||
                            data1 === 'oracleHcm' ||
                            data1 === 'Adp' ||
                            data1 === 'dynamics365Sales' ||
                            data1 === 'ceridianDayforce' ||
                            data1 === 'oracleCrm' ||
                            data1 === 'oracleErpCloud' ||
                            data1 === 'sageIntacct' ||
                            data1 === 'bambooHr' ||
                            data1 === 'sapErp' ||
                            data1 === 'googleCloudPlatformCloudStorage' ||
                            data1 === 'sas' ||
                            data1 === 'dropbox' ||
                            data1 === 'googleDrive' ||
                            data1 === 'jira' ||
                            data1 === 'monday' ||
                            data1 === 'zuora' ||
                            data1 === 'adobeAnalytics' ||
                            data1 === 'zoomInfo' ||
                            data1 === 'marketo' ||
                            data1 === 'activeCampaign' ||
                            data1 === 'mailchimp' ||
                            data1 === 'infor' ||
                            data1 === 'cornerstoneOnDemand' ||
                            data1 === 'gusto' ||
                            data1 === 'paychexFlex' ||
                            data1 === 'zendesk' ||
                            data1 === 'serviceNow' ||
                            data1 === 'zohoCrm' ||
                            data1 === 'pipedrive' ||
                            data1 === 'quickBooks' ||
                            data1 === 'xero' ||
                            data1 === 'freshbooks' ||
                            data1 === 'zohoBooks' ||
                            data1 === 'waveFinancial')) {
                            validate27.errors = [
                                {
                                    instancePath: instancePath + '/connectionType',
                                    schemaPath: '#/properties/connectionType/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema57.properties.connectionType.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.name !== undefined) {
                            let data2 = data.name;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate27.errors = [
                                            {
                                                instancePath: instancePath + '/name',
                                                schemaPath: '#/properties/name/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate27.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.source !== undefined) {
                                let data3 = data.source;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 === 'string') {
                                        if (func2(data3) < 1) {
                                            validate27.errors = [
                                                {
                                                    instancePath: instancePath + '/source',
                                                    schemaPath: '#/properties/source/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate27.errors = [
                                            {
                                                instancePath: instancePath + '/source',
                                                schemaPath: '#/properties/source/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.failedOnLastTry !== undefined) {
                                    const _errs9 = errors;
                                    if (typeof data.failedOnLastTry !== 'boolean') {
                                        validate27.errors = [
                                            {
                                                instancePath: instancePath + '/failedOnLastTry',
                                                schemaPath: '#/properties/failedOnLastTry/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.isDiscoveryFail !== undefined) {
                                        const _errs11 = errors;
                                        if (typeof data.isDiscoveryFail !== 'boolean') {
                                            validate27.errors = [
                                                {
                                                    instancePath: instancePath + '/isDiscoveryFail',
                                                    schemaPath: '#/properties/isDiscoveryFail/type',
                                                    keyword: 'type',
                                                    params: { type: 'boolean' },
                                                    message: 'must be boolean'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.verificationErrorMessage !== undefined) {
                                            const _errs13 = errors;
                                            if (typeof data.verificationErrorMessage !== 'string') {
                                                validate27.errors = [
                                                    {
                                                        instancePath: instancePath + '/verificationErrorMessage',
                                                        schemaPath: '#/properties/verificationErrorMessage/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid0 = _errs13 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate27.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate27.errors = vErrors;
    return errors === 0;
}
export const databaseAuthSchemaValidation = validate28;
const schema58 = {
    $id: 'urn:wisepipe-common-connection:DatabaseAuth',
    type: 'object',
    properties: {
        host: { type: 'string', minLength: 1 },
        port: { type: 'number', minimum: 0 },
        database: { type: 'string', minLength: 1 },
        userPassword: { $ref: 'urn:wisepipe-common-connection:UserPassword' }
    },
    required: ['host', 'port', 'database', 'userPassword']
};
const schema59 = {
    $id: 'urn:wisepipe-common-connection:UserPassword',
    type: 'object',
    properties: { user: { type: 'string', minLength: 1 }, password: { type: 'string', minLength: 1 } },
    required: ['user', 'password']
};
function validate28(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:DatabaseAuth" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.host === undefined && (missing0 = 'host')) ||
                (data.port === undefined && (missing0 = 'port')) ||
                (data.database === undefined && (missing0 = 'database')) ||
                (data.userPassword === undefined && (missing0 = 'userPassword'))) {
                validate28.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.host !== undefined) {
                    let data0 = data.host;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate28.errors = [
                                    {
                                        instancePath: instancePath + '/host',
                                        schemaPath: '#/properties/host/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate28.errors = [
                                {
                                    instancePath: instancePath + '/host',
                                    schemaPath: '#/properties/host/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.port !== undefined) {
                        let data1 = data.port;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 == 'number') {
                                if (data1 < 0 || isNaN(data1)) {
                                    validate28.errors = [
                                        {
                                            instancePath: instancePath + '/port',
                                            schemaPath: '#/properties/port/minimum',
                                            keyword: 'minimum',
                                            params: { comparison: '>=', limit: 0 },
                                            message: 'must be >= 0'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate28.errors = [
                                    {
                                        instancePath: instancePath + '/port',
                                        schemaPath: '#/properties/port/type',
                                        keyword: 'type',
                                        params: { type: 'number' },
                                        message: 'must be number'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.database !== undefined) {
                            let data2 = data.database;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate28.errors = [
                                            {
                                                instancePath: instancePath + '/database',
                                                schemaPath: '#/properties/database/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate28.errors = [
                                        {
                                            instancePath: instancePath + '/database',
                                            schemaPath: '#/properties/database/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.userPassword !== undefined) {
                                let data3 = data.userPassword;
                                const _errs7 = errors;
                                const _errs8 = errors;
                                if (errors === _errs8) {
                                    if (data3 && typeof data3 == 'object' && !Array.isArray(data3)) {
                                        let missing1;
                                        if ((data3.user === undefined && (missing1 = 'user')) ||
                                            (data3.password === undefined && (missing1 = 'password'))) {
                                            validate28.errors = [
                                                {
                                                    instancePath: instancePath + '/userPassword',
                                                    schemaPath: 'urn:wisepipe-common-connection:UserPassword/required',
                                                    keyword: 'required',
                                                    params: { missingProperty: missing1 },
                                                    message: "must have required property '" + missing1 + "'"
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            if (data3.user !== undefined) {
                                                let data4 = data3.user;
                                                const _errs10 = errors;
                                                if (errors === _errs10) {
                                                    if (typeof data4 === 'string') {
                                                        if (func2(data4) < 1) {
                                                            validate28.errors = [
                                                                {
                                                                    instancePath: instancePath + '/userPassword/user',
                                                                    schemaPath: 'urn:wisepipe-common-connection:UserPassword/properties/user/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate28.errors = [
                                                            {
                                                                instancePath: instancePath + '/userPassword/user',
                                                                schemaPath: 'urn:wisepipe-common-connection:UserPassword/properties/user/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid2 = _errs10 === errors;
                                            }
                                            else {
                                                var valid2 = true;
                                            }
                                            if (valid2) {
                                                if (data3.password !== undefined) {
                                                    let data5 = data3.password;
                                                    const _errs12 = errors;
                                                    if (errors === _errs12) {
                                                        if (typeof data5 === 'string') {
                                                            if (func2(data5) < 1) {
                                                                validate28.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/userPassword/password',
                                                                        schemaPath: 'urn:wisepipe-common-connection:UserPassword/properties/password/minLength',
                                                                        keyword: 'minLength',
                                                                        params: { limit: 1 },
                                                                        message: 'must NOT have fewer than 1 characters'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate28.errors = [
                                                                {
                                                                    instancePath: instancePath + '/userPassword/password',
                                                                    schemaPath: 'urn:wisepipe-common-connection:UserPassword/properties/password/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid2 = _errs12 === errors;
                                                }
                                                else {
                                                    var valid2 = true;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate28.errors = [
                                            {
                                                instancePath: instancePath + '/userPassword',
                                                schemaPath: 'urn:wisepipe-common-connection:UserPassword/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate28.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate28.errors = vErrors;
    return errors === 0;
}
export const databaseConnectionSchemaValidation = validate29;
const schema60 = {
    $id: 'urn:wisepipe-common-connection:DatabaseConnection',
    type: 'object',
    properties: {
        host: { type: 'string', minLength: 1 },
        port: { type: 'number', minimum: 0 },
        database: { type: 'string', minLength: 1 }
    },
    required: ['host', 'port', 'database']
};
function validate29(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:DatabaseConnection" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.host === undefined && (missing0 = 'host')) ||
                (data.port === undefined && (missing0 = 'port')) ||
                (data.database === undefined && (missing0 = 'database'))) {
                validate29.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.host !== undefined) {
                    let data0 = data.host;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate29.errors = [
                                    {
                                        instancePath: instancePath + '/host',
                                        schemaPath: '#/properties/host/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate29.errors = [
                                {
                                    instancePath: instancePath + '/host',
                                    schemaPath: '#/properties/host/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.port !== undefined) {
                        let data1 = data.port;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 == 'number') {
                                if (data1 < 0 || isNaN(data1)) {
                                    validate29.errors = [
                                        {
                                            instancePath: instancePath + '/port',
                                            schemaPath: '#/properties/port/minimum',
                                            keyword: 'minimum',
                                            params: { comparison: '>=', limit: 0 },
                                            message: 'must be >= 0'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate29.errors = [
                                    {
                                        instancePath: instancePath + '/port',
                                        schemaPath: '#/properties/port/type',
                                        keyword: 'type',
                                        params: { type: 'number' },
                                        message: 'must be number'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.database !== undefined) {
                            let data2 = data.database;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate29.errors = [
                                            {
                                                instancePath: instancePath + '/database',
                                                schemaPath: '#/properties/database/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate29.errors = [
                                        {
                                            instancePath: instancePath + '/database',
                                            schemaPath: '#/properties/database/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate29.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate29.errors = vErrors;
    return errors === 0;
}
export const dynamicsAuthSchemaValidation = validate30;
const schema61 = {
    $id: 'urn:wisepipe-common-connection:DynamicsAuth',
    type: 'object',
    properties: {
        code: { type: 'string', minLength: 1 },
        redirectUri: { type: 'string', format: 'uri' },
        instanceUri: { type: 'string', format: 'uri' }
    },
    required: ['code', 'redirectUri', 'instanceUri']
};
const formats0 = formatWrapper.uri;
function validate30(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:DynamicsAuth" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.code === undefined && (missing0 = 'code')) ||
                (data.redirectUri === undefined && (missing0 = 'redirectUri')) ||
                (data.instanceUri === undefined && (missing0 = 'instanceUri'))) {
                validate30.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.code !== undefined) {
                    let data0 = data.code;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate30.errors = [
                                    {
                                        instancePath: instancePath + '/code',
                                        schemaPath: '#/properties/code/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate30.errors = [
                                {
                                    instancePath: instancePath + '/code',
                                    schemaPath: '#/properties/code/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.redirectUri !== undefined) {
                        let data1 = data.redirectUri;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (errors === _errs3) {
                                if (typeof data1 === 'string') {
                                    if (!formats0(data1)) {
                                        validate30.errors = [
                                            {
                                                instancePath: instancePath + '/redirectUri',
                                                schemaPath: '#/properties/redirectUri/format',
                                                keyword: 'format',
                                                params: { format: 'uri' },
                                                message: 'must match format "' + 'uri' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate30.errors = [
                                        {
                                            instancePath: instancePath + '/redirectUri',
                                            schemaPath: '#/properties/redirectUri/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.instanceUri !== undefined) {
                            let data2 = data.instanceUri;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (errors === _errs5) {
                                    if (typeof data2 === 'string') {
                                        if (!formats0(data2)) {
                                            validate30.errors = [
                                                {
                                                    instancePath: instancePath + '/instanceUri',
                                                    schemaPath: '#/properties/instanceUri/format',
                                                    keyword: 'format',
                                                    params: { format: 'uri' },
                                                    message: 'must match format "' + 'uri' + '"'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate30.errors = [
                                            {
                                                instancePath: instancePath + '/instanceUri',
                                                schemaPath: '#/properties/instanceUri/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate30.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate30.errors = vErrors;
    return errors === 0;
}
export const dynamicsConnectionSchemaValidation = validate31;
const schema62 = {
    $id: 'urn:wisepipe-common-connection:DynamicsConnection',
    type: 'object',
    properties: { instanceUri: { type: 'string', minLength: 1 } },
    required: ['instanceUri']
};
function validate31(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:DynamicsConnection" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.instanceUri === undefined && (missing0 = 'instanceUri')) {
                validate31.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.instanceUri !== undefined) {
                    let data0 = data.instanceUri;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate31.errors = [
                                    {
                                        instancePath: instancePath + '/instanceUri',
                                        schemaPath: '#/properties/instanceUri/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate31.errors = [
                                {
                                    instancePath: instancePath + '/instanceUri',
                                    schemaPath: '#/properties/instanceUri/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate31.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate31.errors = vErrors;
    return errors === 0;
}
export const gSheetsExportAuthSchemaValidation = validate32;
const schema63 = {
    $id: 'urn:wisepipe-common-connection:GSheetsExportAuth',
    type: 'object',
    properties: { code: { type: 'string', minLength: 1 }, redirectUri: { type: 'string', format: 'uri' } },
    required: ['code', 'redirectUri']
};
function validate32(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:GSheetsExportAuth" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.code === undefined && (missing0 = 'code')) ||
                (data.redirectUri === undefined && (missing0 = 'redirectUri'))) {
                validate32.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.code !== undefined) {
                    let data0 = data.code;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate32.errors = [
                                    {
                                        instancePath: instancePath + '/code',
                                        schemaPath: '#/properties/code/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate32.errors = [
                                {
                                    instancePath: instancePath + '/code',
                                    schemaPath: '#/properties/code/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.redirectUri !== undefined) {
                        let data1 = data.redirectUri;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (errors === _errs3) {
                                if (typeof data1 === 'string') {
                                    if (!formats0(data1)) {
                                        validate32.errors = [
                                            {
                                                instancePath: instancePath + '/redirectUri',
                                                schemaPath: '#/properties/redirectUri/format',
                                                keyword: 'format',
                                                params: { format: 'uri' },
                                                message: 'must match format "' + 'uri' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate32.errors = [
                                        {
                                            instancePath: instancePath + '/redirectUri',
                                            schemaPath: '#/properties/redirectUri/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate32.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate32.errors = vErrors;
    return errors === 0;
}
export const gSheetsExportConnectionSchemaValidation = validate33;
const schema64 = {
    $id: 'urn:wisepipe-common-connection:GSheetsExportConnection',
    type: 'object',
    properties: {},
    required: []
};
function validate33(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:GSheetsExportConnection" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate33.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate33.errors = vErrors;
    return errors === 0;
}
export const gSheetsImportAuthSchemaValidation = validate34;
const schema65 = {
    $id: 'urn:wisepipe-common-connection:GSheetsImportAuth',
    type: 'object',
    properties: { code: { type: 'string', minLength: 1 }, redirectUri: { type: 'string', format: 'uri' } },
    required: ['code', 'redirectUri']
};
function validate34(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:GSheetsImportAuth" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.code === undefined && (missing0 = 'code')) ||
                (data.redirectUri === undefined && (missing0 = 'redirectUri'))) {
                validate34.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.code !== undefined) {
                    let data0 = data.code;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate34.errors = [
                                    {
                                        instancePath: instancePath + '/code',
                                        schemaPath: '#/properties/code/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate34.errors = [
                                {
                                    instancePath: instancePath + '/code',
                                    schemaPath: '#/properties/code/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.redirectUri !== undefined) {
                        let data1 = data.redirectUri;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (errors === _errs3) {
                                if (typeof data1 === 'string') {
                                    if (!formats0(data1)) {
                                        validate34.errors = [
                                            {
                                                instancePath: instancePath + '/redirectUri',
                                                schemaPath: '#/properties/redirectUri/format',
                                                keyword: 'format',
                                                params: { format: 'uri' },
                                                message: 'must match format "' + 'uri' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate34.errors = [
                                        {
                                            instancePath: instancePath + '/redirectUri',
                                            schemaPath: '#/properties/redirectUri/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate34.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate34.errors = vErrors;
    return errors === 0;
}
export const gSheetsImportConnectionSchemaValidation = validate35;
const schema66 = {
    $id: 'urn:wisepipe-common-connection:GSheetsImportConnection',
    type: 'object',
    properties: {},
    required: []
};
function validate35(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:GSheetsImportConnection" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate35.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate35.errors = vErrors;
    return errors === 0;
}
export const gongAuthSchemaValidation = validate36;
const schema67 = {
    $id: 'urn:wisepipe-common-connection:GongAuth',
    type: 'object',
    properties: { apiKey: { $ref: 'urn:wisepipe-common-connection:ApiKey' } },
    required: ['apiKey']
};
function validate36(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:GongAuth" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.apiKey === undefined && (missing0 = 'apiKey')) {
                validate36.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.apiKey !== undefined) {
                    let data0 = data.apiKey;
                    const _errs2 = errors;
                    if (errors === _errs2) {
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            let missing1;
                            if (data0.value === undefined && (missing1 = 'value')) {
                                validate36.errors = [
                                    {
                                        instancePath: instancePath + '/apiKey',
                                        schemaPath: 'urn:wisepipe-common-connection:ApiKey/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing1 },
                                        message: "must have required property '" + missing1 + "'"
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0.value !== undefined) {
                                    let data1 = data0.value;
                                    const _errs4 = errors;
                                    if (errors === _errs4) {
                                        if (typeof data1 === 'string') {
                                            if (func2(data1) < 1) {
                                                validate36.errors = [
                                                    {
                                                        instancePath: instancePath + '/apiKey/value',
                                                        schemaPath: 'urn:wisepipe-common-connection:ApiKey/properties/value/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate36.errors = [
                                                {
                                                    instancePath: instancePath + '/apiKey/value',
                                                    schemaPath: 'urn:wisepipe-common-connection:ApiKey/properties/value/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate36.errors = [
                                {
                                    instancePath: instancePath + '/apiKey',
                                    schemaPath: 'urn:wisepipe-common-connection:ApiKey/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate36.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate36.errors = vErrors;
    return errors === 0;
}
export const gongConnectionSchemaValidation = validate37;
const schema69 = { $id: 'urn:wisepipe-common-connection:GongConnection', type: 'object', properties: {}, required: [] };
function validate37(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:GongConnection" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate37.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate37.errors = vErrors;
    return errors === 0;
}
export const googleAuthSchemaValidation = validate38;
const schema70 = {
    $id: 'urn:wisepipe-common-connection:GoogleAuth',
    type: 'object',
    properties: { code: { type: 'string', minLength: 1 }, redirectUri: { type: 'string', format: 'uri' } },
    required: ['code', 'redirectUri']
};
function validate38(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:GoogleAuth" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.code === undefined && (missing0 = 'code')) ||
                (data.redirectUri === undefined && (missing0 = 'redirectUri'))) {
                validate38.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.code !== undefined) {
                    let data0 = data.code;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate38.errors = [
                                    {
                                        instancePath: instancePath + '/code',
                                        schemaPath: '#/properties/code/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate38.errors = [
                                {
                                    instancePath: instancePath + '/code',
                                    schemaPath: '#/properties/code/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.redirectUri !== undefined) {
                        let data1 = data.redirectUri;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (errors === _errs3) {
                                if (typeof data1 === 'string') {
                                    if (!formats0(data1)) {
                                        validate38.errors = [
                                            {
                                                instancePath: instancePath + '/redirectUri',
                                                schemaPath: '#/properties/redirectUri/format',
                                                keyword: 'format',
                                                params: { format: 'uri' },
                                                message: 'must match format "' + 'uri' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate38.errors = [
                                        {
                                            instancePath: instancePath + '/redirectUri',
                                            schemaPath: '#/properties/redirectUri/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate38.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate38.errors = vErrors;
    return errors === 0;
}
export const googleConnectionSchemaValidation = validate39;
const schema71 = {
    $id: 'urn:wisepipe-common-connection:GoogleConnection',
    type: 'object',
    properties: {},
    required: []
};
function validate39(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:GoogleConnection" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate39.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate39.errors = vErrors;
    return errors === 0;
}
export const hubspotAuthSchemaValidation = validate40;
const schema72 = {
    $id: 'urn:wisepipe-common-connection:HubspotAuth',
    type: 'object',
    properties: { code: { type: 'string', minLength: 1 }, redirectUri: { type: 'string', format: 'uri' } },
    required: ['code', 'redirectUri']
};
function validate40(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:HubspotAuth" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.code === undefined && (missing0 = 'code')) ||
                (data.redirectUri === undefined && (missing0 = 'redirectUri'))) {
                validate40.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.code !== undefined) {
                    let data0 = data.code;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate40.errors = [
                                    {
                                        instancePath: instancePath + '/code',
                                        schemaPath: '#/properties/code/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate40.errors = [
                                {
                                    instancePath: instancePath + '/code',
                                    schemaPath: '#/properties/code/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.redirectUri !== undefined) {
                        let data1 = data.redirectUri;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (errors === _errs3) {
                                if (typeof data1 === 'string') {
                                    if (!formats0(data1)) {
                                        validate40.errors = [
                                            {
                                                instancePath: instancePath + '/redirectUri',
                                                schemaPath: '#/properties/redirectUri/format',
                                                keyword: 'format',
                                                params: { format: 'uri' },
                                                message: 'must match format "' + 'uri' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate40.errors = [
                                        {
                                            instancePath: instancePath + '/redirectUri',
                                            schemaPath: '#/properties/redirectUri/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate40.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate40.errors = vErrors;
    return errors === 0;
}
export const hubspotConnectionSchemaValidation = validate41;
const schema73 = {
    $id: 'urn:wisepipe-common-connection:HubspotConnection',
    type: 'object',
    properties: {},
    required: []
};
function validate41(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:HubspotConnection" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate41.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate41.errors = vErrors;
    return errors === 0;
}
export const icmAuthSchemaValidation = validate42;
const schema74 = {
    $id: 'urn:wisepipe-common-connection:IcmAuth',
    type: 'object',
    properties: {
        domainName: { type: 'string', minLength: 1 },
        model: { type: 'string', minLength: 1 },
        apiKey: { $ref: 'urn:wisepipe-common-connection:ApiKey' }
    },
    required: ['domainName', 'model', 'apiKey']
};
function validate42(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:IcmAuth" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.domainName === undefined && (missing0 = 'domainName')) ||
                (data.model === undefined && (missing0 = 'model')) ||
                (data.apiKey === undefined && (missing0 = 'apiKey'))) {
                validate42.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.domainName !== undefined) {
                    let data0 = data.domainName;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate42.errors = [
                                    {
                                        instancePath: instancePath + '/domainName',
                                        schemaPath: '#/properties/domainName/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate42.errors = [
                                {
                                    instancePath: instancePath + '/domainName',
                                    schemaPath: '#/properties/domainName/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.model !== undefined) {
                        let data1 = data.model;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate42.errors = [
                                        {
                                            instancePath: instancePath + '/model',
                                            schemaPath: '#/properties/model/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate42.errors = [
                                    {
                                        instancePath: instancePath + '/model',
                                        schemaPath: '#/properties/model/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.apiKey !== undefined) {
                            let data2 = data.apiKey;
                            const _errs5 = errors;
                            const _errs6 = errors;
                            if (errors === _errs6) {
                                if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                    let missing1;
                                    if (data2.value === undefined && (missing1 = 'value')) {
                                        validate42.errors = [
                                            {
                                                instancePath: instancePath + '/apiKey',
                                                schemaPath: 'urn:wisepipe-common-connection:ApiKey/required',
                                                keyword: 'required',
                                                params: { missingProperty: missing1 },
                                                message: "must have required property '" + missing1 + "'"
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        if (data2.value !== undefined) {
                                            let data3 = data2.value;
                                            const _errs8 = errors;
                                            if (errors === _errs8) {
                                                if (typeof data3 === 'string') {
                                                    if (func2(data3) < 1) {
                                                        validate42.errors = [
                                                            {
                                                                instancePath: instancePath + '/apiKey/value',
                                                                schemaPath: 'urn:wisepipe-common-connection:ApiKey/properties/value/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate42.errors = [
                                                        {
                                                            instancePath: instancePath + '/apiKey/value',
                                                            schemaPath: 'urn:wisepipe-common-connection:ApiKey/properties/value/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate42.errors = [
                                        {
                                            instancePath: instancePath + '/apiKey',
                                            schemaPath: 'urn:wisepipe-common-connection:ApiKey/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate42.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate42.errors = vErrors;
    return errors === 0;
}
export const icmConnectionSchemaValidation = validate43;
const schema76 = {
    $id: 'urn:wisepipe-common-connection:IcmConnection',
    type: 'object',
    properties: { domainName: { type: 'string', minLength: 1 }, model: { type: 'string', minLength: 1 } },
    required: ['domainName', 'model']
};
function validate43(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:IcmConnection" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.domainName === undefined && (missing0 = 'domainName')) ||
                (data.model === undefined && (missing0 = 'model'))) {
                validate43.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.domainName !== undefined) {
                    let data0 = data.domainName;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate43.errors = [
                                    {
                                        instancePath: instancePath + '/domainName',
                                        schemaPath: '#/properties/domainName/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate43.errors = [
                                {
                                    instancePath: instancePath + '/domainName',
                                    schemaPath: '#/properties/domainName/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.model !== undefined) {
                        let data1 = data.model;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate43.errors = [
                                        {
                                            instancePath: instancePath + '/model',
                                            schemaPath: '#/properties/model/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate43.errors = [
                                    {
                                        instancePath: instancePath + '/model',
                                        schemaPath: '#/properties/model/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate43.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate43.errors = vErrors;
    return errors === 0;
}
export const msSqlAuthSchemaValidation = validate44;
const schema77 = { $id: 'urn:wisepipe-common-connection:MsSqlAuth', type: 'object', properties: {}, required: [] };
function validate44(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:MsSqlAuth" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate44.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate44.errors = vErrors;
    return errors === 0;
}
export const msSqlConnectionSchemaValidation = validate45;
const schema78 = {
    $id: 'urn:wisepipe-common-connection:MsSqlConnection',
    type: 'object',
    properties: {},
    required: []
};
function validate45(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:MsSqlConnection" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate45.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate45.errors = vErrors;
    return errors === 0;
}
export const mySqlAuthSchemaValidation = validate46;
const schema79 = { $id: 'urn:wisepipe-common-connection:MySqlAuth', type: 'object', properties: {}, required: [] };
function validate46(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:MySqlAuth" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate46.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate46.errors = vErrors;
    return errors === 0;
}
export const mySqlConnectionSchemaValidation = validate47;
const schema80 = {
    $id: 'urn:wisepipe-common-connection:MySqlConnection',
    type: 'object',
    properties: {},
    required: []
};
function validate47(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:MySqlConnection" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate47.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate47.errors = vErrors;
    return errors === 0;
}
export const netSuiteAuthSchemaValidation = validate48;
const schema81 = {
    $id: 'urn:wisepipe-common-connection:NetSuiteAuth',
    type: 'object',
    properties: {
        accountID: { type: 'string', minLength: 1 },
        credentials: { $ref: 'urn:wisepipe-common-connection:TokenBasedAuthentication' }
    },
    required: ['accountID', 'credentials']
};
const schema82 = {
    $id: 'urn:wisepipe-common-connection:TokenBasedAuthentication',
    type: 'object',
    properties: {
        consumerKey: { type: 'string', minLength: 1 },
        consumerSecret: { type: 'string', minLength: 1 },
        tokenKey: { type: 'string', minLength: 1 },
        tokenSecret: { type: 'string', minLength: 1 }
    },
    required: ['consumerKey', 'consumerSecret', 'tokenKey', 'tokenSecret']
};
function validate48(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:NetSuiteAuth" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.accountID === undefined && (missing0 = 'accountID')) ||
                (data.credentials === undefined && (missing0 = 'credentials'))) {
                validate48.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.accountID !== undefined) {
                    let data0 = data.accountID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate48.errors = [
                                    {
                                        instancePath: instancePath + '/accountID',
                                        schemaPath: '#/properties/accountID/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate48.errors = [
                                {
                                    instancePath: instancePath + '/accountID',
                                    schemaPath: '#/properties/accountID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.credentials !== undefined) {
                        let data1 = data.credentials;
                        const _errs3 = errors;
                        const _errs4 = errors;
                        if (errors === _errs4) {
                            if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                                let missing1;
                                if ((data1.consumerKey === undefined && (missing1 = 'consumerKey')) ||
                                    (data1.consumerSecret === undefined && (missing1 = 'consumerSecret')) ||
                                    (data1.tokenKey === undefined && (missing1 = 'tokenKey')) ||
                                    (data1.tokenSecret === undefined && (missing1 = 'tokenSecret'))) {
                                    validate48.errors = [
                                        {
                                            instancePath: instancePath + '/credentials',
                                            schemaPath: 'urn:wisepipe-common-connection:TokenBasedAuthentication/required',
                                            keyword: 'required',
                                            params: { missingProperty: missing1 },
                                            message: "must have required property '" + missing1 + "'"
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (data1.consumerKey !== undefined) {
                                        let data2 = data1.consumerKey;
                                        const _errs6 = errors;
                                        if (errors === _errs6) {
                                            if (typeof data2 === 'string') {
                                                if (func2(data2) < 1) {
                                                    validate48.errors = [
                                                        {
                                                            instancePath: instancePath + '/credentials/consumerKey',
                                                            schemaPath: 'urn:wisepipe-common-connection:TokenBasedAuthentication/properties/consumerKey/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate48.errors = [
                                                    {
                                                        instancePath: instancePath + '/credentials/consumerKey',
                                                        schemaPath: 'urn:wisepipe-common-connection:TokenBasedAuthentication/properties/consumerKey/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid2 = _errs6 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                    if (valid2) {
                                        if (data1.consumerSecret !== undefined) {
                                            let data3 = data1.consumerSecret;
                                            const _errs8 = errors;
                                            if (errors === _errs8) {
                                                if (typeof data3 === 'string') {
                                                    if (func2(data3) < 1) {
                                                        validate48.errors = [
                                                            {
                                                                instancePath: instancePath + '/credentials/consumerSecret',
                                                                schemaPath: 'urn:wisepipe-common-connection:TokenBasedAuthentication/properties/consumerSecret/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate48.errors = [
                                                        {
                                                            instancePath: instancePath + '/credentials/consumerSecret',
                                                            schemaPath: 'urn:wisepipe-common-connection:TokenBasedAuthentication/properties/consumerSecret/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid2 = _errs8 === errors;
                                        }
                                        else {
                                            var valid2 = true;
                                        }
                                        if (valid2) {
                                            if (data1.tokenKey !== undefined) {
                                                let data4 = data1.tokenKey;
                                                const _errs10 = errors;
                                                if (errors === _errs10) {
                                                    if (typeof data4 === 'string') {
                                                        if (func2(data4) < 1) {
                                                            validate48.errors = [
                                                                {
                                                                    instancePath: instancePath + '/credentials/tokenKey',
                                                                    schemaPath: 'urn:wisepipe-common-connection:TokenBasedAuthentication/properties/tokenKey/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate48.errors = [
                                                            {
                                                                instancePath: instancePath + '/credentials/tokenKey',
                                                                schemaPath: 'urn:wisepipe-common-connection:TokenBasedAuthentication/properties/tokenKey/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid2 = _errs10 === errors;
                                            }
                                            else {
                                                var valid2 = true;
                                            }
                                            if (valid2) {
                                                if (data1.tokenSecret !== undefined) {
                                                    let data5 = data1.tokenSecret;
                                                    const _errs12 = errors;
                                                    if (errors === _errs12) {
                                                        if (typeof data5 === 'string') {
                                                            if (func2(data5) < 1) {
                                                                validate48.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/credentials/tokenSecret',
                                                                        schemaPath: 'urn:wisepipe-common-connection:TokenBasedAuthentication/properties/tokenSecret/minLength',
                                                                        keyword: 'minLength',
                                                                        params: { limit: 1 },
                                                                        message: 'must NOT have fewer than 1 characters'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate48.errors = [
                                                                {
                                                                    instancePath: instancePath + '/credentials/tokenSecret',
                                                                    schemaPath: 'urn:wisepipe-common-connection:TokenBasedAuthentication/properties/tokenSecret/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid2 = _errs12 === errors;
                                                }
                                                else {
                                                    var valid2 = true;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                validate48.errors = [
                                    {
                                        instancePath: instancePath + '/credentials',
                                        schemaPath: 'urn:wisepipe-common-connection:TokenBasedAuthentication/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate48.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate48.errors = vErrors;
    return errors === 0;
}
export const netSuiteConnectionSchemaValidation = validate49;
const schema83 = {
    $id: 'urn:wisepipe-common-connection:NetSuiteConnection',
    type: 'object',
    properties: { accountID: { type: 'string', minLength: 1 } },
    required: ['accountID']
};
function validate49(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:NetSuiteConnection" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.accountID === undefined && (missing0 = 'accountID')) {
                validate49.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.accountID !== undefined) {
                    let data0 = data.accountID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate49.errors = [
                                    {
                                        instancePath: instancePath + '/accountID',
                                        schemaPath: '#/properties/accountID/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate49.errors = [
                                {
                                    instancePath: instancePath + '/accountID',
                                    schemaPath: '#/properties/accountID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate49.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate49.errors = vErrors;
    return errors === 0;
}
export const nonceSchemaValidation = validate50;
const schema84 = {
    $id: 'urn:wisepipe-common-connection:Nonce',
    type: 'object',
    properties: { value: { type: 'string', minLength: 1 } },
    required: ['value']
};
function validate50(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:Nonce" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.value === undefined && (missing0 = 'value')) {
                validate50.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.value !== undefined) {
                    let data0 = data.value;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate50.errors = [
                                    {
                                        instancePath: instancePath + '/value',
                                        schemaPath: '#/properties/value/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate50.errors = [
                                {
                                    instancePath: instancePath + '/value',
                                    schemaPath: '#/properties/value/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate50.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate50.errors = vErrors;
    return errors === 0;
}
export const oAuthTokensSchemaValidation = validate51;
const schema85 = {
    $id: 'urn:wisepipe-common-connection:OAuthTokens',
    type: 'object',
    properties: {
        accessToken: { type: 'string', minLength: 1 },
        refreshToken: { type: 'string', minLength: 1 },
        clientID: { type: 'string', minLength: 1 },
        clientSecret: { type: 'string', minLength: 1 }
    },
    required: ['accessToken']
};
function validate51(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:OAuthTokens" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.accessToken === undefined && (missing0 = 'accessToken')) {
                validate51.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.accessToken !== undefined) {
                    let data0 = data.accessToken;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate51.errors = [
                                    {
                                        instancePath: instancePath + '/accessToken',
                                        schemaPath: '#/properties/accessToken/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate51.errors = [
                                {
                                    instancePath: instancePath + '/accessToken',
                                    schemaPath: '#/properties/accessToken/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.refreshToken !== undefined) {
                        let data1 = data.refreshToken;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate51.errors = [
                                        {
                                            instancePath: instancePath + '/refreshToken',
                                            schemaPath: '#/properties/refreshToken/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate51.errors = [
                                    {
                                        instancePath: instancePath + '/refreshToken',
                                        schemaPath: '#/properties/refreshToken/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.clientID !== undefined) {
                            let data2 = data.clientID;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate51.errors = [
                                            {
                                                instancePath: instancePath + '/clientID',
                                                schemaPath: '#/properties/clientID/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate51.errors = [
                                        {
                                            instancePath: instancePath + '/clientID',
                                            schemaPath: '#/properties/clientID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.clientSecret !== undefined) {
                                let data3 = data.clientSecret;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 === 'string') {
                                        if (func2(data3) < 1) {
                                            validate51.errors = [
                                                {
                                                    instancePath: instancePath + '/clientSecret',
                                                    schemaPath: '#/properties/clientSecret/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate51.errors = [
                                            {
                                                instancePath: instancePath + '/clientSecret',
                                                schemaPath: '#/properties/clientSecret/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate51.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate51.errors = vErrors;
    return errors === 0;
}
export const oneDriveAuthSchemaValidation = validate52;
const schema86 = {
    $id: 'urn:wisepipe-common-connection:OneDriveAuth',
    type: 'object',
    properties: { code: { type: 'string', minLength: 1 }, redirectUri: { type: 'string', format: 'uri' } },
    required: ['code', 'redirectUri']
};
function validate52(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:OneDriveAuth" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.code === undefined && (missing0 = 'code')) ||
                (data.redirectUri === undefined && (missing0 = 'redirectUri'))) {
                validate52.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.code !== undefined) {
                    let data0 = data.code;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate52.errors = [
                                    {
                                        instancePath: instancePath + '/code',
                                        schemaPath: '#/properties/code/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate52.errors = [
                                {
                                    instancePath: instancePath + '/code',
                                    schemaPath: '#/properties/code/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.redirectUri !== undefined) {
                        let data1 = data.redirectUri;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (errors === _errs3) {
                                if (typeof data1 === 'string') {
                                    if (!formats0(data1)) {
                                        validate52.errors = [
                                            {
                                                instancePath: instancePath + '/redirectUri',
                                                schemaPath: '#/properties/redirectUri/format',
                                                keyword: 'format',
                                                params: { format: 'uri' },
                                                message: 'must match format "' + 'uri' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate52.errors = [
                                        {
                                            instancePath: instancePath + '/redirectUri',
                                            schemaPath: '#/properties/redirectUri/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate52.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate52.errors = vErrors;
    return errors === 0;
}
export const oneDriveConnectionSchemaValidation = validate53;
const schema87 = {
    $id: 'urn:wisepipe-common-connection:OneDriveConnection',
    type: 'object',
    properties: {},
    required: []
};
function validate53(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:OneDriveConnection" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate53.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate53.errors = vErrors;
    return errors === 0;
}
export const oneDriveExportAuthSchemaValidation = validate54;
const schema88 = {
    $id: 'urn:wisepipe-common-connection:OneDriveExportAuth',
    type: 'object',
    properties: { code: { type: 'string', minLength: 1 }, redirectUri: { type: 'string', format: 'uri' } },
    required: ['code', 'redirectUri']
};
function validate54(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:OneDriveExportAuth" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.code === undefined && (missing0 = 'code')) ||
                (data.redirectUri === undefined && (missing0 = 'redirectUri'))) {
                validate54.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.code !== undefined) {
                    let data0 = data.code;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate54.errors = [
                                    {
                                        instancePath: instancePath + '/code',
                                        schemaPath: '#/properties/code/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate54.errors = [
                                {
                                    instancePath: instancePath + '/code',
                                    schemaPath: '#/properties/code/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.redirectUri !== undefined) {
                        let data1 = data.redirectUri;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (errors === _errs3) {
                                if (typeof data1 === 'string') {
                                    if (!formats0(data1)) {
                                        validate54.errors = [
                                            {
                                                instancePath: instancePath + '/redirectUri',
                                                schemaPath: '#/properties/redirectUri/format',
                                                keyword: 'format',
                                                params: { format: 'uri' },
                                                message: 'must match format "' + 'uri' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate54.errors = [
                                        {
                                            instancePath: instancePath + '/redirectUri',
                                            schemaPath: '#/properties/redirectUri/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate54.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate54.errors = vErrors;
    return errors === 0;
}
export const oneDriveExportConnectionSchemaValidation = validate55;
const schema89 = {
    $id: 'urn:wisepipe-common-connection:OneDriveExportConnection',
    type: 'object',
    properties: {},
    required: []
};
function validate55(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:OneDriveExportConnection" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate55.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate55.errors = vErrors;
    return errors === 0;
}
export const oracleAuthSchemaValidation = validate56;
const schema90 = {
    $id: 'urn:wisepipe-common-connection:OracleAuth',
    type: 'object',
    properties: { sid: { type: 'string', minLength: 1 } },
    required: ['sid']
};
function validate56(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:OracleAuth" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.sid === undefined && (missing0 = 'sid')) {
                validate56.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.sid !== undefined) {
                    let data0 = data.sid;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate56.errors = [
                                    {
                                        instancePath: instancePath + '/sid',
                                        schemaPath: '#/properties/sid/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate56.errors = [
                                {
                                    instancePath: instancePath + '/sid',
                                    schemaPath: '#/properties/sid/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate56.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate56.errors = vErrors;
    return errors === 0;
}
export const oracleConnectionSchemaValidation = validate57;
const schema91 = {
    $id: 'urn:wisepipe-common-connection:OracleConnection',
    type: 'object',
    properties: { sid: { type: 'string', minLength: 1 } },
    required: ['sid']
};
function validate57(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:OracleConnection" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.sid === undefined && (missing0 = 'sid')) {
                validate57.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.sid !== undefined) {
                    let data0 = data.sid;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate57.errors = [
                                    {
                                        instancePath: instancePath + '/sid',
                                        schemaPath: '#/properties/sid/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate57.errors = [
                                {
                                    instancePath: instancePath + '/sid',
                                    schemaPath: '#/properties/sid/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate57.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate57.errors = vErrors;
    return errors === 0;
}
export const postgreSqlAuthSchemaValidation = validate58;
const schema92 = { $id: 'urn:wisepipe-common-connection:PostgreSqlAuth', type: 'object', properties: {}, required: [] };
function validate58(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:PostgreSqlAuth" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate58.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate58.errors = vErrors;
    return errors === 0;
}
export const postgreSqlConnectionSchemaValidation = validate59;
const schema93 = {
    $id: 'urn:wisepipe-common-connection:PostgreSqlConnection',
    type: 'object',
    properties: {},
    required: []
};
function validate59(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:PostgreSqlConnection" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate59.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate59.errors = vErrors;
    return errors === 0;
}
export const powerBIAuthSchemaValidation = validate60;
const schema94 = {
    $id: 'urn:wisepipe-common-connection:PowerBIAuth',
    type: 'object',
    properties: { code: { type: 'string', minLength: 1 }, redirectUri: { type: 'string', format: 'uri' } },
    required: ['code', 'redirectUri']
};
function validate60(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:PowerBIAuth" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.code === undefined && (missing0 = 'code')) ||
                (data.redirectUri === undefined && (missing0 = 'redirectUri'))) {
                validate60.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.code !== undefined) {
                    let data0 = data.code;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate60.errors = [
                                    {
                                        instancePath: instancePath + '/code',
                                        schemaPath: '#/properties/code/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate60.errors = [
                                {
                                    instancePath: instancePath + '/code',
                                    schemaPath: '#/properties/code/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.redirectUri !== undefined) {
                        let data1 = data.redirectUri;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (errors === _errs3) {
                                if (typeof data1 === 'string') {
                                    if (!formats0(data1)) {
                                        validate60.errors = [
                                            {
                                                instancePath: instancePath + '/redirectUri',
                                                schemaPath: '#/properties/redirectUri/format',
                                                keyword: 'format',
                                                params: { format: 'uri' },
                                                message: 'must match format "' + 'uri' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate60.errors = [
                                        {
                                            instancePath: instancePath + '/redirectUri',
                                            schemaPath: '#/properties/redirectUri/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate60.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate60.errors = vErrors;
    return errors === 0;
}
export const powerBIConnectionSchemaValidation = validate61;
const schema95 = {
    $id: 'urn:wisepipe-common-connection:PowerBIConnection',
    type: 'object',
    properties: {},
    required: []
};
function validate61(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:PowerBIConnection" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate61.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate61.errors = vErrors;
    return errors === 0;
}
export const restAuthCredentialsSchemaValidation = validate62;
const schema96 = {
    $id: 'urn:wisepipe-common-connection:RestAuthCredentials',
    type: 'object',
    properties: {
        type: { type: 'string', enum: ['none', 'basic', 'api_key', 'oauth_client_credentials', 'oauth_client_code'] },
        userName: { type: 'string' },
        password: { type: 'string' },
        authHeader: { type: 'string' },
        accessToken: { type: 'string' },
        refreshToken: { type: 'string' },
        clientID: { type: 'string' },
        clientSecret: { type: 'string' },
        tokenUrl: { type: 'string' },
        tokenType: { type: 'string' },
        key: { type: 'string' },
        secret: { type: 'string' },
        authUrl: { type: 'string' },
        code: { type: 'string' },
        redirectUri: { type: 'string' }
    },
    required: ['type'],
    allOf: [
        { if: { properties: { type: { const: 'basic' } } }, then: { required: ['userName', 'password'] } },
        { if: { properties: { type: { const: 'api_key' } } }, then: { required: ['authHeader'] } },
        {
            if: { properties: { type: { const: 'oauth_client_credentials' } } },
            then: { required: ['tokenType', 'key', 'secret', 'authUrl'] }
        },
        {
            if: { properties: { type: { const: 'oauth_client_code' } } },
            then: { required: ['clientID', 'clientSecret', 'tokenUrl', 'authUrl', 'redirectUri'] }
        }
    ]
};
function validate62(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:RestAuthCredentials" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    const _errs2 = errors;
    let valid1 = true;
    const _errs3 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.type !== undefined) {
            if ('basic' !== data.type) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs3 === errors;
    errors = _errs2;
    if (vErrors !== null) {
        if (_errs2) {
            vErrors.length = _errs2;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs5 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.userName === undefined && (missing0 = 'userName')) ||
                (data.password === undefined && (missing0 = 'password'))) {
                validate62.errors = [
                    {
                        instancePath,
                        schemaPath: '#/allOf/0/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs5 === errors;
        valid1 = _valid0;
    }
    if (!valid1) {
        const err1 = {
            instancePath,
            schemaPath: '#/allOf/0/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
        validate62.errors = vErrors;
        return false;
    }
    var valid0 = _errs1 === errors;
    if (valid0) {
        const _errs6 = errors;
        const _errs7 = errors;
        let valid3 = true;
        const _errs8 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.type !== undefined) {
                if ('api_key' !== data.type) {
                    const err2 = {};
                    if (vErrors === null) {
                        vErrors = [err2];
                    }
                    else {
                        vErrors.push(err2);
                    }
                    errors++;
                }
            }
        }
        var _valid1 = _errs8 === errors;
        errors = _errs7;
        if (vErrors !== null) {
            if (_errs7) {
                vErrors.length = _errs7;
            }
            else {
                vErrors = null;
            }
        }
        if (_valid1) {
            const _errs10 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                let missing1;
                if (data.authHeader === undefined && (missing1 = 'authHeader')) {
                    validate62.errors = [
                        {
                            instancePath,
                            schemaPath: '#/allOf/1/then/required',
                            keyword: 'required',
                            params: { missingProperty: missing1 },
                            message: "must have required property '" + missing1 + "'"
                        }
                    ];
                    return false;
                }
            }
            var _valid1 = _errs10 === errors;
            valid3 = _valid1;
        }
        if (!valid3) {
            const err3 = {
                instancePath,
                schemaPath: '#/allOf/1/if',
                keyword: 'if',
                params: { failingKeyword: 'then' },
                message: 'must match "then" schema'
            };
            if (vErrors === null) {
                vErrors = [err3];
            }
            else {
                vErrors.push(err3);
            }
            errors++;
            validate62.errors = vErrors;
            return false;
        }
        var valid0 = _errs6 === errors;
        if (valid0) {
            const _errs11 = errors;
            const _errs12 = errors;
            let valid5 = true;
            const _errs13 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                if (data.type !== undefined) {
                    if ('oauth_client_credentials' !== data.type) {
                        const err4 = {};
                        if (vErrors === null) {
                            vErrors = [err4];
                        }
                        else {
                            vErrors.push(err4);
                        }
                        errors++;
                    }
                }
            }
            var _valid2 = _errs13 === errors;
            errors = _errs12;
            if (vErrors !== null) {
                if (_errs12) {
                    vErrors.length = _errs12;
                }
                else {
                    vErrors = null;
                }
            }
            if (_valid2) {
                const _errs15 = errors;
                if (data && typeof data == 'object' && !Array.isArray(data)) {
                    let missing2;
                    if ((data.tokenType === undefined && (missing2 = 'tokenType')) ||
                        (data.key === undefined && (missing2 = 'key')) ||
                        (data.secret === undefined && (missing2 = 'secret')) ||
                        (data.authUrl === undefined && (missing2 = 'authUrl'))) {
                        validate62.errors = [
                            {
                                instancePath,
                                schemaPath: '#/allOf/2/then/required',
                                keyword: 'required',
                                params: { missingProperty: missing2 },
                                message: "must have required property '" + missing2 + "'"
                            }
                        ];
                        return false;
                    }
                }
                var _valid2 = _errs15 === errors;
                valid5 = _valid2;
            }
            if (!valid5) {
                const err5 = {
                    instancePath,
                    schemaPath: '#/allOf/2/if',
                    keyword: 'if',
                    params: { failingKeyword: 'then' },
                    message: 'must match "then" schema'
                };
                if (vErrors === null) {
                    vErrors = [err5];
                }
                else {
                    vErrors.push(err5);
                }
                errors++;
                validate62.errors = vErrors;
                return false;
            }
            var valid0 = _errs11 === errors;
            if (valid0) {
                const _errs16 = errors;
                const _errs17 = errors;
                let valid7 = true;
                const _errs18 = errors;
                if (data && typeof data == 'object' && !Array.isArray(data)) {
                    if (data.type !== undefined) {
                        if ('oauth_client_code' !== data.type) {
                            const err6 = {};
                            if (vErrors === null) {
                                vErrors = [err6];
                            }
                            else {
                                vErrors.push(err6);
                            }
                            errors++;
                        }
                    }
                }
                var _valid3 = _errs18 === errors;
                errors = _errs17;
                if (vErrors !== null) {
                    if (_errs17) {
                        vErrors.length = _errs17;
                    }
                    else {
                        vErrors = null;
                    }
                }
                if (_valid3) {
                    const _errs20 = errors;
                    if (data && typeof data == 'object' && !Array.isArray(data)) {
                        let missing3;
                        if ((data.clientID === undefined && (missing3 = 'clientID')) ||
                            (data.clientSecret === undefined && (missing3 = 'clientSecret')) ||
                            (data.tokenUrl === undefined && (missing3 = 'tokenUrl')) ||
                            (data.authUrl === undefined && (missing3 = 'authUrl')) ||
                            (data.redirectUri === undefined && (missing3 = 'redirectUri'))) {
                            validate62.errors = [
                                {
                                    instancePath,
                                    schemaPath: '#/allOf/3/then/required',
                                    keyword: 'required',
                                    params: { missingProperty: missing3 },
                                    message: "must have required property '" + missing3 + "'"
                                }
                            ];
                            return false;
                        }
                    }
                    var _valid3 = _errs20 === errors;
                    valid7 = _valid3;
                }
                if (!valid7) {
                    const err7 = {
                        instancePath,
                        schemaPath: '#/allOf/3/if',
                        keyword: 'if',
                        params: { failingKeyword: 'then' },
                        message: 'must match "then" schema'
                    };
                    if (vErrors === null) {
                        vErrors = [err7];
                    }
                    else {
                        vErrors.push(err7);
                    }
                    errors++;
                    validate62.errors = vErrors;
                    return false;
                }
                var valid0 = _errs16 === errors;
            }
        }
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing4;
            if (data.type === undefined && (missing4 = 'type')) {
                validate62.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing4 },
                        message: "must have required property '" + missing4 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.type !== undefined) {
                    let data4 = data.type;
                    const _errs21 = errors;
                    if (typeof data4 !== 'string') {
                        validate62.errors = [
                            {
                                instancePath: instancePath + '/type',
                                schemaPath: '#/properties/type/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data4 === 'none' ||
                        data4 === 'basic' ||
                        data4 === 'api_key' ||
                        data4 === 'oauth_client_credentials' ||
                        data4 === 'oauth_client_code')) {
                        validate62.errors = [
                            {
                                instancePath: instancePath + '/type',
                                schemaPath: '#/properties/type/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema96.properties.type.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid9 = _errs21 === errors;
                }
                else {
                    var valid9 = true;
                }
                if (valid9) {
                    if (data.userName !== undefined) {
                        const _errs23 = errors;
                        if (typeof data.userName !== 'string') {
                            validate62.errors = [
                                {
                                    instancePath: instancePath + '/userName',
                                    schemaPath: '#/properties/userName/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid9 = _errs23 === errors;
                    }
                    else {
                        var valid9 = true;
                    }
                    if (valid9) {
                        if (data.password !== undefined) {
                            const _errs25 = errors;
                            if (typeof data.password !== 'string') {
                                validate62.errors = [
                                    {
                                        instancePath: instancePath + '/password',
                                        schemaPath: '#/properties/password/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            var valid9 = _errs25 === errors;
                        }
                        else {
                            var valid9 = true;
                        }
                        if (valid9) {
                            if (data.authHeader !== undefined) {
                                const _errs27 = errors;
                                if (typeof data.authHeader !== 'string') {
                                    validate62.errors = [
                                        {
                                            instancePath: instancePath + '/authHeader',
                                            schemaPath: '#/properties/authHeader/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                var valid9 = _errs27 === errors;
                            }
                            else {
                                var valid9 = true;
                            }
                            if (valid9) {
                                if (data.accessToken !== undefined) {
                                    const _errs29 = errors;
                                    if (typeof data.accessToken !== 'string') {
                                        validate62.errors = [
                                            {
                                                instancePath: instancePath + '/accessToken',
                                                schemaPath: '#/properties/accessToken/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid9 = _errs29 === errors;
                                }
                                else {
                                    var valid9 = true;
                                }
                                if (valid9) {
                                    if (data.refreshToken !== undefined) {
                                        const _errs31 = errors;
                                        if (typeof data.refreshToken !== 'string') {
                                            validate62.errors = [
                                                {
                                                    instancePath: instancePath + '/refreshToken',
                                                    schemaPath: '#/properties/refreshToken/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid9 = _errs31 === errors;
                                    }
                                    else {
                                        var valid9 = true;
                                    }
                                    if (valid9) {
                                        if (data.clientID !== undefined) {
                                            const _errs33 = errors;
                                            if (typeof data.clientID !== 'string') {
                                                validate62.errors = [
                                                    {
                                                        instancePath: instancePath + '/clientID',
                                                        schemaPath: '#/properties/clientID/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid9 = _errs33 === errors;
                                        }
                                        else {
                                            var valid9 = true;
                                        }
                                        if (valid9) {
                                            if (data.clientSecret !== undefined) {
                                                const _errs35 = errors;
                                                if (typeof data.clientSecret !== 'string') {
                                                    validate62.errors = [
                                                        {
                                                            instancePath: instancePath + '/clientSecret',
                                                            schemaPath: '#/properties/clientSecret/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid9 = _errs35 === errors;
                                            }
                                            else {
                                                var valid9 = true;
                                            }
                                            if (valid9) {
                                                if (data.tokenUrl !== undefined) {
                                                    const _errs37 = errors;
                                                    if (typeof data.tokenUrl !== 'string') {
                                                        validate62.errors = [
                                                            {
                                                                instancePath: instancePath + '/tokenUrl',
                                                                schemaPath: '#/properties/tokenUrl/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid9 = _errs37 === errors;
                                                }
                                                else {
                                                    var valid9 = true;
                                                }
                                                if (valid9) {
                                                    if (data.tokenType !== undefined) {
                                                        const _errs39 = errors;
                                                        if (typeof data.tokenType !== 'string') {
                                                            validate62.errors = [
                                                                {
                                                                    instancePath: instancePath + '/tokenType',
                                                                    schemaPath: '#/properties/tokenType/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid9 = _errs39 === errors;
                                                    }
                                                    else {
                                                        var valid9 = true;
                                                    }
                                                    if (valid9) {
                                                        if (data.key !== undefined) {
                                                            const _errs41 = errors;
                                                            if (typeof data.key !== 'string') {
                                                                validate62.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/key',
                                                                        schemaPath: '#/properties/key/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid9 = _errs41 === errors;
                                                        }
                                                        else {
                                                            var valid9 = true;
                                                        }
                                                        if (valid9) {
                                                            if (data.secret !== undefined) {
                                                                const _errs43 = errors;
                                                                if (typeof data.secret !== 'string') {
                                                                    validate62.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/secret',
                                                                            schemaPath: '#/properties/secret/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid9 = _errs43 === errors;
                                                            }
                                                            else {
                                                                var valid9 = true;
                                                            }
                                                            if (valid9) {
                                                                if (data.authUrl !== undefined) {
                                                                    const _errs45 = errors;
                                                                    if (typeof data.authUrl !== 'string') {
                                                                        validate62.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/authUrl',
                                                                                schemaPath: '#/properties/authUrl/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    var valid9 = _errs45 === errors;
                                                                }
                                                                else {
                                                                    var valid9 = true;
                                                                }
                                                                if (valid9) {
                                                                    if (data.code !== undefined) {
                                                                        const _errs47 = errors;
                                                                        if (typeof data.code !== 'string') {
                                                                            validate62.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/code',
                                                                                    schemaPath: '#/properties/code/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        var valid9 = _errs47 === errors;
                                                                    }
                                                                    else {
                                                                        var valid9 = true;
                                                                    }
                                                                    if (valid9) {
                                                                        if (data.redirectUri !== undefined) {
                                                                            const _errs49 = errors;
                                                                            if (typeof data.redirectUri !== 'string') {
                                                                                validate62.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/redirectUri',
                                                                                        schemaPath: '#/properties/redirectUri/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            var valid9 = _errs49 === errors;
                                                                        }
                                                                        else {
                                                                            var valid9 = true;
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate62.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate62.errors = vErrors;
    return errors === 0;
}
export const restAuthEndpointSchemaSchemaValidation = validate63;
const schema97 = {
    $id: 'urn:wisepipe-common-connection:RestAuthEndpointSchema',
    type: 'object',
    properties: {
        mode: { type: 'string', enum: ['infer', 'manual'] },
        override: {
            type: 'object',
            additionalProperties: { type: 'string', enum: ['string', 'boolean', 'number', 'date'] }
        },
        properties: {
            type: 'object',
            additionalProperties: {
                type: 'object',
                properties: { type: { type: 'array' }, format: { type: 'string' } },
                required: ['type']
            }
        }
    },
    required: ['mode'],
    if: { properties: { mode: { const: 'manual' } } },
    then: { required: ['properties'] }
};
function validate63(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:RestAuthEndpointSchema" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.mode !== undefined) {
            if ('manual' !== data.mode) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs4 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.properties === undefined && (missing0 = 'properties')) {
                validate63.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs4 === errors;
        valid0 = _valid0;
    }
    if (!valid0) {
        const err1 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
        validate63.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if (data.mode === undefined && (missing1 = 'mode')) {
                validate63.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.mode !== undefined) {
                    let data1 = data.mode;
                    const _errs5 = errors;
                    if (typeof data1 !== 'string') {
                        validate63.errors = [
                            {
                                instancePath: instancePath + '/mode',
                                schemaPath: '#/properties/mode/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data1 === 'infer' || data1 === 'manual')) {
                        validate63.errors = [
                            {
                                instancePath: instancePath + '/mode',
                                schemaPath: '#/properties/mode/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema97.properties.mode.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid2 = _errs5 === errors;
                }
                else {
                    var valid2 = true;
                }
                if (valid2) {
                    if (data.override !== undefined) {
                        let data2 = data.override;
                        const _errs7 = errors;
                        if (errors === _errs7) {
                            if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                for (const key0 in data2) {
                                    let data3 = data2[key0];
                                    const _errs10 = errors;
                                    if (typeof data3 !== 'string') {
                                        validate63.errors = [
                                            {
                                                instancePath: instancePath + '/override/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                schemaPath: '#/properties/override/additionalProperties/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (!(data3 === 'string' || data3 === 'boolean' || data3 === 'number' || data3 === 'date')) {
                                        validate63.errors = [
                                            {
                                                instancePath: instancePath + '/override/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                schemaPath: '#/properties/override/additionalProperties/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema97.properties.override.additionalProperties.enum },
                                                message: 'must be equal to one of the allowed values'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid3 = _errs10 === errors;
                                    if (!valid3) {
                                        break;
                                    }
                                }
                            }
                            else {
                                validate63.errors = [
                                    {
                                        instancePath: instancePath + '/override',
                                        schemaPath: '#/properties/override/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid2 = _errs7 === errors;
                    }
                    else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.properties !== undefined) {
                            let data4 = data.properties;
                            const _errs12 = errors;
                            if (errors === _errs12) {
                                if (data4 && typeof data4 == 'object' && !Array.isArray(data4)) {
                                    for (const key1 in data4) {
                                        let data5 = data4[key1];
                                        const _errs15 = errors;
                                        if (errors === _errs15) {
                                            if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
                                                let missing2;
                                                if (data5.type === undefined && (missing2 = 'type')) {
                                                    validate63.errors = [
                                                        {
                                                            instancePath: instancePath + '/properties/' + key1.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                            schemaPath: '#/properties/properties/additionalProperties/required',
                                                            keyword: 'required',
                                                            params: { missingProperty: missing2 },
                                                            message: "must have required property '" + missing2 + "'"
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    if (data5.type !== undefined) {
                                                        const _errs17 = errors;
                                                        if (!Array.isArray(data5.type)) {
                                                            validate63.errors = [
                                                                {
                                                                    instancePath: instancePath +
                                                                        '/properties/' +
                                                                        key1.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                        '/type',
                                                                    schemaPath: '#/properties/properties/additionalProperties/properties/type/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'array' },
                                                                    message: 'must be array'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid5 = _errs17 === errors;
                                                    }
                                                    else {
                                                        var valid5 = true;
                                                    }
                                                    if (valid5) {
                                                        if (data5.format !== undefined) {
                                                            const _errs19 = errors;
                                                            if (typeof data5.format !== 'string') {
                                                                validate63.errors = [
                                                                    {
                                                                        instancePath: instancePath +
                                                                            '/properties/' +
                                                                            key1.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                            '/format',
                                                                        schemaPath: '#/properties/properties/additionalProperties/properties/format/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid5 = _errs19 === errors;
                                                        }
                                                        else {
                                                            var valid5 = true;
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate63.errors = [
                                                    {
                                                        instancePath: instancePath + '/properties/' + key1.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                        schemaPath: '#/properties/properties/additionalProperties/type',
                                                        keyword: 'type',
                                                        params: { type: 'object' },
                                                        message: 'must be object'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid4 = _errs15 === errors;
                                        if (!valid4) {
                                            break;
                                        }
                                    }
                                }
                                else {
                                    validate63.errors = [
                                        {
                                            instancePath: instancePath + '/properties',
                                            schemaPath: '#/properties/properties/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid2 = _errs12 === errors;
                        }
                        else {
                            var valid2 = true;
                        }
                    }
                }
            }
        }
        else {
            validate63.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate63.errors = vErrors;
    return errors === 0;
}
export const restAuthEndpointSchemaValidation = validate64;
const schema98 = {
    $id: 'urn:wisepipe-common-connection:RestAuthEndpoint',
    type: 'object',
    properties: {
        url: { type: 'string', minLength: 5, maxLength: 2048 },
        verb: { type: 'string', enum: ['GET', 'get'] },
        pathToData: { type: 'string' },
        flatten: { type: 'boolean' },
        tableKey: { type: 'string' },
        schema: { $ref: 'urn:wisepipe-common-connection:RestAuthEndpointSchema' }
    },
    required: ['url', 'verb', 'pathToData', 'flatten', 'tableKey', 'schema']
};
function validate64(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:RestAuthEndpoint" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.url === undefined && (missing0 = 'url')) ||
                (data.verb === undefined && (missing0 = 'verb')) ||
                (data.pathToData === undefined && (missing0 = 'pathToData')) ||
                (data.flatten === undefined && (missing0 = 'flatten')) ||
                (data.tableKey === undefined && (missing0 = 'tableKey')) ||
                (data.schema === undefined && (missing0 = 'schema'))) {
                validate64.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.url !== undefined) {
                    let data0 = data.url;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 2048) {
                                validate64.errors = [
                                    {
                                        instancePath: instancePath + '/url',
                                        schemaPath: '#/properties/url/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 2048 },
                                        message: 'must NOT have more than 2048 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data0) < 5) {
                                    validate64.errors = [
                                        {
                                            instancePath: instancePath + '/url',
                                            schemaPath: '#/properties/url/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 5 },
                                            message: 'must NOT have fewer than 5 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate64.errors = [
                                {
                                    instancePath: instancePath + '/url',
                                    schemaPath: '#/properties/url/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.verb !== undefined) {
                        let data1 = data.verb;
                        const _errs3 = errors;
                        if (typeof data1 !== 'string') {
                            validate64.errors = [
                                {
                                    instancePath: instancePath + '/verb',
                                    schemaPath: '#/properties/verb/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data1 === 'GET' || data1 === 'get')) {
                            validate64.errors = [
                                {
                                    instancePath: instancePath + '/verb',
                                    schemaPath: '#/properties/verb/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema98.properties.verb.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.pathToData !== undefined) {
                            const _errs5 = errors;
                            if (typeof data.pathToData !== 'string') {
                                validate64.errors = [
                                    {
                                        instancePath: instancePath + '/pathToData',
                                        schemaPath: '#/properties/pathToData/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.flatten !== undefined) {
                                const _errs7 = errors;
                                if (typeof data.flatten !== 'boolean') {
                                    validate64.errors = [
                                        {
                                            instancePath: instancePath + '/flatten',
                                            schemaPath: '#/properties/flatten/type',
                                            keyword: 'type',
                                            params: { type: 'boolean' },
                                            message: 'must be boolean'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.tableKey !== undefined) {
                                    const _errs9 = errors;
                                    if (typeof data.tableKey !== 'string') {
                                        validate64.errors = [
                                            {
                                                instancePath: instancePath + '/tableKey',
                                                schemaPath: '#/properties/tableKey/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.schema !== undefined) {
                                        let data5 = data.schema;
                                        const _errs11 = errors;
                                        const _errs12 = errors;
                                        const _errs14 = errors;
                                        let valid2 = true;
                                        const _errs15 = errors;
                                        if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
                                            if (data5.mode !== undefined) {
                                                if ('manual' !== data5.mode) {
                                                    const err0 = {};
                                                    if (vErrors === null) {
                                                        vErrors = [err0];
                                                    }
                                                    else {
                                                        vErrors.push(err0);
                                                    }
                                                    errors++;
                                                }
                                            }
                                        }
                                        var _valid0 = _errs15 === errors;
                                        errors = _errs14;
                                        if (vErrors !== null) {
                                            if (_errs14) {
                                                vErrors.length = _errs14;
                                            }
                                            else {
                                                vErrors = null;
                                            }
                                        }
                                        if (_valid0) {
                                            const _errs17 = errors;
                                            if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
                                                let missing1;
                                                if (data5.properties === undefined && (missing1 = 'properties')) {
                                                    validate64.errors = [
                                                        {
                                                            instancePath: instancePath + '/schema',
                                                            schemaPath: 'urn:wisepipe-common-connection:RestAuthEndpointSchema/then/required',
                                                            keyword: 'required',
                                                            params: { missingProperty: missing1 },
                                                            message: "must have required property '" + missing1 + "'"
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var _valid0 = _errs17 === errors;
                                            valid2 = _valid0;
                                        }
                                        if (!valid2) {
                                            const err1 = {
                                                instancePath: instancePath + '/schema',
                                                schemaPath: 'urn:wisepipe-common-connection:RestAuthEndpointSchema/if',
                                                keyword: 'if',
                                                params: { failingKeyword: 'then' },
                                                message: 'must match "then" schema'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err1];
                                            }
                                            else {
                                                vErrors.push(err1);
                                            }
                                            errors++;
                                            validate64.errors = vErrors;
                                            return false;
                                        }
                                        if (errors === _errs12) {
                                            if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
                                                let missing2;
                                                if (data5.mode === undefined && (missing2 = 'mode')) {
                                                    validate64.errors = [
                                                        {
                                                            instancePath: instancePath + '/schema',
                                                            schemaPath: 'urn:wisepipe-common-connection:RestAuthEndpointSchema/required',
                                                            keyword: 'required',
                                                            params: { missingProperty: missing2 },
                                                            message: "must have required property '" + missing2 + "'"
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    if (data5.mode !== undefined) {
                                                        let data7 = data5.mode;
                                                        const _errs18 = errors;
                                                        if (typeof data7 !== 'string') {
                                                            validate64.errors = [
                                                                {
                                                                    instancePath: instancePath + '/schema/mode',
                                                                    schemaPath: 'urn:wisepipe-common-connection:RestAuthEndpointSchema/properties/mode/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        if (!(data7 === 'infer' || data7 === 'manual')) {
                                                            validate64.errors = [
                                                                {
                                                                    instancePath: instancePath + '/schema/mode',
                                                                    schemaPath: 'urn:wisepipe-common-connection:RestAuthEndpointSchema/properties/mode/enum',
                                                                    keyword: 'enum',
                                                                    params: { allowedValues: schema97.properties.mode.enum },
                                                                    message: 'must be equal to one of the allowed values'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid4 = _errs18 === errors;
                                                    }
                                                    else {
                                                        var valid4 = true;
                                                    }
                                                    if (valid4) {
                                                        if (data5.override !== undefined) {
                                                            let data8 = data5.override;
                                                            const _errs20 = errors;
                                                            if (errors === _errs20) {
                                                                if (data8 && typeof data8 == 'object' && !Array.isArray(data8)) {
                                                                    for (const key0 in data8) {
                                                                        let data9 = data8[key0];
                                                                        const _errs23 = errors;
                                                                        if (typeof data9 !== 'string') {
                                                                            validate64.errors = [
                                                                                {
                                                                                    instancePath: instancePath +
                                                                                        '/schema/override/' +
                                                                                        key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                                    schemaPath: 'urn:wisepipe-common-connection:RestAuthEndpointSchema/properties/override/additionalProperties/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        if (!(data9 === 'string' ||
                                                                            data9 === 'boolean' ||
                                                                            data9 === 'number' ||
                                                                            data9 === 'date')) {
                                                                            validate64.errors = [
                                                                                {
                                                                                    instancePath: instancePath +
                                                                                        '/schema/override/' +
                                                                                        key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                                    schemaPath: 'urn:wisepipe-common-connection:RestAuthEndpointSchema/properties/override/additionalProperties/enum',
                                                                                    keyword: 'enum',
                                                                                    params: {
                                                                                        allowedValues: schema97.properties.override.additionalProperties.enum
                                                                                    },
                                                                                    message: 'must be equal to one of the allowed values'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        var valid5 = _errs23 === errors;
                                                                        if (!valid5) {
                                                                            break;
                                                                        }
                                                                    }
                                                                }
                                                                else {
                                                                    validate64.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/schema/override',
                                                                            schemaPath: 'urn:wisepipe-common-connection:RestAuthEndpointSchema/properties/override/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'object' },
                                                                            message: 'must be object'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid4 = _errs20 === errors;
                                                        }
                                                        else {
                                                            var valid4 = true;
                                                        }
                                                        if (valid4) {
                                                            if (data5.properties !== undefined) {
                                                                let data10 = data5.properties;
                                                                const _errs25 = errors;
                                                                if (errors === _errs25) {
                                                                    if (data10 && typeof data10 == 'object' && !Array.isArray(data10)) {
                                                                        for (const key1 in data10) {
                                                                            let data11 = data10[key1];
                                                                            const _errs28 = errors;
                                                                            if (errors === _errs28) {
                                                                                if (data11 && typeof data11 == 'object' && !Array.isArray(data11)) {
                                                                                    let missing3;
                                                                                    if (data11.type === undefined && (missing3 = 'type')) {
                                                                                        validate64.errors = [
                                                                                            {
                                                                                                instancePath: instancePath +
                                                                                                    '/schema/properties/' +
                                                                                                    key1.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                                                schemaPath: 'urn:wisepipe-common-connection:RestAuthEndpointSchema/properties/properties/additionalProperties/required',
                                                                                                keyword: 'required',
                                                                                                params: { missingProperty: missing3 },
                                                                                                message: "must have required property '" + missing3 + "'"
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                    else {
                                                                                        if (data11.type !== undefined) {
                                                                                            const _errs30 = errors;
                                                                                            if (!Array.isArray(data11.type)) {
                                                                                                validate64.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath +
                                                                                                            '/schema/properties/' +
                                                                                                            key1.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                            '/type',
                                                                                                        schemaPath: 'urn:wisepipe-common-connection:RestAuthEndpointSchema/properties/properties/additionalProperties/properties/type/type',
                                                                                                        keyword: 'type',
                                                                                                        params: { type: 'array' },
                                                                                                        message: 'must be array'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                            var valid7 = _errs30 === errors;
                                                                                        }
                                                                                        else {
                                                                                            var valid7 = true;
                                                                                        }
                                                                                        if (valid7) {
                                                                                            if (data11.format !== undefined) {
                                                                                                const _errs32 = errors;
                                                                                                if (typeof data11.format !== 'string') {
                                                                                                    validate64.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath +
                                                                                                                '/schema/properties/' +
                                                                                                                key1.replace(/~/g, '~0').replace(/\//g, '~1') +
                                                                                                                '/format',
                                                                                                            schemaPath: 'urn:wisepipe-common-connection:RestAuthEndpointSchema/properties/properties/additionalProperties/properties/format/type',
                                                                                                            keyword: 'type',
                                                                                                            params: { type: 'string' },
                                                                                                            message: 'must be string'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                                var valid7 = _errs32 === errors;
                                                                                            }
                                                                                            else {
                                                                                                var valid7 = true;
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    validate64.errors = [
                                                                                        {
                                                                                            instancePath: instancePath +
                                                                                                '/schema/properties/' +
                                                                                                key1.replace(/~/g, '~0').replace(/\//g, '~1'),
                                                                                            schemaPath: 'urn:wisepipe-common-connection:RestAuthEndpointSchema/properties/properties/additionalProperties/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'object' },
                                                                                            message: 'must be object'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            var valid6 = _errs28 === errors;
                                                                            if (!valid6) {
                                                                                break;
                                                                            }
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate64.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/schema/properties',
                                                                                schemaPath: 'urn:wisepipe-common-connection:RestAuthEndpointSchema/properties/properties/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'object' },
                                                                                message: 'must be object'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                var valid4 = _errs25 === errors;
                                                            }
                                                            else {
                                                                var valid4 = true;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate64.errors = [
                                                    {
                                                        instancePath: instancePath + '/schema',
                                                        schemaPath: 'urn:wisepipe-common-connection:RestAuthEndpointSchema/type',
                                                        keyword: 'type',
                                                        params: { type: 'object' },
                                                        message: 'must be object'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate64.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate64.errors = vErrors;
    return errors === 0;
}
export const restAuthPaginationSchemaValidation = validate65;
const schema100 = {
    $id: 'urn:wisepipe-common-connection:RestAuthPagination',
    type: 'object',
    properties: {
        mode: { type: 'string', enum: ['none', 'paged', 'offset', 'cursor'] },
        firstPageNumber: { type: 'number' },
        lastPage: {
            type: 'object',
            properties: { mode: { type: 'string', enum: ['empty', 'error_code'] }, errorCode: { type: 'number' } },
            required: ['mode'],
            if: { properties: { mode: { const: 'error_code' } } },
            then: { required: ['errorCode'] }
        },
        requestPageLabel: { type: 'string' },
        requestPageSize: { type: 'number' },
        requestPageSizeLabel: { type: 'string' },
        pathToOffset: { type: 'string' },
        offsetLabel: { type: 'string' },
        cursorLabel: { type: 'string' }
    },
    required: ['mode'],
    allOf: [
        {
            if: { properties: { mode: { const: 'paged' } } },
            then: { required: ['firstPageNumber', 'lastPage', 'requestPageLabel'] }
        },
        {
            if: { properties: { mode: { const: 'offset' } } },
            then: { required: ['pathToOffset', 'lastPage', 'requestPageSize', 'requestPageSizeLabel', 'offsetLabel'] }
        },
        {
            if: { properties: { mode: { const: 'cursor' } } },
            then: { required: ['lastPage', 'requestPageSize', 'requestPageSizeLabel', 'cursorLabel'] }
        }
    ]
};
function validate65(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:RestAuthPagination" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    const _errs2 = errors;
    let valid1 = true;
    const _errs3 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.mode !== undefined) {
            if ('paged' !== data.mode) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs3 === errors;
    errors = _errs2;
    if (vErrors !== null) {
        if (_errs2) {
            vErrors.length = _errs2;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs5 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.firstPageNumber === undefined && (missing0 = 'firstPageNumber')) ||
                (data.lastPage === undefined && (missing0 = 'lastPage')) ||
                (data.requestPageLabel === undefined && (missing0 = 'requestPageLabel'))) {
                validate65.errors = [
                    {
                        instancePath,
                        schemaPath: '#/allOf/0/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs5 === errors;
        valid1 = _valid0;
    }
    if (!valid1) {
        const err1 = {
            instancePath,
            schemaPath: '#/allOf/0/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
        validate65.errors = vErrors;
        return false;
    }
    var valid0 = _errs1 === errors;
    if (valid0) {
        const _errs6 = errors;
        const _errs7 = errors;
        let valid3 = true;
        const _errs8 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.mode !== undefined) {
                if ('offset' !== data.mode) {
                    const err2 = {};
                    if (vErrors === null) {
                        vErrors = [err2];
                    }
                    else {
                        vErrors.push(err2);
                    }
                    errors++;
                }
            }
        }
        var _valid1 = _errs8 === errors;
        errors = _errs7;
        if (vErrors !== null) {
            if (_errs7) {
                vErrors.length = _errs7;
            }
            else {
                vErrors = null;
            }
        }
        if (_valid1) {
            const _errs10 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                let missing1;
                if ((data.pathToOffset === undefined && (missing1 = 'pathToOffset')) ||
                    (data.lastPage === undefined && (missing1 = 'lastPage')) ||
                    (data.requestPageSize === undefined && (missing1 = 'requestPageSize')) ||
                    (data.requestPageSizeLabel === undefined && (missing1 = 'requestPageSizeLabel')) ||
                    (data.offsetLabel === undefined && (missing1 = 'offsetLabel'))) {
                    validate65.errors = [
                        {
                            instancePath,
                            schemaPath: '#/allOf/1/then/required',
                            keyword: 'required',
                            params: { missingProperty: missing1 },
                            message: "must have required property '" + missing1 + "'"
                        }
                    ];
                    return false;
                }
            }
            var _valid1 = _errs10 === errors;
            valid3 = _valid1;
        }
        if (!valid3) {
            const err3 = {
                instancePath,
                schemaPath: '#/allOf/1/if',
                keyword: 'if',
                params: { failingKeyword: 'then' },
                message: 'must match "then" schema'
            };
            if (vErrors === null) {
                vErrors = [err3];
            }
            else {
                vErrors.push(err3);
            }
            errors++;
            validate65.errors = vErrors;
            return false;
        }
        var valid0 = _errs6 === errors;
        if (valid0) {
            const _errs11 = errors;
            const _errs12 = errors;
            let valid5 = true;
            const _errs13 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                if (data.mode !== undefined) {
                    if ('cursor' !== data.mode) {
                        const err4 = {};
                        if (vErrors === null) {
                            vErrors = [err4];
                        }
                        else {
                            vErrors.push(err4);
                        }
                        errors++;
                    }
                }
            }
            var _valid2 = _errs13 === errors;
            errors = _errs12;
            if (vErrors !== null) {
                if (_errs12) {
                    vErrors.length = _errs12;
                }
                else {
                    vErrors = null;
                }
            }
            if (_valid2) {
                const _errs15 = errors;
                if (data && typeof data == 'object' && !Array.isArray(data)) {
                    let missing2;
                    if ((data.lastPage === undefined && (missing2 = 'lastPage')) ||
                        (data.requestPageSize === undefined && (missing2 = 'requestPageSize')) ||
                        (data.requestPageSizeLabel === undefined && (missing2 = 'requestPageSizeLabel')) ||
                        (data.cursorLabel === undefined && (missing2 = 'cursorLabel'))) {
                        validate65.errors = [
                            {
                                instancePath,
                                schemaPath: '#/allOf/2/then/required',
                                keyword: 'required',
                                params: { missingProperty: missing2 },
                                message: "must have required property '" + missing2 + "'"
                            }
                        ];
                        return false;
                    }
                }
                var _valid2 = _errs15 === errors;
                valid5 = _valid2;
            }
            if (!valid5) {
                const err5 = {
                    instancePath,
                    schemaPath: '#/allOf/2/if',
                    keyword: 'if',
                    params: { failingKeyword: 'then' },
                    message: 'must match "then" schema'
                };
                if (vErrors === null) {
                    vErrors = [err5];
                }
                else {
                    vErrors.push(err5);
                }
                errors++;
                validate65.errors = vErrors;
                return false;
            }
            var valid0 = _errs11 === errors;
        }
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing3;
            if (data.mode === undefined && (missing3 = 'mode')) {
                validate65.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing3 },
                        message: "must have required property '" + missing3 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.mode !== undefined) {
                    let data3 = data.mode;
                    const _errs16 = errors;
                    if (typeof data3 !== 'string') {
                        validate65.errors = [
                            {
                                instancePath: instancePath + '/mode',
                                schemaPath: '#/properties/mode/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data3 === 'none' || data3 === 'paged' || data3 === 'offset' || data3 === 'cursor')) {
                        validate65.errors = [
                            {
                                instancePath: instancePath + '/mode',
                                schemaPath: '#/properties/mode/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema100.properties.mode.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid7 = _errs16 === errors;
                }
                else {
                    var valid7 = true;
                }
                if (valid7) {
                    if (data.firstPageNumber !== undefined) {
                        const _errs18 = errors;
                        if (!(typeof data.firstPageNumber == 'number')) {
                            validate65.errors = [
                                {
                                    instancePath: instancePath + '/firstPageNumber',
                                    schemaPath: '#/properties/firstPageNumber/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                        var valid7 = _errs18 === errors;
                    }
                    else {
                        var valid7 = true;
                    }
                    if (valid7) {
                        if (data.lastPage !== undefined) {
                            let data5 = data.lastPage;
                            const _errs20 = errors;
                            const _errs22 = errors;
                            let valid8 = true;
                            const _errs23 = errors;
                            if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
                                if (data5.mode !== undefined) {
                                    if ('error_code' !== data5.mode) {
                                        const err6 = {};
                                        if (vErrors === null) {
                                            vErrors = [err6];
                                        }
                                        else {
                                            vErrors.push(err6);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            var _valid3 = _errs23 === errors;
                            errors = _errs22;
                            if (vErrors !== null) {
                                if (_errs22) {
                                    vErrors.length = _errs22;
                                }
                                else {
                                    vErrors = null;
                                }
                            }
                            if (_valid3) {
                                const _errs25 = errors;
                                if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
                                    let missing4;
                                    if (data5.errorCode === undefined && (missing4 = 'errorCode')) {
                                        validate65.errors = [
                                            {
                                                instancePath: instancePath + '/lastPage',
                                                schemaPath: '#/properties/lastPage/then/required',
                                                keyword: 'required',
                                                params: { missingProperty: missing4 },
                                                message: "must have required property '" + missing4 + "'"
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var _valid3 = _errs25 === errors;
                                valid8 = _valid3;
                            }
                            if (!valid8) {
                                const err7 = {
                                    instancePath: instancePath + '/lastPage',
                                    schemaPath: '#/properties/lastPage/if',
                                    keyword: 'if',
                                    params: { failingKeyword: 'then' },
                                    message: 'must match "then" schema'
                                };
                                if (vErrors === null) {
                                    vErrors = [err7];
                                }
                                else {
                                    vErrors.push(err7);
                                }
                                errors++;
                                validate65.errors = vErrors;
                                return false;
                            }
                            if (errors === _errs20) {
                                if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
                                    let missing5;
                                    if (data5.mode === undefined && (missing5 = 'mode')) {
                                        validate65.errors = [
                                            {
                                                instancePath: instancePath + '/lastPage',
                                                schemaPath: '#/properties/lastPage/required',
                                                keyword: 'required',
                                                params: { missingProperty: missing5 },
                                                message: "must have required property '" + missing5 + "'"
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        if (data5.mode !== undefined) {
                                            let data7 = data5.mode;
                                            const _errs26 = errors;
                                            if (typeof data7 !== 'string') {
                                                validate65.errors = [
                                                    {
                                                        instancePath: instancePath + '/lastPage/mode',
                                                        schemaPath: '#/properties/lastPage/properties/mode/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            if (!(data7 === 'empty' || data7 === 'error_code')) {
                                                validate65.errors = [
                                                    {
                                                        instancePath: instancePath + '/lastPage/mode',
                                                        schemaPath: '#/properties/lastPage/properties/mode/enum',
                                                        keyword: 'enum',
                                                        params: { allowedValues: schema100.properties.lastPage.properties.mode.enum },
                                                        message: 'must be equal to one of the allowed values'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid10 = _errs26 === errors;
                                        }
                                        else {
                                            var valid10 = true;
                                        }
                                        if (valid10) {
                                            if (data5.errorCode !== undefined) {
                                                const _errs28 = errors;
                                                if (!(typeof data5.errorCode == 'number')) {
                                                    validate65.errors = [
                                                        {
                                                            instancePath: instancePath + '/lastPage/errorCode',
                                                            schemaPath: '#/properties/lastPage/properties/errorCode/type',
                                                            keyword: 'type',
                                                            params: { type: 'number' },
                                                            message: 'must be number'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid10 = _errs28 === errors;
                                            }
                                            else {
                                                var valid10 = true;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate65.errors = [
                                        {
                                            instancePath: instancePath + '/lastPage',
                                            schemaPath: '#/properties/lastPage/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid7 = _errs20 === errors;
                        }
                        else {
                            var valid7 = true;
                        }
                        if (valid7) {
                            if (data.requestPageLabel !== undefined) {
                                const _errs30 = errors;
                                if (typeof data.requestPageLabel !== 'string') {
                                    validate65.errors = [
                                        {
                                            instancePath: instancePath + '/requestPageLabel',
                                            schemaPath: '#/properties/requestPageLabel/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                var valid7 = _errs30 === errors;
                            }
                            else {
                                var valid7 = true;
                            }
                            if (valid7) {
                                if (data.requestPageSize !== undefined) {
                                    const _errs32 = errors;
                                    if (!(typeof data.requestPageSize == 'number')) {
                                        validate65.errors = [
                                            {
                                                instancePath: instancePath + '/requestPageSize',
                                                schemaPath: '#/properties/requestPageSize/type',
                                                keyword: 'type',
                                                params: { type: 'number' },
                                                message: 'must be number'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid7 = _errs32 === errors;
                                }
                                else {
                                    var valid7 = true;
                                }
                                if (valid7) {
                                    if (data.requestPageSizeLabel !== undefined) {
                                        const _errs34 = errors;
                                        if (typeof data.requestPageSizeLabel !== 'string') {
                                            validate65.errors = [
                                                {
                                                    instancePath: instancePath + '/requestPageSizeLabel',
                                                    schemaPath: '#/properties/requestPageSizeLabel/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid7 = _errs34 === errors;
                                    }
                                    else {
                                        var valid7 = true;
                                    }
                                    if (valid7) {
                                        if (data.pathToOffset !== undefined) {
                                            const _errs36 = errors;
                                            if (typeof data.pathToOffset !== 'string') {
                                                validate65.errors = [
                                                    {
                                                        instancePath: instancePath + '/pathToOffset',
                                                        schemaPath: '#/properties/pathToOffset/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid7 = _errs36 === errors;
                                        }
                                        else {
                                            var valid7 = true;
                                        }
                                        if (valid7) {
                                            if (data.offsetLabel !== undefined) {
                                                const _errs38 = errors;
                                                if (typeof data.offsetLabel !== 'string') {
                                                    validate65.errors = [
                                                        {
                                                            instancePath: instancePath + '/offsetLabel',
                                                            schemaPath: '#/properties/offsetLabel/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid7 = _errs38 === errors;
                                            }
                                            else {
                                                var valid7 = true;
                                            }
                                            if (valid7) {
                                                if (data.cursorLabel !== undefined) {
                                                    const _errs40 = errors;
                                                    if (typeof data.cursorLabel !== 'string') {
                                                        validate65.errors = [
                                                            {
                                                                instancePath: instancePath + '/cursorLabel',
                                                                schemaPath: '#/properties/cursorLabel/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid7 = _errs40 === errors;
                                                }
                                                else {
                                                    var valid7 = true;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate65.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate65.errors = vErrors;
    return errors === 0;
}
export const restAuthSchemaValidation = validate66;
const schema101 = {
    $id: 'urn:wisepipe-common-connection:RestAuth',
    type: 'object',
    properties: {
        auth: { $ref: 'urn:wisepipe-common-connection:RestAuthCredentials' },
        endpoints: { type: 'object', additionalProperties: { $ref: 'urn:wisepipe-common-connection:RestAuthEndpoint' } },
        pagination: { $ref: 'urn:wisepipe-common-connection:RestAuthPagination' },
        subType: {
            type: 'string',
            enum: [
                'netSuite',
                'sapSuccessFactors',
                'sapCrm',
                'ukg',
                'oracleHcm',
                'Adp',
                'dynamics365Sales',
                'ceridianDayforce',
                'oracleCrm',
                'oracleErpCloud',
                'sageIntacct',
                'bambooHr',
                'sapErp',
                'googleCloudPlatformCloudStorage',
                'sas',
                'oneDrive',
                'dropbox',
                'googleDrive',
                'jira',
                'monday',
                'zuora',
                'adobeAnalytics',
                'zoomInfo',
                'marketo',
                'activeCampaign',
                'mailchimp',
                'infor',
                'cornerstoneOnDemand',
                'gusto',
                'paychexFlex',
                'zendesk',
                'serviceNow',
                'zohoCrm',
                'pipedrive',
                'quickBooks',
                'xero',
                'freshbooks',
                'zohoBooks',
                'waveFinancial'
            ]
        }
    },
    required: ['auth', 'endpoints', 'pagination']
};
function validate66(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:RestAuth" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.auth === undefined && (missing0 = 'auth')) ||
                (data.endpoints === undefined && (missing0 = 'endpoints')) ||
                (data.pagination === undefined && (missing0 = 'pagination'))) {
                validate66.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.auth !== undefined) {
                    let data0 = data.auth;
                    const _errs1 = errors;
                    const _errs2 = errors;
                    const _errs4 = errors;
                    const _errs5 = errors;
                    let valid3 = true;
                    const _errs6 = errors;
                    if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                        if (data0.type !== undefined) {
                            if ('basic' !== data0.type) {
                                const err0 = {};
                                if (vErrors === null) {
                                    vErrors = [err0];
                                }
                                else {
                                    vErrors.push(err0);
                                }
                                errors++;
                            }
                        }
                    }
                    var _valid0 = _errs6 === errors;
                    errors = _errs5;
                    if (vErrors !== null) {
                        if (_errs5) {
                            vErrors.length = _errs5;
                        }
                        else {
                            vErrors = null;
                        }
                    }
                    if (_valid0) {
                        const _errs8 = errors;
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            let missing1;
                            if ((data0.userName === undefined && (missing1 = 'userName')) ||
                                (data0.password === undefined && (missing1 = 'password'))) {
                                validate66.errors = [
                                    {
                                        instancePath: instancePath + '/auth',
                                        schemaPath: 'urn:wisepipe-common-connection:RestAuthCredentials/allOf/0/then/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing1 },
                                        message: "must have required property '" + missing1 + "'"
                                    }
                                ];
                                return false;
                            }
                        }
                        var _valid0 = _errs8 === errors;
                        valid3 = _valid0;
                    }
                    if (!valid3) {
                        const err1 = {
                            instancePath: instancePath + '/auth',
                            schemaPath: 'urn:wisepipe-common-connection:RestAuthCredentials/allOf/0/if',
                            keyword: 'if',
                            params: { failingKeyword: 'then' },
                            message: 'must match "then" schema'
                        };
                        if (vErrors === null) {
                            vErrors = [err1];
                        }
                        else {
                            vErrors.push(err1);
                        }
                        errors++;
                        validate66.errors = vErrors;
                        return false;
                    }
                    var valid2 = _errs4 === errors;
                    if (valid2) {
                        const _errs9 = errors;
                        const _errs10 = errors;
                        let valid5 = true;
                        const _errs11 = errors;
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            if (data0.type !== undefined) {
                                if ('api_key' !== data0.type) {
                                    const err2 = {};
                                    if (vErrors === null) {
                                        vErrors = [err2];
                                    }
                                    else {
                                        vErrors.push(err2);
                                    }
                                    errors++;
                                }
                            }
                        }
                        var _valid1 = _errs11 === errors;
                        errors = _errs10;
                        if (vErrors !== null) {
                            if (_errs10) {
                                vErrors.length = _errs10;
                            }
                            else {
                                vErrors = null;
                            }
                        }
                        if (_valid1) {
                            const _errs13 = errors;
                            if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                                let missing2;
                                if (data0.authHeader === undefined && (missing2 = 'authHeader')) {
                                    validate66.errors = [
                                        {
                                            instancePath: instancePath + '/auth',
                                            schemaPath: 'urn:wisepipe-common-connection:RestAuthCredentials/allOf/1/then/required',
                                            keyword: 'required',
                                            params: { missingProperty: missing2 },
                                            message: "must have required property '" + missing2 + "'"
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var _valid1 = _errs13 === errors;
                            valid5 = _valid1;
                        }
                        if (!valid5) {
                            const err3 = {
                                instancePath: instancePath + '/auth',
                                schemaPath: 'urn:wisepipe-common-connection:RestAuthCredentials/allOf/1/if',
                                keyword: 'if',
                                params: { failingKeyword: 'then' },
                                message: 'must match "then" schema'
                            };
                            if (vErrors === null) {
                                vErrors = [err3];
                            }
                            else {
                                vErrors.push(err3);
                            }
                            errors++;
                            validate66.errors = vErrors;
                            return false;
                        }
                        var valid2 = _errs9 === errors;
                        if (valid2) {
                            const _errs14 = errors;
                            const _errs15 = errors;
                            let valid7 = true;
                            const _errs16 = errors;
                            if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                                if (data0.type !== undefined) {
                                    if ('oauth_client_credentials' !== data0.type) {
                                        const err4 = {};
                                        if (vErrors === null) {
                                            vErrors = [err4];
                                        }
                                        else {
                                            vErrors.push(err4);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            var _valid2 = _errs16 === errors;
                            errors = _errs15;
                            if (vErrors !== null) {
                                if (_errs15) {
                                    vErrors.length = _errs15;
                                }
                                else {
                                    vErrors = null;
                                }
                            }
                            if (_valid2) {
                                const _errs18 = errors;
                                if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                                    let missing3;
                                    if ((data0.tokenType === undefined && (missing3 = 'tokenType')) ||
                                        (data0.key === undefined && (missing3 = 'key')) ||
                                        (data0.secret === undefined && (missing3 = 'secret')) ||
                                        (data0.authUrl === undefined && (missing3 = 'authUrl'))) {
                                        validate66.errors = [
                                            {
                                                instancePath: instancePath + '/auth',
                                                schemaPath: 'urn:wisepipe-common-connection:RestAuthCredentials/allOf/2/then/required',
                                                keyword: 'required',
                                                params: { missingProperty: missing3 },
                                                message: "must have required property '" + missing3 + "'"
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var _valid2 = _errs18 === errors;
                                valid7 = _valid2;
                            }
                            if (!valid7) {
                                const err5 = {
                                    instancePath: instancePath + '/auth',
                                    schemaPath: 'urn:wisepipe-common-connection:RestAuthCredentials/allOf/2/if',
                                    keyword: 'if',
                                    params: { failingKeyword: 'then' },
                                    message: 'must match "then" schema'
                                };
                                if (vErrors === null) {
                                    vErrors = [err5];
                                }
                                else {
                                    vErrors.push(err5);
                                }
                                errors++;
                                validate66.errors = vErrors;
                                return false;
                            }
                            var valid2 = _errs14 === errors;
                            if (valid2) {
                                const _errs19 = errors;
                                const _errs20 = errors;
                                let valid9 = true;
                                const _errs21 = errors;
                                if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                                    if (data0.type !== undefined) {
                                        if ('oauth_client_code' !== data0.type) {
                                            const err6 = {};
                                            if (vErrors === null) {
                                                vErrors = [err6];
                                            }
                                            else {
                                                vErrors.push(err6);
                                            }
                                            errors++;
                                        }
                                    }
                                }
                                var _valid3 = _errs21 === errors;
                                errors = _errs20;
                                if (vErrors !== null) {
                                    if (_errs20) {
                                        vErrors.length = _errs20;
                                    }
                                    else {
                                        vErrors = null;
                                    }
                                }
                                if (_valid3) {
                                    const _errs23 = errors;
                                    if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                                        let missing4;
                                        if ((data0.clientID === undefined && (missing4 = 'clientID')) ||
                                            (data0.clientSecret === undefined && (missing4 = 'clientSecret')) ||
                                            (data0.tokenUrl === undefined && (missing4 = 'tokenUrl')) ||
                                            (data0.authUrl === undefined && (missing4 = 'authUrl')) ||
                                            (data0.redirectUri === undefined && (missing4 = 'redirectUri'))) {
                                            validate66.errors = [
                                                {
                                                    instancePath: instancePath + '/auth',
                                                    schemaPath: 'urn:wisepipe-common-connection:RestAuthCredentials/allOf/3/then/required',
                                                    keyword: 'required',
                                                    params: { missingProperty: missing4 },
                                                    message: "must have required property '" + missing4 + "'"
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var _valid3 = _errs23 === errors;
                                    valid9 = _valid3;
                                }
                                if (!valid9) {
                                    const err7 = {
                                        instancePath: instancePath + '/auth',
                                        schemaPath: 'urn:wisepipe-common-connection:RestAuthCredentials/allOf/3/if',
                                        keyword: 'if',
                                        params: { failingKeyword: 'then' },
                                        message: 'must match "then" schema'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err7];
                                    }
                                    else {
                                        vErrors.push(err7);
                                    }
                                    errors++;
                                    validate66.errors = vErrors;
                                    return false;
                                }
                                var valid2 = _errs19 === errors;
                            }
                        }
                    }
                    if (errors === _errs2) {
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            let missing5;
                            if (data0.type === undefined && (missing5 = 'type')) {
                                validate66.errors = [
                                    {
                                        instancePath: instancePath + '/auth',
                                        schemaPath: 'urn:wisepipe-common-connection:RestAuthCredentials/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing5 },
                                        message: "must have required property '" + missing5 + "'"
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0.type !== undefined) {
                                    let data5 = data0.type;
                                    const _errs24 = errors;
                                    if (typeof data5 !== 'string') {
                                        validate66.errors = [
                                            {
                                                instancePath: instancePath + '/auth/type',
                                                schemaPath: 'urn:wisepipe-common-connection:RestAuthCredentials/properties/type/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (!(data5 === 'none' ||
                                        data5 === 'basic' ||
                                        data5 === 'api_key' ||
                                        data5 === 'oauth_client_credentials' ||
                                        data5 === 'oauth_client_code')) {
                                        validate66.errors = [
                                            {
                                                instancePath: instancePath + '/auth/type',
                                                schemaPath: 'urn:wisepipe-common-connection:RestAuthCredentials/properties/type/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema96.properties.type.enum },
                                                message: 'must be equal to one of the allowed values'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid11 = _errs24 === errors;
                                }
                                else {
                                    var valid11 = true;
                                }
                                if (valid11) {
                                    if (data0.userName !== undefined) {
                                        const _errs26 = errors;
                                        if (typeof data0.userName !== 'string') {
                                            validate66.errors = [
                                                {
                                                    instancePath: instancePath + '/auth/userName',
                                                    schemaPath: 'urn:wisepipe-common-connection:RestAuthCredentials/properties/userName/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid11 = _errs26 === errors;
                                    }
                                    else {
                                        var valid11 = true;
                                    }
                                    if (valid11) {
                                        if (data0.password !== undefined) {
                                            const _errs28 = errors;
                                            if (typeof data0.password !== 'string') {
                                                validate66.errors = [
                                                    {
                                                        instancePath: instancePath + '/auth/password',
                                                        schemaPath: 'urn:wisepipe-common-connection:RestAuthCredentials/properties/password/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid11 = _errs28 === errors;
                                        }
                                        else {
                                            var valid11 = true;
                                        }
                                        if (valid11) {
                                            if (data0.authHeader !== undefined) {
                                                const _errs30 = errors;
                                                if (typeof data0.authHeader !== 'string') {
                                                    validate66.errors = [
                                                        {
                                                            instancePath: instancePath + '/auth/authHeader',
                                                            schemaPath: 'urn:wisepipe-common-connection:RestAuthCredentials/properties/authHeader/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid11 = _errs30 === errors;
                                            }
                                            else {
                                                var valid11 = true;
                                            }
                                            if (valid11) {
                                                if (data0.accessToken !== undefined) {
                                                    const _errs32 = errors;
                                                    if (typeof data0.accessToken !== 'string') {
                                                        validate66.errors = [
                                                            {
                                                                instancePath: instancePath + '/auth/accessToken',
                                                                schemaPath: 'urn:wisepipe-common-connection:RestAuthCredentials/properties/accessToken/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid11 = _errs32 === errors;
                                                }
                                                else {
                                                    var valid11 = true;
                                                }
                                                if (valid11) {
                                                    if (data0.refreshToken !== undefined) {
                                                        const _errs34 = errors;
                                                        if (typeof data0.refreshToken !== 'string') {
                                                            validate66.errors = [
                                                                {
                                                                    instancePath: instancePath + '/auth/refreshToken',
                                                                    schemaPath: 'urn:wisepipe-common-connection:RestAuthCredentials/properties/refreshToken/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid11 = _errs34 === errors;
                                                    }
                                                    else {
                                                        var valid11 = true;
                                                    }
                                                    if (valid11) {
                                                        if (data0.clientID !== undefined) {
                                                            const _errs36 = errors;
                                                            if (typeof data0.clientID !== 'string') {
                                                                validate66.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/auth/clientID',
                                                                        schemaPath: 'urn:wisepipe-common-connection:RestAuthCredentials/properties/clientID/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid11 = _errs36 === errors;
                                                        }
                                                        else {
                                                            var valid11 = true;
                                                        }
                                                        if (valid11) {
                                                            if (data0.clientSecret !== undefined) {
                                                                const _errs38 = errors;
                                                                if (typeof data0.clientSecret !== 'string') {
                                                                    validate66.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/auth/clientSecret',
                                                                            schemaPath: 'urn:wisepipe-common-connection:RestAuthCredentials/properties/clientSecret/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid11 = _errs38 === errors;
                                                            }
                                                            else {
                                                                var valid11 = true;
                                                            }
                                                            if (valid11) {
                                                                if (data0.tokenUrl !== undefined) {
                                                                    const _errs40 = errors;
                                                                    if (typeof data0.tokenUrl !== 'string') {
                                                                        validate66.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/auth/tokenUrl',
                                                                                schemaPath: 'urn:wisepipe-common-connection:RestAuthCredentials/properties/tokenUrl/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    var valid11 = _errs40 === errors;
                                                                }
                                                                else {
                                                                    var valid11 = true;
                                                                }
                                                                if (valid11) {
                                                                    if (data0.tokenType !== undefined) {
                                                                        const _errs42 = errors;
                                                                        if (typeof data0.tokenType !== 'string') {
                                                                            validate66.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/auth/tokenType',
                                                                                    schemaPath: 'urn:wisepipe-common-connection:RestAuthCredentials/properties/tokenType/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        var valid11 = _errs42 === errors;
                                                                    }
                                                                    else {
                                                                        var valid11 = true;
                                                                    }
                                                                    if (valid11) {
                                                                        if (data0.key !== undefined) {
                                                                            const _errs44 = errors;
                                                                            if (typeof data0.key !== 'string') {
                                                                                validate66.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/auth/key',
                                                                                        schemaPath: 'urn:wisepipe-common-connection:RestAuthCredentials/properties/key/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            var valid11 = _errs44 === errors;
                                                                        }
                                                                        else {
                                                                            var valid11 = true;
                                                                        }
                                                                        if (valid11) {
                                                                            if (data0.secret !== undefined) {
                                                                                const _errs46 = errors;
                                                                                if (typeof data0.secret !== 'string') {
                                                                                    validate66.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/auth/secret',
                                                                                            schemaPath: 'urn:wisepipe-common-connection:RestAuthCredentials/properties/secret/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'string' },
                                                                                            message: 'must be string'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                                var valid11 = _errs46 === errors;
                                                                            }
                                                                            else {
                                                                                var valid11 = true;
                                                                            }
                                                                            if (valid11) {
                                                                                if (data0.authUrl !== undefined) {
                                                                                    const _errs48 = errors;
                                                                                    if (typeof data0.authUrl !== 'string') {
                                                                                        validate66.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/auth/authUrl',
                                                                                                schemaPath: 'urn:wisepipe-common-connection:RestAuthCredentials/properties/authUrl/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'string' },
                                                                                                message: 'must be string'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                    var valid11 = _errs48 === errors;
                                                                                }
                                                                                else {
                                                                                    var valid11 = true;
                                                                                }
                                                                                if (valid11) {
                                                                                    if (data0.code !== undefined) {
                                                                                        const _errs50 = errors;
                                                                                        if (typeof data0.code !== 'string') {
                                                                                            validate66.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/auth/code',
                                                                                                    schemaPath: 'urn:wisepipe-common-connection:RestAuthCredentials/properties/code/type',
                                                                                                    keyword: 'type',
                                                                                                    params: { type: 'string' },
                                                                                                    message: 'must be string'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                        var valid11 = _errs50 === errors;
                                                                                    }
                                                                                    else {
                                                                                        var valid11 = true;
                                                                                    }
                                                                                    if (valid11) {
                                                                                        if (data0.redirectUri !== undefined) {
                                                                                            const _errs52 = errors;
                                                                                            if (typeof data0.redirectUri !== 'string') {
                                                                                                validate66.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/auth/redirectUri',
                                                                                                        schemaPath: 'urn:wisepipe-common-connection:RestAuthCredentials/properties/redirectUri/type',
                                                                                                        keyword: 'type',
                                                                                                        params: { type: 'string' },
                                                                                                        message: 'must be string'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                            var valid11 = _errs52 === errors;
                                                                                        }
                                                                                        else {
                                                                                            var valid11 = true;
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate66.errors = [
                                {
                                    instancePath: instancePath + '/auth',
                                    schemaPath: 'urn:wisepipe-common-connection:RestAuthCredentials/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.endpoints !== undefined) {
                        let data20 = data.endpoints;
                        const _errs54 = errors;
                        if (errors === _errs54) {
                            if (data20 && typeof data20 == 'object' && !Array.isArray(data20)) {
                                for (const key0 in data20) {
                                    const _errs57 = errors;
                                    if (!validate64(data20[key0], {
                                        instancePath: instancePath + '/endpoints/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                        parentData: data20,
                                        parentDataProperty: key0,
                                        rootData
                                    })) {
                                        vErrors = vErrors === null ? validate64.errors : vErrors.concat(validate64.errors);
                                        errors = vErrors.length;
                                    }
                                    var valid12 = _errs57 === errors;
                                    if (!valid12) {
                                        break;
                                    }
                                }
                            }
                            else {
                                validate66.errors = [
                                    {
                                        instancePath: instancePath + '/endpoints',
                                        schemaPath: '#/properties/endpoints/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs54 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.pagination !== undefined) {
                            let data22 = data.pagination;
                            const _errs58 = errors;
                            const _errs59 = errors;
                            const _errs61 = errors;
                            const _errs62 = errors;
                            let valid15 = true;
                            const _errs63 = errors;
                            if (data22 && typeof data22 == 'object' && !Array.isArray(data22)) {
                                if (data22.mode !== undefined) {
                                    if ('paged' !== data22.mode) {
                                        const err8 = {};
                                        if (vErrors === null) {
                                            vErrors = [err8];
                                        }
                                        else {
                                            vErrors.push(err8);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            var _valid4 = _errs63 === errors;
                            errors = _errs62;
                            if (vErrors !== null) {
                                if (_errs62) {
                                    vErrors.length = _errs62;
                                }
                                else {
                                    vErrors = null;
                                }
                            }
                            if (_valid4) {
                                const _errs65 = errors;
                                if (data22 && typeof data22 == 'object' && !Array.isArray(data22)) {
                                    let missing6;
                                    if ((data22.firstPageNumber === undefined && (missing6 = 'firstPageNumber')) ||
                                        (data22.lastPage === undefined && (missing6 = 'lastPage')) ||
                                        (data22.requestPageLabel === undefined && (missing6 = 'requestPageLabel'))) {
                                        validate66.errors = [
                                            {
                                                instancePath: instancePath + '/pagination',
                                                schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/allOf/0/then/required',
                                                keyword: 'required',
                                                params: { missingProperty: missing6 },
                                                message: "must have required property '" + missing6 + "'"
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var _valid4 = _errs65 === errors;
                                valid15 = _valid4;
                            }
                            if (!valid15) {
                                const err9 = {
                                    instancePath: instancePath + '/pagination',
                                    schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/allOf/0/if',
                                    keyword: 'if',
                                    params: { failingKeyword: 'then' },
                                    message: 'must match "then" schema'
                                };
                                if (vErrors === null) {
                                    vErrors = [err9];
                                }
                                else {
                                    vErrors.push(err9);
                                }
                                errors++;
                                validate66.errors = vErrors;
                                return false;
                            }
                            var valid14 = _errs61 === errors;
                            if (valid14) {
                                const _errs66 = errors;
                                const _errs67 = errors;
                                let valid17 = true;
                                const _errs68 = errors;
                                if (data22 && typeof data22 == 'object' && !Array.isArray(data22)) {
                                    if (data22.mode !== undefined) {
                                        if ('offset' !== data22.mode) {
                                            const err10 = {};
                                            if (vErrors === null) {
                                                vErrors = [err10];
                                            }
                                            else {
                                                vErrors.push(err10);
                                            }
                                            errors++;
                                        }
                                    }
                                }
                                var _valid5 = _errs68 === errors;
                                errors = _errs67;
                                if (vErrors !== null) {
                                    if (_errs67) {
                                        vErrors.length = _errs67;
                                    }
                                    else {
                                        vErrors = null;
                                    }
                                }
                                if (_valid5) {
                                    const _errs70 = errors;
                                    if (data22 && typeof data22 == 'object' && !Array.isArray(data22)) {
                                        let missing7;
                                        if ((data22.pathToOffset === undefined && (missing7 = 'pathToOffset')) ||
                                            (data22.lastPage === undefined && (missing7 = 'lastPage')) ||
                                            (data22.requestPageSize === undefined && (missing7 = 'requestPageSize')) ||
                                            (data22.requestPageSizeLabel === undefined && (missing7 = 'requestPageSizeLabel')) ||
                                            (data22.offsetLabel === undefined && (missing7 = 'offsetLabel'))) {
                                            validate66.errors = [
                                                {
                                                    instancePath: instancePath + '/pagination',
                                                    schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/allOf/1/then/required',
                                                    keyword: 'required',
                                                    params: { missingProperty: missing7 },
                                                    message: "must have required property '" + missing7 + "'"
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var _valid5 = _errs70 === errors;
                                    valid17 = _valid5;
                                }
                                if (!valid17) {
                                    const err11 = {
                                        instancePath: instancePath + '/pagination',
                                        schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/allOf/1/if',
                                        keyword: 'if',
                                        params: { failingKeyword: 'then' },
                                        message: 'must match "then" schema'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err11];
                                    }
                                    else {
                                        vErrors.push(err11);
                                    }
                                    errors++;
                                    validate66.errors = vErrors;
                                    return false;
                                }
                                var valid14 = _errs66 === errors;
                                if (valid14) {
                                    const _errs71 = errors;
                                    const _errs72 = errors;
                                    let valid19 = true;
                                    const _errs73 = errors;
                                    if (data22 && typeof data22 == 'object' && !Array.isArray(data22)) {
                                        if (data22.mode !== undefined) {
                                            if ('cursor' !== data22.mode) {
                                                const err12 = {};
                                                if (vErrors === null) {
                                                    vErrors = [err12];
                                                }
                                                else {
                                                    vErrors.push(err12);
                                                }
                                                errors++;
                                            }
                                        }
                                    }
                                    var _valid6 = _errs73 === errors;
                                    errors = _errs72;
                                    if (vErrors !== null) {
                                        if (_errs72) {
                                            vErrors.length = _errs72;
                                        }
                                        else {
                                            vErrors = null;
                                        }
                                    }
                                    if (_valid6) {
                                        const _errs75 = errors;
                                        if (data22 && typeof data22 == 'object' && !Array.isArray(data22)) {
                                            let missing8;
                                            if ((data22.lastPage === undefined && (missing8 = 'lastPage')) ||
                                                (data22.requestPageSize === undefined && (missing8 = 'requestPageSize')) ||
                                                (data22.requestPageSizeLabel === undefined && (missing8 = 'requestPageSizeLabel')) ||
                                                (data22.cursorLabel === undefined && (missing8 = 'cursorLabel'))) {
                                                validate66.errors = [
                                                    {
                                                        instancePath: instancePath + '/pagination',
                                                        schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/allOf/2/then/required',
                                                        keyword: 'required',
                                                        params: { missingProperty: missing8 },
                                                        message: "must have required property '" + missing8 + "'"
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var _valid6 = _errs75 === errors;
                                        valid19 = _valid6;
                                    }
                                    if (!valid19) {
                                        const err13 = {
                                            instancePath: instancePath + '/pagination',
                                            schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/allOf/2/if',
                                            keyword: 'if',
                                            params: { failingKeyword: 'then' },
                                            message: 'must match "then" schema'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err13];
                                        }
                                        else {
                                            vErrors.push(err13);
                                        }
                                        errors++;
                                        validate66.errors = vErrors;
                                        return false;
                                    }
                                    var valid14 = _errs71 === errors;
                                }
                            }
                            if (errors === _errs59) {
                                if (data22 && typeof data22 == 'object' && !Array.isArray(data22)) {
                                    let missing9;
                                    if (data22.mode === undefined && (missing9 = 'mode')) {
                                        validate66.errors = [
                                            {
                                                instancePath: instancePath + '/pagination',
                                                schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/required',
                                                keyword: 'required',
                                                params: { missingProperty: missing9 },
                                                message: "must have required property '" + missing9 + "'"
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        if (data22.mode !== undefined) {
                                            let data26 = data22.mode;
                                            const _errs76 = errors;
                                            if (typeof data26 !== 'string') {
                                                validate66.errors = [
                                                    {
                                                        instancePath: instancePath + '/pagination/mode',
                                                        schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/properties/mode/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            if (!(data26 === 'none' || data26 === 'paged' || data26 === 'offset' || data26 === 'cursor')) {
                                                validate66.errors = [
                                                    {
                                                        instancePath: instancePath + '/pagination/mode',
                                                        schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/properties/mode/enum',
                                                        keyword: 'enum',
                                                        params: { allowedValues: schema100.properties.mode.enum },
                                                        message: 'must be equal to one of the allowed values'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid21 = _errs76 === errors;
                                        }
                                        else {
                                            var valid21 = true;
                                        }
                                        if (valid21) {
                                            if (data22.firstPageNumber !== undefined) {
                                                const _errs78 = errors;
                                                if (!(typeof data22.firstPageNumber == 'number')) {
                                                    validate66.errors = [
                                                        {
                                                            instancePath: instancePath + '/pagination/firstPageNumber',
                                                            schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/properties/firstPageNumber/type',
                                                            keyword: 'type',
                                                            params: { type: 'number' },
                                                            message: 'must be number'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid21 = _errs78 === errors;
                                            }
                                            else {
                                                var valid21 = true;
                                            }
                                            if (valid21) {
                                                if (data22.lastPage !== undefined) {
                                                    let data28 = data22.lastPage;
                                                    const _errs80 = errors;
                                                    const _errs82 = errors;
                                                    let valid22 = true;
                                                    const _errs83 = errors;
                                                    if (data28 && typeof data28 == 'object' && !Array.isArray(data28)) {
                                                        if (data28.mode !== undefined) {
                                                            if ('error_code' !== data28.mode) {
                                                                const err14 = {};
                                                                if (vErrors === null) {
                                                                    vErrors = [err14];
                                                                }
                                                                else {
                                                                    vErrors.push(err14);
                                                                }
                                                                errors++;
                                                            }
                                                        }
                                                    }
                                                    var _valid7 = _errs83 === errors;
                                                    errors = _errs82;
                                                    if (vErrors !== null) {
                                                        if (_errs82) {
                                                            vErrors.length = _errs82;
                                                        }
                                                        else {
                                                            vErrors = null;
                                                        }
                                                    }
                                                    if (_valid7) {
                                                        const _errs85 = errors;
                                                        if (data28 && typeof data28 == 'object' && !Array.isArray(data28)) {
                                                            let missing10;
                                                            if (data28.errorCode === undefined && (missing10 = 'errorCode')) {
                                                                validate66.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/pagination/lastPage',
                                                                        schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/properties/lastPage/then/required',
                                                                        keyword: 'required',
                                                                        params: { missingProperty: missing10 },
                                                                        message: "must have required property '" + missing10 + "'"
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var _valid7 = _errs85 === errors;
                                                        valid22 = _valid7;
                                                    }
                                                    if (!valid22) {
                                                        const err15 = {
                                                            instancePath: instancePath + '/pagination/lastPage',
                                                            schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/properties/lastPage/if',
                                                            keyword: 'if',
                                                            params: { failingKeyword: 'then' },
                                                            message: 'must match "then" schema'
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err15];
                                                        }
                                                        else {
                                                            vErrors.push(err15);
                                                        }
                                                        errors++;
                                                        validate66.errors = vErrors;
                                                        return false;
                                                    }
                                                    if (errors === _errs80) {
                                                        if (data28 && typeof data28 == 'object' && !Array.isArray(data28)) {
                                                            let missing11;
                                                            if (data28.mode === undefined && (missing11 = 'mode')) {
                                                                validate66.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/pagination/lastPage',
                                                                        schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/properties/lastPage/required',
                                                                        keyword: 'required',
                                                                        params: { missingProperty: missing11 },
                                                                        message: "must have required property '" + missing11 + "'"
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                if (data28.mode !== undefined) {
                                                                    let data30 = data28.mode;
                                                                    const _errs86 = errors;
                                                                    if (typeof data30 !== 'string') {
                                                                        validate66.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/pagination/lastPage/mode',
                                                                                schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/properties/lastPage/properties/mode/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    if (!(data30 === 'empty' || data30 === 'error_code')) {
                                                                        validate66.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/pagination/lastPage/mode',
                                                                                schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/properties/lastPage/properties/mode/enum',
                                                                                keyword: 'enum',
                                                                                params: { allowedValues: schema100.properties.lastPage.properties.mode.enum },
                                                                                message: 'must be equal to one of the allowed values'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    var valid24 = _errs86 === errors;
                                                                }
                                                                else {
                                                                    var valid24 = true;
                                                                }
                                                                if (valid24) {
                                                                    if (data28.errorCode !== undefined) {
                                                                        const _errs88 = errors;
                                                                        if (!(typeof data28.errorCode == 'number')) {
                                                                            validate66.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/pagination/lastPage/errorCode',
                                                                                    schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/properties/lastPage/properties/errorCode/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'number' },
                                                                                    message: 'must be number'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        var valid24 = _errs88 === errors;
                                                                    }
                                                                    else {
                                                                        var valid24 = true;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                        else {
                                                            validate66.errors = [
                                                                {
                                                                    instancePath: instancePath + '/pagination/lastPage',
                                                                    schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/properties/lastPage/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'object' },
                                                                    message: 'must be object'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid21 = _errs80 === errors;
                                                }
                                                else {
                                                    var valid21 = true;
                                                }
                                                if (valid21) {
                                                    if (data22.requestPageLabel !== undefined) {
                                                        const _errs90 = errors;
                                                        if (typeof data22.requestPageLabel !== 'string') {
                                                            validate66.errors = [
                                                                {
                                                                    instancePath: instancePath + '/pagination/requestPageLabel',
                                                                    schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/properties/requestPageLabel/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid21 = _errs90 === errors;
                                                    }
                                                    else {
                                                        var valid21 = true;
                                                    }
                                                    if (valid21) {
                                                        if (data22.requestPageSize !== undefined) {
                                                            const _errs92 = errors;
                                                            if (!(typeof data22.requestPageSize == 'number')) {
                                                                validate66.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/pagination/requestPageSize',
                                                                        schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/properties/requestPageSize/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'number' },
                                                                        message: 'must be number'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid21 = _errs92 === errors;
                                                        }
                                                        else {
                                                            var valid21 = true;
                                                        }
                                                        if (valid21) {
                                                            if (data22.requestPageSizeLabel !== undefined) {
                                                                const _errs94 = errors;
                                                                if (typeof data22.requestPageSizeLabel !== 'string') {
                                                                    validate66.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/pagination/requestPageSizeLabel',
                                                                            schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/properties/requestPageSizeLabel/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid21 = _errs94 === errors;
                                                            }
                                                            else {
                                                                var valid21 = true;
                                                            }
                                                            if (valid21) {
                                                                if (data22.pathToOffset !== undefined) {
                                                                    const _errs96 = errors;
                                                                    if (typeof data22.pathToOffset !== 'string') {
                                                                        validate66.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/pagination/pathToOffset',
                                                                                schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/properties/pathToOffset/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    var valid21 = _errs96 === errors;
                                                                }
                                                                else {
                                                                    var valid21 = true;
                                                                }
                                                                if (valid21) {
                                                                    if (data22.offsetLabel !== undefined) {
                                                                        const _errs98 = errors;
                                                                        if (typeof data22.offsetLabel !== 'string') {
                                                                            validate66.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/pagination/offsetLabel',
                                                                                    schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/properties/offsetLabel/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        var valid21 = _errs98 === errors;
                                                                    }
                                                                    else {
                                                                        var valid21 = true;
                                                                    }
                                                                    if (valid21) {
                                                                        if (data22.cursorLabel !== undefined) {
                                                                            const _errs100 = errors;
                                                                            if (typeof data22.cursorLabel !== 'string') {
                                                                                validate66.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/pagination/cursorLabel',
                                                                                        schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/properties/cursorLabel/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            var valid21 = _errs100 === errors;
                                                                        }
                                                                        else {
                                                                            var valid21 = true;
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate66.errors = [
                                        {
                                            instancePath: instancePath + '/pagination',
                                            schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs58 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.subType !== undefined) {
                                let data38 = data.subType;
                                const _errs102 = errors;
                                if (typeof data38 !== 'string') {
                                    validate66.errors = [
                                        {
                                            instancePath: instancePath + '/subType',
                                            schemaPath: '#/properties/subType/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                if (!(data38 === 'netSuite' ||
                                    data38 === 'sapSuccessFactors' ||
                                    data38 === 'sapCrm' ||
                                    data38 === 'ukg' ||
                                    data38 === 'oracleHcm' ||
                                    data38 === 'Adp' ||
                                    data38 === 'dynamics365Sales' ||
                                    data38 === 'ceridianDayforce' ||
                                    data38 === 'oracleCrm' ||
                                    data38 === 'oracleErpCloud' ||
                                    data38 === 'sageIntacct' ||
                                    data38 === 'bambooHr' ||
                                    data38 === 'sapErp' ||
                                    data38 === 'googleCloudPlatformCloudStorage' ||
                                    data38 === 'sas' ||
                                    data38 === 'oneDrive' ||
                                    data38 === 'dropbox' ||
                                    data38 === 'googleDrive' ||
                                    data38 === 'jira' ||
                                    data38 === 'monday' ||
                                    data38 === 'zuora' ||
                                    data38 === 'adobeAnalytics' ||
                                    data38 === 'zoomInfo' ||
                                    data38 === 'marketo' ||
                                    data38 === 'activeCampaign' ||
                                    data38 === 'mailchimp' ||
                                    data38 === 'infor' ||
                                    data38 === 'cornerstoneOnDemand' ||
                                    data38 === 'gusto' ||
                                    data38 === 'paychexFlex' ||
                                    data38 === 'zendesk' ||
                                    data38 === 'serviceNow' ||
                                    data38 === 'zohoCrm' ||
                                    data38 === 'pipedrive' ||
                                    data38 === 'quickBooks' ||
                                    data38 === 'xero' ||
                                    data38 === 'freshbooks' ||
                                    data38 === 'zohoBooks' ||
                                    data38 === 'waveFinancial')) {
                                    validate66.errors = [
                                        {
                                            instancePath: instancePath + '/subType',
                                            schemaPath: '#/properties/subType/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema101.properties.subType.enum },
                                            message: 'must be equal to one of the allowed values'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs102 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate66.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate66.errors = vErrors;
    return errors === 0;
}
export const restConnectionSchemaValidation = validate68;
const schema104 = {
    $id: 'urn:wisepipe-common-connection:RestConnection',
    type: 'object',
    properties: {
        endpoints: { type: 'object', additionalProperties: { $ref: 'urn:wisepipe-common-connection:RestAuthEndpoint' } },
        pagination: { $ref: 'urn:wisepipe-common-connection:RestAuthPagination' },
        subType: {
            type: 'string',
            enum: [
                'netSuite',
                'sapSuccessFactors',
                'sapCrm',
                'ukg',
                'oracleHcm',
                'Adp',
                'dynamics365Sales',
                'ceridianDayforce',
                'oracleCrm',
                'oracleErpCloud',
                'sageIntacct',
                'bambooHr',
                'sapErp',
                'googleCloudPlatformCloudStorage',
                'sas',
                'oneDrive',
                'dropbox',
                'googleDrive',
                'jira',
                'monday',
                'zuora',
                'adobeAnalytics',
                'zoomInfo',
                'marketo',
                'activeCampaign',
                'mailchimp',
                'infor',
                'cornerstoneOnDemand',
                'gusto',
                'paychexFlex',
                'zendesk',
                'serviceNow',
                'zohoCrm',
                'pipedrive',
                'quickBooks',
                'xero',
                'freshbooks',
                'zohoBooks',
                'waveFinancial'
            ]
        },
        authType: { type: 'string', enum: ['none', 'basic', 'api_key', 'oauth_client_credentials', 'oauth_client_code'] }
    },
    required: ['endpoints', 'pagination']
};
function validate68(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:RestConnection" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.endpoints === undefined && (missing0 = 'endpoints')) ||
                (data.pagination === undefined && (missing0 = 'pagination'))) {
                validate68.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.endpoints !== undefined) {
                    let data0 = data.endpoints;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            for (const key0 in data0) {
                                const _errs4 = errors;
                                if (!validate64(data0[key0], {
                                    instancePath: instancePath + '/endpoints/' + key0.replace(/~/g, '~0').replace(/\//g, '~1'),
                                    parentData: data0,
                                    parentDataProperty: key0,
                                    rootData
                                })) {
                                    vErrors = vErrors === null ? validate64.errors : vErrors.concat(validate64.errors);
                                    errors = vErrors.length;
                                }
                                var valid1 = _errs4 === errors;
                                if (!valid1) {
                                    break;
                                }
                            }
                        }
                        else {
                            validate68.errors = [
                                {
                                    instancePath: instancePath + '/endpoints',
                                    schemaPath: '#/properties/endpoints/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.pagination !== undefined) {
                        let data2 = data.pagination;
                        const _errs5 = errors;
                        const _errs6 = errors;
                        const _errs8 = errors;
                        const _errs9 = errors;
                        let valid4 = true;
                        const _errs10 = errors;
                        if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                            if (data2.mode !== undefined) {
                                if ('paged' !== data2.mode) {
                                    const err0 = {};
                                    if (vErrors === null) {
                                        vErrors = [err0];
                                    }
                                    else {
                                        vErrors.push(err0);
                                    }
                                    errors++;
                                }
                            }
                        }
                        var _valid0 = _errs10 === errors;
                        errors = _errs9;
                        if (vErrors !== null) {
                            if (_errs9) {
                                vErrors.length = _errs9;
                            }
                            else {
                                vErrors = null;
                            }
                        }
                        if (_valid0) {
                            const _errs12 = errors;
                            if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                let missing1;
                                if ((data2.firstPageNumber === undefined && (missing1 = 'firstPageNumber')) ||
                                    (data2.lastPage === undefined && (missing1 = 'lastPage')) ||
                                    (data2.requestPageLabel === undefined && (missing1 = 'requestPageLabel'))) {
                                    validate68.errors = [
                                        {
                                            instancePath: instancePath + '/pagination',
                                            schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/allOf/0/then/required',
                                            keyword: 'required',
                                            params: { missingProperty: missing1 },
                                            message: "must have required property '" + missing1 + "'"
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var _valid0 = _errs12 === errors;
                            valid4 = _valid0;
                        }
                        if (!valid4) {
                            const err1 = {
                                instancePath: instancePath + '/pagination',
                                schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/allOf/0/if',
                                keyword: 'if',
                                params: { failingKeyword: 'then' },
                                message: 'must match "then" schema'
                            };
                            if (vErrors === null) {
                                vErrors = [err1];
                            }
                            else {
                                vErrors.push(err1);
                            }
                            errors++;
                            validate68.errors = vErrors;
                            return false;
                        }
                        var valid3 = _errs8 === errors;
                        if (valid3) {
                            const _errs13 = errors;
                            const _errs14 = errors;
                            let valid6 = true;
                            const _errs15 = errors;
                            if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                if (data2.mode !== undefined) {
                                    if ('offset' !== data2.mode) {
                                        const err2 = {};
                                        if (vErrors === null) {
                                            vErrors = [err2];
                                        }
                                        else {
                                            vErrors.push(err2);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            var _valid1 = _errs15 === errors;
                            errors = _errs14;
                            if (vErrors !== null) {
                                if (_errs14) {
                                    vErrors.length = _errs14;
                                }
                                else {
                                    vErrors = null;
                                }
                            }
                            if (_valid1) {
                                const _errs17 = errors;
                                if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                    let missing2;
                                    if ((data2.pathToOffset === undefined && (missing2 = 'pathToOffset')) ||
                                        (data2.lastPage === undefined && (missing2 = 'lastPage')) ||
                                        (data2.requestPageSize === undefined && (missing2 = 'requestPageSize')) ||
                                        (data2.requestPageSizeLabel === undefined && (missing2 = 'requestPageSizeLabel')) ||
                                        (data2.offsetLabel === undefined && (missing2 = 'offsetLabel'))) {
                                        validate68.errors = [
                                            {
                                                instancePath: instancePath + '/pagination',
                                                schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/allOf/1/then/required',
                                                keyword: 'required',
                                                params: { missingProperty: missing2 },
                                                message: "must have required property '" + missing2 + "'"
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var _valid1 = _errs17 === errors;
                                valid6 = _valid1;
                            }
                            if (!valid6) {
                                const err3 = {
                                    instancePath: instancePath + '/pagination',
                                    schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/allOf/1/if',
                                    keyword: 'if',
                                    params: { failingKeyword: 'then' },
                                    message: 'must match "then" schema'
                                };
                                if (vErrors === null) {
                                    vErrors = [err3];
                                }
                                else {
                                    vErrors.push(err3);
                                }
                                errors++;
                                validate68.errors = vErrors;
                                return false;
                            }
                            var valid3 = _errs13 === errors;
                            if (valid3) {
                                const _errs18 = errors;
                                const _errs19 = errors;
                                let valid8 = true;
                                const _errs20 = errors;
                                if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                    if (data2.mode !== undefined) {
                                        if ('cursor' !== data2.mode) {
                                            const err4 = {};
                                            if (vErrors === null) {
                                                vErrors = [err4];
                                            }
                                            else {
                                                vErrors.push(err4);
                                            }
                                            errors++;
                                        }
                                    }
                                }
                                var _valid2 = _errs20 === errors;
                                errors = _errs19;
                                if (vErrors !== null) {
                                    if (_errs19) {
                                        vErrors.length = _errs19;
                                    }
                                    else {
                                        vErrors = null;
                                    }
                                }
                                if (_valid2) {
                                    const _errs22 = errors;
                                    if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                        let missing3;
                                        if ((data2.lastPage === undefined && (missing3 = 'lastPage')) ||
                                            (data2.requestPageSize === undefined && (missing3 = 'requestPageSize')) ||
                                            (data2.requestPageSizeLabel === undefined && (missing3 = 'requestPageSizeLabel')) ||
                                            (data2.cursorLabel === undefined && (missing3 = 'cursorLabel'))) {
                                            validate68.errors = [
                                                {
                                                    instancePath: instancePath + '/pagination',
                                                    schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/allOf/2/then/required',
                                                    keyword: 'required',
                                                    params: { missingProperty: missing3 },
                                                    message: "must have required property '" + missing3 + "'"
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var _valid2 = _errs22 === errors;
                                    valid8 = _valid2;
                                }
                                if (!valid8) {
                                    const err5 = {
                                        instancePath: instancePath + '/pagination',
                                        schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/allOf/2/if',
                                        keyword: 'if',
                                        params: { failingKeyword: 'then' },
                                        message: 'must match "then" schema'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err5];
                                    }
                                    else {
                                        vErrors.push(err5);
                                    }
                                    errors++;
                                    validate68.errors = vErrors;
                                    return false;
                                }
                                var valid3 = _errs18 === errors;
                            }
                        }
                        if (errors === _errs6) {
                            if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                let missing4;
                                if (data2.mode === undefined && (missing4 = 'mode')) {
                                    validate68.errors = [
                                        {
                                            instancePath: instancePath + '/pagination',
                                            schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/required',
                                            keyword: 'required',
                                            params: { missingProperty: missing4 },
                                            message: "must have required property '" + missing4 + "'"
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (data2.mode !== undefined) {
                                        let data6 = data2.mode;
                                        const _errs23 = errors;
                                        if (typeof data6 !== 'string') {
                                            validate68.errors = [
                                                {
                                                    instancePath: instancePath + '/pagination/mode',
                                                    schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/properties/mode/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        if (!(data6 === 'none' || data6 === 'paged' || data6 === 'offset' || data6 === 'cursor')) {
                                            validate68.errors = [
                                                {
                                                    instancePath: instancePath + '/pagination/mode',
                                                    schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/properties/mode/enum',
                                                    keyword: 'enum',
                                                    params: { allowedValues: schema100.properties.mode.enum },
                                                    message: 'must be equal to one of the allowed values'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid10 = _errs23 === errors;
                                    }
                                    else {
                                        var valid10 = true;
                                    }
                                    if (valid10) {
                                        if (data2.firstPageNumber !== undefined) {
                                            const _errs25 = errors;
                                            if (!(typeof data2.firstPageNumber == 'number')) {
                                                validate68.errors = [
                                                    {
                                                        instancePath: instancePath + '/pagination/firstPageNumber',
                                                        schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/properties/firstPageNumber/type',
                                                        keyword: 'type',
                                                        params: { type: 'number' },
                                                        message: 'must be number'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid10 = _errs25 === errors;
                                        }
                                        else {
                                            var valid10 = true;
                                        }
                                        if (valid10) {
                                            if (data2.lastPage !== undefined) {
                                                let data8 = data2.lastPage;
                                                const _errs27 = errors;
                                                const _errs29 = errors;
                                                let valid11 = true;
                                                const _errs30 = errors;
                                                if (data8 && typeof data8 == 'object' && !Array.isArray(data8)) {
                                                    if (data8.mode !== undefined) {
                                                        if ('error_code' !== data8.mode) {
                                                            const err6 = {};
                                                            if (vErrors === null) {
                                                                vErrors = [err6];
                                                            }
                                                            else {
                                                                vErrors.push(err6);
                                                            }
                                                            errors++;
                                                        }
                                                    }
                                                }
                                                var _valid3 = _errs30 === errors;
                                                errors = _errs29;
                                                if (vErrors !== null) {
                                                    if (_errs29) {
                                                        vErrors.length = _errs29;
                                                    }
                                                    else {
                                                        vErrors = null;
                                                    }
                                                }
                                                if (_valid3) {
                                                    const _errs32 = errors;
                                                    if (data8 && typeof data8 == 'object' && !Array.isArray(data8)) {
                                                        let missing5;
                                                        if (data8.errorCode === undefined && (missing5 = 'errorCode')) {
                                                            validate68.errors = [
                                                                {
                                                                    instancePath: instancePath + '/pagination/lastPage',
                                                                    schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/properties/lastPage/then/required',
                                                                    keyword: 'required',
                                                                    params: { missingProperty: missing5 },
                                                                    message: "must have required property '" + missing5 + "'"
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var _valid3 = _errs32 === errors;
                                                    valid11 = _valid3;
                                                }
                                                if (!valid11) {
                                                    const err7 = {
                                                        instancePath: instancePath + '/pagination/lastPage',
                                                        schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/properties/lastPage/if',
                                                        keyword: 'if',
                                                        params: { failingKeyword: 'then' },
                                                        message: 'must match "then" schema'
                                                    };
                                                    if (vErrors === null) {
                                                        vErrors = [err7];
                                                    }
                                                    else {
                                                        vErrors.push(err7);
                                                    }
                                                    errors++;
                                                    validate68.errors = vErrors;
                                                    return false;
                                                }
                                                if (errors === _errs27) {
                                                    if (data8 && typeof data8 == 'object' && !Array.isArray(data8)) {
                                                        let missing6;
                                                        if (data8.mode === undefined && (missing6 = 'mode')) {
                                                            validate68.errors = [
                                                                {
                                                                    instancePath: instancePath + '/pagination/lastPage',
                                                                    schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/properties/lastPage/required',
                                                                    keyword: 'required',
                                                                    params: { missingProperty: missing6 },
                                                                    message: "must have required property '" + missing6 + "'"
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        else {
                                                            if (data8.mode !== undefined) {
                                                                let data10 = data8.mode;
                                                                const _errs33 = errors;
                                                                if (typeof data10 !== 'string') {
                                                                    validate68.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/pagination/lastPage/mode',
                                                                            schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/properties/lastPage/properties/mode/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                if (!(data10 === 'empty' || data10 === 'error_code')) {
                                                                    validate68.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/pagination/lastPage/mode',
                                                                            schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/properties/lastPage/properties/mode/enum',
                                                                            keyword: 'enum',
                                                                            params: { allowedValues: schema100.properties.lastPage.properties.mode.enum },
                                                                            message: 'must be equal to one of the allowed values'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid13 = _errs33 === errors;
                                                            }
                                                            else {
                                                                var valid13 = true;
                                                            }
                                                            if (valid13) {
                                                                if (data8.errorCode !== undefined) {
                                                                    const _errs35 = errors;
                                                                    if (!(typeof data8.errorCode == 'number')) {
                                                                        validate68.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/pagination/lastPage/errorCode',
                                                                                schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/properties/lastPage/properties/errorCode/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'number' },
                                                                                message: 'must be number'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    var valid13 = _errs35 === errors;
                                                                }
                                                                else {
                                                                    var valid13 = true;
                                                                }
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate68.errors = [
                                                            {
                                                                instancePath: instancePath + '/pagination/lastPage',
                                                                schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/properties/lastPage/type',
                                                                keyword: 'type',
                                                                params: { type: 'object' },
                                                                message: 'must be object'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid10 = _errs27 === errors;
                                            }
                                            else {
                                                var valid10 = true;
                                            }
                                            if (valid10) {
                                                if (data2.requestPageLabel !== undefined) {
                                                    const _errs37 = errors;
                                                    if (typeof data2.requestPageLabel !== 'string') {
                                                        validate68.errors = [
                                                            {
                                                                instancePath: instancePath + '/pagination/requestPageLabel',
                                                                schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/properties/requestPageLabel/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid10 = _errs37 === errors;
                                                }
                                                else {
                                                    var valid10 = true;
                                                }
                                                if (valid10) {
                                                    if (data2.requestPageSize !== undefined) {
                                                        const _errs39 = errors;
                                                        if (!(typeof data2.requestPageSize == 'number')) {
                                                            validate68.errors = [
                                                                {
                                                                    instancePath: instancePath + '/pagination/requestPageSize',
                                                                    schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/properties/requestPageSize/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'number' },
                                                                    message: 'must be number'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid10 = _errs39 === errors;
                                                    }
                                                    else {
                                                        var valid10 = true;
                                                    }
                                                    if (valid10) {
                                                        if (data2.requestPageSizeLabel !== undefined) {
                                                            const _errs41 = errors;
                                                            if (typeof data2.requestPageSizeLabel !== 'string') {
                                                                validate68.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/pagination/requestPageSizeLabel',
                                                                        schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/properties/requestPageSizeLabel/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid10 = _errs41 === errors;
                                                        }
                                                        else {
                                                            var valid10 = true;
                                                        }
                                                        if (valid10) {
                                                            if (data2.pathToOffset !== undefined) {
                                                                const _errs43 = errors;
                                                                if (typeof data2.pathToOffset !== 'string') {
                                                                    validate68.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/pagination/pathToOffset',
                                                                            schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/properties/pathToOffset/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid10 = _errs43 === errors;
                                                            }
                                                            else {
                                                                var valid10 = true;
                                                            }
                                                            if (valid10) {
                                                                if (data2.offsetLabel !== undefined) {
                                                                    const _errs45 = errors;
                                                                    if (typeof data2.offsetLabel !== 'string') {
                                                                        validate68.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/pagination/offsetLabel',
                                                                                schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/properties/offsetLabel/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    var valid10 = _errs45 === errors;
                                                                }
                                                                else {
                                                                    var valid10 = true;
                                                                }
                                                                if (valid10) {
                                                                    if (data2.cursorLabel !== undefined) {
                                                                        const _errs47 = errors;
                                                                        if (typeof data2.cursorLabel !== 'string') {
                                                                            validate68.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/pagination/cursorLabel',
                                                                                    schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/properties/cursorLabel/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        var valid10 = _errs47 === errors;
                                                                    }
                                                                    else {
                                                                        var valid10 = true;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                validate68.errors = [
                                    {
                                        instancePath: instancePath + '/pagination',
                                        schemaPath: 'urn:wisepipe-common-connection:RestAuthPagination/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs5 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.subType !== undefined) {
                            let data18 = data.subType;
                            const _errs49 = errors;
                            if (typeof data18 !== 'string') {
                                validate68.errors = [
                                    {
                                        instancePath: instancePath + '/subType',
                                        schemaPath: '#/properties/subType/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            if (!(data18 === 'netSuite' ||
                                data18 === 'sapSuccessFactors' ||
                                data18 === 'sapCrm' ||
                                data18 === 'ukg' ||
                                data18 === 'oracleHcm' ||
                                data18 === 'Adp' ||
                                data18 === 'dynamics365Sales' ||
                                data18 === 'ceridianDayforce' ||
                                data18 === 'oracleCrm' ||
                                data18 === 'oracleErpCloud' ||
                                data18 === 'sageIntacct' ||
                                data18 === 'bambooHr' ||
                                data18 === 'sapErp' ||
                                data18 === 'googleCloudPlatformCloudStorage' ||
                                data18 === 'sas' ||
                                data18 === 'oneDrive' ||
                                data18 === 'dropbox' ||
                                data18 === 'googleDrive' ||
                                data18 === 'jira' ||
                                data18 === 'monday' ||
                                data18 === 'zuora' ||
                                data18 === 'adobeAnalytics' ||
                                data18 === 'zoomInfo' ||
                                data18 === 'marketo' ||
                                data18 === 'activeCampaign' ||
                                data18 === 'mailchimp' ||
                                data18 === 'infor' ||
                                data18 === 'cornerstoneOnDemand' ||
                                data18 === 'gusto' ||
                                data18 === 'paychexFlex' ||
                                data18 === 'zendesk' ||
                                data18 === 'serviceNow' ||
                                data18 === 'zohoCrm' ||
                                data18 === 'pipedrive' ||
                                data18 === 'quickBooks' ||
                                data18 === 'xero' ||
                                data18 === 'freshbooks' ||
                                data18 === 'zohoBooks' ||
                                data18 === 'waveFinancial')) {
                                validate68.errors = [
                                    {
                                        instancePath: instancePath + '/subType',
                                        schemaPath: '#/properties/subType/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema104.properties.subType.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs49 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.authType !== undefined) {
                                let data19 = data.authType;
                                const _errs51 = errors;
                                if (typeof data19 !== 'string') {
                                    validate68.errors = [
                                        {
                                            instancePath: instancePath + '/authType',
                                            schemaPath: '#/properties/authType/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                if (!(data19 === 'none' ||
                                    data19 === 'basic' ||
                                    data19 === 'api_key' ||
                                    data19 === 'oauth_client_credentials' ||
                                    data19 === 'oauth_client_code')) {
                                    validate68.errors = [
                                        {
                                            instancePath: instancePath + '/authType',
                                            schemaPath: '#/properties/authType/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema104.properties.authType.enum },
                                            message: 'must be equal to one of the allowed values'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs51 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate68.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate68.errors = vErrors;
    return errors === 0;
}
export const salesForceAuthSchemaValidation = validate70;
const schema106 = {
    $id: 'urn:wisepipe-common-connection:SalesForceAuth',
    type: 'object',
    properties: {
        code: { type: 'string', minLength: 1 },
        redirectUri: { type: 'string', format: 'uri' },
        useSandbox: { type: 'boolean' }
    },
    required: ['code', 'redirectUri']
};
function validate70(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:SalesForceAuth" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.code === undefined && (missing0 = 'code')) ||
                (data.redirectUri === undefined && (missing0 = 'redirectUri'))) {
                validate70.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.code !== undefined) {
                    let data0 = data.code;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate70.errors = [
                                    {
                                        instancePath: instancePath + '/code',
                                        schemaPath: '#/properties/code/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate70.errors = [
                                {
                                    instancePath: instancePath + '/code',
                                    schemaPath: '#/properties/code/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.redirectUri !== undefined) {
                        let data1 = data.redirectUri;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (errors === _errs3) {
                                if (typeof data1 === 'string') {
                                    if (!formats0(data1)) {
                                        validate70.errors = [
                                            {
                                                instancePath: instancePath + '/redirectUri',
                                                schemaPath: '#/properties/redirectUri/format',
                                                keyword: 'format',
                                                params: { format: 'uri' },
                                                message: 'must match format "' + 'uri' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate70.errors = [
                                        {
                                            instancePath: instancePath + '/redirectUri',
                                            schemaPath: '#/properties/redirectUri/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.useSandbox !== undefined) {
                            const _errs5 = errors;
                            if (typeof data.useSandbox !== 'boolean') {
                                validate70.errors = [
                                    {
                                        instancePath: instancePath + '/useSandbox',
                                        schemaPath: '#/properties/useSandbox/type',
                                        keyword: 'type',
                                        params: { type: 'boolean' },
                                        message: 'must be boolean'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate70.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate70.errors = vErrors;
    return errors === 0;
}
export const salesForceConnectionSchemaValidation = validate71;
const schema107 = {
    $id: 'urn:wisepipe-common-connection:SalesForceConnection',
    type: 'object',
    properties: { instanceUrl: { type: 'string', minLength: 1 }, useSandbox: { type: 'boolean' } },
    required: ['instanceUrl']
};
function validate71(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:SalesForceConnection" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.instanceUrl === undefined && (missing0 = 'instanceUrl')) {
                validate71.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.instanceUrl !== undefined) {
                    let data0 = data.instanceUrl;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate71.errors = [
                                    {
                                        instancePath: instancePath + '/instanceUrl',
                                        schemaPath: '#/properties/instanceUrl/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate71.errors = [
                                {
                                    instancePath: instancePath + '/instanceUrl',
                                    schemaPath: '#/properties/instanceUrl/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.useSandbox !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.useSandbox !== 'boolean') {
                            validate71.errors = [
                                {
                                    instancePath: instancePath + '/useSandbox',
                                    schemaPath: '#/properties/useSandbox/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate71.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate71.errors = vErrors;
    return errors === 0;
}
export const sftpAuthSchemaValidation = validate72;
const schema108 = {
    $id: 'urn:wisepipe-common-connection:SftpAuth',
    type: 'object',
    properties: {
        host: { type: 'string', minLength: 1 },
        port: { type: 'number', minimum: 0 },
        userPassword: { $ref: 'urn:wisepipe-common-connection:UserPassword' }
    },
    required: ['host', 'port', 'userPassword']
};
function validate72(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:SftpAuth" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.host === undefined && (missing0 = 'host')) ||
                (data.port === undefined && (missing0 = 'port')) ||
                (data.userPassword === undefined && (missing0 = 'userPassword'))) {
                validate72.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.host !== undefined) {
                    let data0 = data.host;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate72.errors = [
                                    {
                                        instancePath: instancePath + '/host',
                                        schemaPath: '#/properties/host/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate72.errors = [
                                {
                                    instancePath: instancePath + '/host',
                                    schemaPath: '#/properties/host/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.port !== undefined) {
                        let data1 = data.port;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 == 'number') {
                                if (data1 < 0 || isNaN(data1)) {
                                    validate72.errors = [
                                        {
                                            instancePath: instancePath + '/port',
                                            schemaPath: '#/properties/port/minimum',
                                            keyword: 'minimum',
                                            params: { comparison: '>=', limit: 0 },
                                            message: 'must be >= 0'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate72.errors = [
                                    {
                                        instancePath: instancePath + '/port',
                                        schemaPath: '#/properties/port/type',
                                        keyword: 'type',
                                        params: { type: 'number' },
                                        message: 'must be number'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.userPassword !== undefined) {
                            let data2 = data.userPassword;
                            const _errs5 = errors;
                            const _errs6 = errors;
                            if (errors === _errs6) {
                                if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                    let missing1;
                                    if ((data2.user === undefined && (missing1 = 'user')) ||
                                        (data2.password === undefined && (missing1 = 'password'))) {
                                        validate72.errors = [
                                            {
                                                instancePath: instancePath + '/userPassword',
                                                schemaPath: 'urn:wisepipe-common-connection:UserPassword/required',
                                                keyword: 'required',
                                                params: { missingProperty: missing1 },
                                                message: "must have required property '" + missing1 + "'"
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        if (data2.user !== undefined) {
                                            let data3 = data2.user;
                                            const _errs8 = errors;
                                            if (errors === _errs8) {
                                                if (typeof data3 === 'string') {
                                                    if (func2(data3) < 1) {
                                                        validate72.errors = [
                                                            {
                                                                instancePath: instancePath + '/userPassword/user',
                                                                schemaPath: 'urn:wisepipe-common-connection:UserPassword/properties/user/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate72.errors = [
                                                        {
                                                            instancePath: instancePath + '/userPassword/user',
                                                            schemaPath: 'urn:wisepipe-common-connection:UserPassword/properties/user/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid2 = _errs8 === errors;
                                        }
                                        else {
                                            var valid2 = true;
                                        }
                                        if (valid2) {
                                            if (data2.password !== undefined) {
                                                let data4 = data2.password;
                                                const _errs10 = errors;
                                                if (errors === _errs10) {
                                                    if (typeof data4 === 'string') {
                                                        if (func2(data4) < 1) {
                                                            validate72.errors = [
                                                                {
                                                                    instancePath: instancePath + '/userPassword/password',
                                                                    schemaPath: 'urn:wisepipe-common-connection:UserPassword/properties/password/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate72.errors = [
                                                            {
                                                                instancePath: instancePath + '/userPassword/password',
                                                                schemaPath: 'urn:wisepipe-common-connection:UserPassword/properties/password/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid2 = _errs10 === errors;
                                            }
                                            else {
                                                var valid2 = true;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate72.errors = [
                                        {
                                            instancePath: instancePath + '/userPassword',
                                            schemaPath: 'urn:wisepipe-common-connection:UserPassword/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate72.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate72.errors = vErrors;
    return errors === 0;
}
export const sftpConnectionSchemaValidation = validate73;
const schema110 = {
    $id: 'urn:wisepipe-common-connection:SftpConnection',
    type: 'object',
    properties: {
        host: { type: 'string', minLength: 1 },
        port: { type: 'number', minimum: 0 },
        useEncryption: { type: 'boolean' }
    },
    required: ['host', 'port']
};
function validate73(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:SftpConnection" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.host === undefined && (missing0 = 'host')) || (data.port === undefined && (missing0 = 'port'))) {
                validate73.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.host !== undefined) {
                    let data0 = data.host;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate73.errors = [
                                    {
                                        instancePath: instancePath + '/host',
                                        schemaPath: '#/properties/host/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate73.errors = [
                                {
                                    instancePath: instancePath + '/host',
                                    schemaPath: '#/properties/host/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.port !== undefined) {
                        let data1 = data.port;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 == 'number') {
                                if (data1 < 0 || isNaN(data1)) {
                                    validate73.errors = [
                                        {
                                            instancePath: instancePath + '/port',
                                            schemaPath: '#/properties/port/minimum',
                                            keyword: 'minimum',
                                            params: { comparison: '>=', limit: 0 },
                                            message: 'must be >= 0'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate73.errors = [
                                    {
                                        instancePath: instancePath + '/port',
                                        schemaPath: '#/properties/port/type',
                                        keyword: 'type',
                                        params: { type: 'number' },
                                        message: 'must be number'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.useEncryption !== undefined) {
                            const _errs5 = errors;
                            if (typeof data.useEncryption !== 'boolean') {
                                validate73.errors = [
                                    {
                                        instancePath: instancePath + '/useEncryption',
                                        schemaPath: '#/properties/useEncryption/type',
                                        keyword: 'type',
                                        params: { type: 'boolean' },
                                        message: 'must be boolean'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate73.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate73.errors = vErrors;
    return errors === 0;
}
export const shopifyAuthSchemaValidation = validate74;
const schema111 = {
    $id: 'urn:wisepipe-common-connection:ShopifyAuth',
    type: 'object',
    properties: {
        code: { type: 'string', minLength: 1 },
        shop: { type: 'string', minLength: 1 },
        queryParams: { type: 'object' }
    },
    required: ['queryParams', 'code', 'shop']
};
function validate74(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:ShopifyAuth" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.queryParams === undefined && (missing0 = 'queryParams')) ||
                (data.code === undefined && (missing0 = 'code')) ||
                (data.shop === undefined && (missing0 = 'shop'))) {
                validate74.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.code !== undefined) {
                    let data0 = data.code;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate74.errors = [
                                    {
                                        instancePath: instancePath + '/code',
                                        schemaPath: '#/properties/code/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate74.errors = [
                                {
                                    instancePath: instancePath + '/code',
                                    schemaPath: '#/properties/code/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.shop !== undefined) {
                        let data1 = data.shop;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate74.errors = [
                                        {
                                            instancePath: instancePath + '/shop',
                                            schemaPath: '#/properties/shop/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate74.errors = [
                                    {
                                        instancePath: instancePath + '/shop',
                                        schemaPath: '#/properties/shop/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.queryParams !== undefined) {
                            let data2 = data.queryParams;
                            const _errs5 = errors;
                            if (!(data2 && typeof data2 == 'object' && !Array.isArray(data2))) {
                                validate74.errors = [
                                    {
                                        instancePath: instancePath + '/queryParams',
                                        schemaPath: '#/properties/queryParams/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate74.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate74.errors = vErrors;
    return errors === 0;
}
export const shopifyConnectionSchemaValidation = validate75;
const schema112 = {
    $id: 'urn:wisepipe-common-connection:ShopifyConnection',
    type: 'object',
    properties: { shop: { type: 'string', minLength: 1 } },
    required: ['shop']
};
function validate75(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:ShopifyConnection" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.shop === undefined && (missing0 = 'shop')) {
                validate75.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.shop !== undefined) {
                    let data0 = data.shop;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate75.errors = [
                                    {
                                        instancePath: instancePath + '/shop',
                                        schemaPath: '#/properties/shop/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate75.errors = [
                                {
                                    instancePath: instancePath + '/shop',
                                    schemaPath: '#/properties/shop/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate75.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate75.errors = vErrors;
    return errors === 0;
}
export const snowflakeAuthSchemaValidation = validate76;
const schema113 = {
    $id: 'urn:wisepipe-common-connection:SnowflakeAuth',
    type: 'object',
    properties: {
        account: { type: 'string' },
        warehouse: { type: 'string' },
        dbname: { type: 'string' },
        authMethod: { type: 'string', enum: ['basic', 'oauth'] },
        userPassword: { $ref: 'urn:wisepipe-common-connection:UserPassword' },
        role: { type: 'string' },
        code: { type: 'string' },
        clientID: { type: 'string' },
        clientSecret: { type: 'string' },
        redirectUri: { type: 'string' },
        storageIntegration: { $ref: 'urn:wisepipe-common-connection:SnowflakeStorageIntegration' },
        externalID: { type: 'string' }
    },
    required: ['account', 'warehouse', 'dbname'],
    if: { properties: { authMethod: { const: 'basic' } } },
    then: { required: ['userPassword'] },
    else: { required: ['clientID', 'clientSecret', 'redirectUri', 'code'] }
};
const schema115 = {
    $id: 'urn:wisepipe-common-connection:SnowflakeStorageIntegration',
    type: 'object',
    properties: {
        roleName: { type: 'string', pattern: '^storage-integration-.{12}$' },
        principal: { type: 'string', minLength: 1 },
        storageIntegrationName: { type: 'string', minLength: 1 }
    },
    required: ['roleName', 'principal', 'storageIntegrationName']
};
const pattern0 = new RegExp('^storage-integration-.{12}$', 'u');
function validate76(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:SnowflakeAuth" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.authMethod !== undefined) {
            if ('basic' !== data.authMethod) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    let ifClause0;
    if (_valid0) {
        const _errs4 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.userPassword === undefined && (missing0 = 'userPassword')) {
                validate76.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs4 === errors;
        valid0 = _valid0;
        ifClause0 = 'then';
    }
    else {
        const _errs5 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if ((data.clientID === undefined && (missing1 = 'clientID')) ||
                (data.clientSecret === undefined && (missing1 = 'clientSecret')) ||
                (data.redirectUri === undefined && (missing1 = 'redirectUri')) ||
                (data.code === undefined && (missing1 = 'code'))) {
                validate76.errors = [
                    {
                        instancePath,
                        schemaPath: '#/else/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs5 === errors;
        valid0 = _valid0;
        ifClause0 = 'else';
    }
    if (!valid0) {
        const err1 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: ifClause0 },
            message: 'must match "' + ifClause0 + '" schema'
        };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
        validate76.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing2;
            if ((data.account === undefined && (missing2 = 'account')) ||
                (data.warehouse === undefined && (missing2 = 'warehouse')) ||
                (data.dbname === undefined && (missing2 = 'dbname'))) {
                validate76.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing2 },
                        message: "must have required property '" + missing2 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.account !== undefined) {
                    const _errs6 = errors;
                    if (typeof data.account !== 'string') {
                        validate76.errors = [
                            {
                                instancePath: instancePath + '/account',
                                schemaPath: '#/properties/account/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid2 = _errs6 === errors;
                }
                else {
                    var valid2 = true;
                }
                if (valid2) {
                    if (data.warehouse !== undefined) {
                        const _errs8 = errors;
                        if (typeof data.warehouse !== 'string') {
                            validate76.errors = [
                                {
                                    instancePath: instancePath + '/warehouse',
                                    schemaPath: '#/properties/warehouse/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid2 = _errs8 === errors;
                    }
                    else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.dbname !== undefined) {
                            const _errs10 = errors;
                            if (typeof data.dbname !== 'string') {
                                validate76.errors = [
                                    {
                                        instancePath: instancePath + '/dbname',
                                        schemaPath: '#/properties/dbname/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            var valid2 = _errs10 === errors;
                        }
                        else {
                            var valid2 = true;
                        }
                        if (valid2) {
                            if (data.authMethod !== undefined) {
                                let data4 = data.authMethod;
                                const _errs12 = errors;
                                if (typeof data4 !== 'string') {
                                    validate76.errors = [
                                        {
                                            instancePath: instancePath + '/authMethod',
                                            schemaPath: '#/properties/authMethod/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                if (!(data4 === 'basic' || data4 === 'oauth')) {
                                    validate76.errors = [
                                        {
                                            instancePath: instancePath + '/authMethod',
                                            schemaPath: '#/properties/authMethod/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema113.properties.authMethod.enum },
                                            message: 'must be equal to one of the allowed values'
                                        }
                                    ];
                                    return false;
                                }
                                var valid2 = _errs12 === errors;
                            }
                            else {
                                var valid2 = true;
                            }
                            if (valid2) {
                                if (data.userPassword !== undefined) {
                                    let data5 = data.userPassword;
                                    const _errs14 = errors;
                                    const _errs15 = errors;
                                    if (errors === _errs15) {
                                        if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
                                            let missing3;
                                            if ((data5.user === undefined && (missing3 = 'user')) ||
                                                (data5.password === undefined && (missing3 = 'password'))) {
                                                validate76.errors = [
                                                    {
                                                        instancePath: instancePath + '/userPassword',
                                                        schemaPath: 'urn:wisepipe-common-connection:UserPassword/required',
                                                        keyword: 'required',
                                                        params: { missingProperty: missing3 },
                                                        message: "must have required property '" + missing3 + "'"
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (data5.user !== undefined) {
                                                    let data6 = data5.user;
                                                    const _errs17 = errors;
                                                    if (errors === _errs17) {
                                                        if (typeof data6 === 'string') {
                                                            if (func2(data6) < 1) {
                                                                validate76.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/userPassword/user',
                                                                        schemaPath: 'urn:wisepipe-common-connection:UserPassword/properties/user/minLength',
                                                                        keyword: 'minLength',
                                                                        params: { limit: 1 },
                                                                        message: 'must NOT have fewer than 1 characters'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate76.errors = [
                                                                {
                                                                    instancePath: instancePath + '/userPassword/user',
                                                                    schemaPath: 'urn:wisepipe-common-connection:UserPassword/properties/user/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid4 = _errs17 === errors;
                                                }
                                                else {
                                                    var valid4 = true;
                                                }
                                                if (valid4) {
                                                    if (data5.password !== undefined) {
                                                        let data7 = data5.password;
                                                        const _errs19 = errors;
                                                        if (errors === _errs19) {
                                                            if (typeof data7 === 'string') {
                                                                if (func2(data7) < 1) {
                                                                    validate76.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/userPassword/password',
                                                                            schemaPath: 'urn:wisepipe-common-connection:UserPassword/properties/password/minLength',
                                                                            keyword: 'minLength',
                                                                            params: { limit: 1 },
                                                                            message: 'must NOT have fewer than 1 characters'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            else {
                                                                validate76.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/userPassword/password',
                                                                        schemaPath: 'urn:wisepipe-common-connection:UserPassword/properties/password/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid4 = _errs19 === errors;
                                                    }
                                                    else {
                                                        var valid4 = true;
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate76.errors = [
                                                {
                                                    instancePath: instancePath + '/userPassword',
                                                    schemaPath: 'urn:wisepipe-common-connection:UserPassword/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid2 = _errs14 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                                if (valid2) {
                                    if (data.role !== undefined) {
                                        const _errs21 = errors;
                                        if (typeof data.role !== 'string') {
                                            validate76.errors = [
                                                {
                                                    instancePath: instancePath + '/role',
                                                    schemaPath: '#/properties/role/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid2 = _errs21 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                    if (valid2) {
                                        if (data.code !== undefined) {
                                            const _errs23 = errors;
                                            if (typeof data.code !== 'string') {
                                                validate76.errors = [
                                                    {
                                                        instancePath: instancePath + '/code',
                                                        schemaPath: '#/properties/code/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid2 = _errs23 === errors;
                                        }
                                        else {
                                            var valid2 = true;
                                        }
                                        if (valid2) {
                                            if (data.clientID !== undefined) {
                                                const _errs25 = errors;
                                                if (typeof data.clientID !== 'string') {
                                                    validate76.errors = [
                                                        {
                                                            instancePath: instancePath + '/clientID',
                                                            schemaPath: '#/properties/clientID/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid2 = _errs25 === errors;
                                            }
                                            else {
                                                var valid2 = true;
                                            }
                                            if (valid2) {
                                                if (data.clientSecret !== undefined) {
                                                    const _errs27 = errors;
                                                    if (typeof data.clientSecret !== 'string') {
                                                        validate76.errors = [
                                                            {
                                                                instancePath: instancePath + '/clientSecret',
                                                                schemaPath: '#/properties/clientSecret/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    var valid2 = _errs27 === errors;
                                                }
                                                else {
                                                    var valid2 = true;
                                                }
                                                if (valid2) {
                                                    if (data.redirectUri !== undefined) {
                                                        const _errs29 = errors;
                                                        if (typeof data.redirectUri !== 'string') {
                                                            validate76.errors = [
                                                                {
                                                                    instancePath: instancePath + '/redirectUri',
                                                                    schemaPath: '#/properties/redirectUri/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid2 = _errs29 === errors;
                                                    }
                                                    else {
                                                        var valid2 = true;
                                                    }
                                                    if (valid2) {
                                                        if (data.storageIntegration !== undefined) {
                                                            let data13 = data.storageIntegration;
                                                            const _errs31 = errors;
                                                            const _errs32 = errors;
                                                            if (errors === _errs32) {
                                                                if (data13 && typeof data13 == 'object' && !Array.isArray(data13)) {
                                                                    let missing4;
                                                                    if ((data13.roleName === undefined && (missing4 = 'roleName')) ||
                                                                        (data13.principal === undefined && (missing4 = 'principal')) ||
                                                                        (data13.storageIntegrationName === undefined &&
                                                                            (missing4 = 'storageIntegrationName'))) {
                                                                        validate76.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/storageIntegration',
                                                                                schemaPath: 'urn:wisepipe-common-connection:SnowflakeStorageIntegration/required',
                                                                                keyword: 'required',
                                                                                params: { missingProperty: missing4 },
                                                                                message: "must have required property '" + missing4 + "'"
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    else {
                                                                        if (data13.roleName !== undefined) {
                                                                            let data14 = data13.roleName;
                                                                            const _errs34 = errors;
                                                                            if (errors === _errs34) {
                                                                                if (typeof data14 === 'string') {
                                                                                    if (!pattern0.test(data14)) {
                                                                                        validate76.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/storageIntegration/roleName',
                                                                                                schemaPath: 'urn:wisepipe-common-connection:SnowflakeStorageIntegration/properties/roleName/pattern',
                                                                                                keyword: 'pattern',
                                                                                                params: { pattern: '^storage-integration-.{12}$' },
                                                                                                message: 'must match pattern "' + '^storage-integration-.{12}$' + '"'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    validate76.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/storageIntegration/roleName',
                                                                                            schemaPath: 'urn:wisepipe-common-connection:SnowflakeStorageIntegration/properties/roleName/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'string' },
                                                                                            message: 'must be string'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            var valid6 = _errs34 === errors;
                                                                        }
                                                                        else {
                                                                            var valid6 = true;
                                                                        }
                                                                        if (valid6) {
                                                                            if (data13.principal !== undefined) {
                                                                                let data15 = data13.principal;
                                                                                const _errs36 = errors;
                                                                                if (errors === _errs36) {
                                                                                    if (typeof data15 === 'string') {
                                                                                        if (func2(data15) < 1) {
                                                                                            validate76.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/storageIntegration/principal',
                                                                                                    schemaPath: 'urn:wisepipe-common-connection:SnowflakeStorageIntegration/properties/principal/minLength',
                                                                                                    keyword: 'minLength',
                                                                                                    params: { limit: 1 },
                                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        validate76.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/storageIntegration/principal',
                                                                                                schemaPath: 'urn:wisepipe-common-connection:SnowflakeStorageIntegration/properties/principal/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'string' },
                                                                                                message: 'must be string'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                var valid6 = _errs36 === errors;
                                                                            }
                                                                            else {
                                                                                var valid6 = true;
                                                                            }
                                                                            if (valid6) {
                                                                                if (data13.storageIntegrationName !== undefined) {
                                                                                    let data16 = data13.storageIntegrationName;
                                                                                    const _errs38 = errors;
                                                                                    if (errors === _errs38) {
                                                                                        if (typeof data16 === 'string') {
                                                                                            if (func2(data16) < 1) {
                                                                                                validate76.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/storageIntegration/storageIntegrationName',
                                                                                                        schemaPath: 'urn:wisepipe-common-connection:SnowflakeStorageIntegration/properties/storageIntegrationName/minLength',
                                                                                                        keyword: 'minLength',
                                                                                                        params: { limit: 1 },
                                                                                                        message: 'must NOT have fewer than 1 characters'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                        }
                                                                                        else {
                                                                                            validate76.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/storageIntegration/storageIntegrationName',
                                                                                                    schemaPath: 'urn:wisepipe-common-connection:SnowflakeStorageIntegration/properties/storageIntegrationName/type',
                                                                                                    keyword: 'type',
                                                                                                    params: { type: 'string' },
                                                                                                    message: 'must be string'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                    var valid6 = _errs38 === errors;
                                                                                }
                                                                                else {
                                                                                    var valid6 = true;
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                                else {
                                                                    validate76.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/storageIntegration',
                                                                            schemaPath: 'urn:wisepipe-common-connection:SnowflakeStorageIntegration/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'object' },
                                                                            message: 'must be object'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid2 = _errs31 === errors;
                                                        }
                                                        else {
                                                            var valid2 = true;
                                                        }
                                                        if (valid2) {
                                                            if (data.externalID !== undefined) {
                                                                const _errs40 = errors;
                                                                if (typeof data.externalID !== 'string') {
                                                                    validate76.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/externalID',
                                                                            schemaPath: '#/properties/externalID/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid2 = _errs40 === errors;
                                                            }
                                                            else {
                                                                var valid2 = true;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate76.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate76.errors = vErrors;
    return errors === 0;
}
export const snowflakeConnectionSchemaValidation = validate77;
const schema116 = {
    $id: 'urn:wisepipe-common-connection:SnowflakeConnection',
    type: 'object',
    properties: {
        account: { type: 'string' },
        warehouse: { type: 'string' },
        database: { type: 'string' },
        role: { type: 'string' },
        authMethod: { type: 'string', enum: ['basic', 'oauth'] },
        storageIntegration: { $ref: 'urn:wisepipe-common-connection:SnowflakeStorageIntegration' }
    },
    required: ['account', 'warehouse', 'database']
};
function validate77(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:SnowflakeConnection" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.account === undefined && (missing0 = 'account')) ||
                (data.warehouse === undefined && (missing0 = 'warehouse')) ||
                (data.database === undefined && (missing0 = 'database'))) {
                validate77.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.account !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.account !== 'string') {
                        validate77.errors = [
                            {
                                instancePath: instancePath + '/account',
                                schemaPath: '#/properties/account/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.warehouse !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.warehouse !== 'string') {
                            validate77.errors = [
                                {
                                    instancePath: instancePath + '/warehouse',
                                    schemaPath: '#/properties/warehouse/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.database !== undefined) {
                            const _errs5 = errors;
                            if (typeof data.database !== 'string') {
                                validate77.errors = [
                                    {
                                        instancePath: instancePath + '/database',
                                        schemaPath: '#/properties/database/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.role !== undefined) {
                                const _errs7 = errors;
                                if (typeof data.role !== 'string') {
                                    validate77.errors = [
                                        {
                                            instancePath: instancePath + '/role',
                                            schemaPath: '#/properties/role/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.authMethod !== undefined) {
                                    let data4 = data.authMethod;
                                    const _errs9 = errors;
                                    if (typeof data4 !== 'string') {
                                        validate77.errors = [
                                            {
                                                instancePath: instancePath + '/authMethod',
                                                schemaPath: '#/properties/authMethod/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (!(data4 === 'basic' || data4 === 'oauth')) {
                                        validate77.errors = [
                                            {
                                                instancePath: instancePath + '/authMethod',
                                                schemaPath: '#/properties/authMethod/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema116.properties.authMethod.enum },
                                                message: 'must be equal to one of the allowed values'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.storageIntegration !== undefined) {
                                        let data5 = data.storageIntegration;
                                        const _errs11 = errors;
                                        const _errs12 = errors;
                                        if (errors === _errs12) {
                                            if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
                                                let missing1;
                                                if ((data5.roleName === undefined && (missing1 = 'roleName')) ||
                                                    (data5.principal === undefined && (missing1 = 'principal')) ||
                                                    (data5.storageIntegrationName === undefined && (missing1 = 'storageIntegrationName'))) {
                                                    validate77.errors = [
                                                        {
                                                            instancePath: instancePath + '/storageIntegration',
                                                            schemaPath: 'urn:wisepipe-common-connection:SnowflakeStorageIntegration/required',
                                                            keyword: 'required',
                                                            params: { missingProperty: missing1 },
                                                            message: "must have required property '" + missing1 + "'"
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    if (data5.roleName !== undefined) {
                                                        let data6 = data5.roleName;
                                                        const _errs14 = errors;
                                                        if (errors === _errs14) {
                                                            if (typeof data6 === 'string') {
                                                                if (!pattern0.test(data6)) {
                                                                    validate77.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/storageIntegration/roleName',
                                                                            schemaPath: 'urn:wisepipe-common-connection:SnowflakeStorageIntegration/properties/roleName/pattern',
                                                                            keyword: 'pattern',
                                                                            params: { pattern: '^storage-integration-.{12}$' },
                                                                            message: 'must match pattern "' + '^storage-integration-.{12}$' + '"'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            else {
                                                                validate77.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/storageIntegration/roleName',
                                                                        schemaPath: 'urn:wisepipe-common-connection:SnowflakeStorageIntegration/properties/roleName/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid2 = _errs14 === errors;
                                                    }
                                                    else {
                                                        var valid2 = true;
                                                    }
                                                    if (valid2) {
                                                        if (data5.principal !== undefined) {
                                                            let data7 = data5.principal;
                                                            const _errs16 = errors;
                                                            if (errors === _errs16) {
                                                                if (typeof data7 === 'string') {
                                                                    if (func2(data7) < 1) {
                                                                        validate77.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/storageIntegration/principal',
                                                                                schemaPath: 'urn:wisepipe-common-connection:SnowflakeStorageIntegration/properties/principal/minLength',
                                                                                keyword: 'minLength',
                                                                                params: { limit: 1 },
                                                                                message: 'must NOT have fewer than 1 characters'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                else {
                                                                    validate77.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/storageIntegration/principal',
                                                                            schemaPath: 'urn:wisepipe-common-connection:SnowflakeStorageIntegration/properties/principal/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid2 = _errs16 === errors;
                                                        }
                                                        else {
                                                            var valid2 = true;
                                                        }
                                                        if (valid2) {
                                                            if (data5.storageIntegrationName !== undefined) {
                                                                let data8 = data5.storageIntegrationName;
                                                                const _errs18 = errors;
                                                                if (errors === _errs18) {
                                                                    if (typeof data8 === 'string') {
                                                                        if (func2(data8) < 1) {
                                                                            validate77.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/storageIntegration/storageIntegrationName',
                                                                                    schemaPath: 'urn:wisepipe-common-connection:SnowflakeStorageIntegration/properties/storageIntegrationName/minLength',
                                                                                    keyword: 'minLength',
                                                                                    params: { limit: 1 },
                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate77.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/storageIntegration/storageIntegrationName',
                                                                                schemaPath: 'urn:wisepipe-common-connection:SnowflakeStorageIntegration/properties/storageIntegrationName/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                var valid2 = _errs18 === errors;
                                                            }
                                                            else {
                                                                var valid2 = true;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate77.errors = [
                                                    {
                                                        instancePath: instancePath + '/storageIntegration',
                                                        schemaPath: 'urn:wisepipe-common-connection:SnowflakeStorageIntegration/type',
                                                        keyword: 'type',
                                                        params: { type: 'object' },
                                                        message: 'must be object'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate77.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate77.errors = vErrors;
    return errors === 0;
}
export const snowflakeStorageIntegrationSchemaValidation = validate78;
function validate78(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:SnowflakeStorageIntegration" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.roleName === undefined && (missing0 = 'roleName')) ||
                (data.principal === undefined && (missing0 = 'principal')) ||
                (data.storageIntegrationName === undefined && (missing0 = 'storageIntegrationName'))) {
                validate78.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.roleName !== undefined) {
                    let data0 = data.roleName;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (!pattern0.test(data0)) {
                                validate78.errors = [
                                    {
                                        instancePath: instancePath + '/roleName',
                                        schemaPath: '#/properties/roleName/pattern',
                                        keyword: 'pattern',
                                        params: { pattern: '^storage-integration-.{12}$' },
                                        message: 'must match pattern "' + '^storage-integration-.{12}$' + '"'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate78.errors = [
                                {
                                    instancePath: instancePath + '/roleName',
                                    schemaPath: '#/properties/roleName/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.principal !== undefined) {
                        let data1 = data.principal;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate78.errors = [
                                        {
                                            instancePath: instancePath + '/principal',
                                            schemaPath: '#/properties/principal/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate78.errors = [
                                    {
                                        instancePath: instancePath + '/principal',
                                        schemaPath: '#/properties/principal/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.storageIntegrationName !== undefined) {
                            let data2 = data.storageIntegrationName;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate78.errors = [
                                            {
                                                instancePath: instancePath + '/storageIntegrationName',
                                                schemaPath: '#/properties/storageIntegrationName/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate78.errors = [
                                        {
                                            instancePath: instancePath + '/storageIntegrationName',
                                            schemaPath: '#/properties/storageIntegrationName/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate78.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate78.errors = vErrors;
    return errors === 0;
}
export const symonConnectionSchemaValidation = validate79;
const schema119 = { $id: 'urn:wisepipe-common-connection:SymonConnection', type: 'object' };
function validate79(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:SymonConnection" */ let vErrors = null;
    let errors = 0;
    if (!(data && typeof data == 'object' && !Array.isArray(data))) {
        validate79.errors = [
            { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
        ];
        return false;
    }
    validate79.errors = vErrors;
    return errors === 0;
}
export const symonCredSchemaValidation = validate80;
const schema120 = { $id: 'urn:wisepipe-common-connection:SymonCred', type: 'object' };
function validate80(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:SymonCred" */ let vErrors = null;
    let errors = 0;
    if (!(data && typeof data == 'object' && !Array.isArray(data))) {
        validate80.errors = [
            { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
        ];
        return false;
    }
    validate80.errors = vErrors;
    return errors === 0;
}
export const tableauAuthSchemaValidation = validate81;
const schema121 = {
    $id: 'urn:wisepipe-common-connection:TableauAuth',
    type: 'object',
    properties: {
        serverAddress: { type: 'string' },
        siteName: { type: 'string' },
        persToken: { $ref: 'urn:wisepipe-common-connection:UserPassword' }
    },
    required: ['serverAddress', 'siteName', 'persToken']
};
function validate81(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:TableauAuth" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.serverAddress === undefined && (missing0 = 'serverAddress')) ||
                (data.siteName === undefined && (missing0 = 'siteName')) ||
                (data.persToken === undefined && (missing0 = 'persToken'))) {
                validate81.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.serverAddress !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.serverAddress !== 'string') {
                        validate81.errors = [
                            {
                                instancePath: instancePath + '/serverAddress',
                                schemaPath: '#/properties/serverAddress/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.siteName !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.siteName !== 'string') {
                            validate81.errors = [
                                {
                                    instancePath: instancePath + '/siteName',
                                    schemaPath: '#/properties/siteName/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.persToken !== undefined) {
                            let data2 = data.persToken;
                            const _errs5 = errors;
                            const _errs6 = errors;
                            if (errors === _errs6) {
                                if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                    let missing1;
                                    if ((data2.user === undefined && (missing1 = 'user')) ||
                                        (data2.password === undefined && (missing1 = 'password'))) {
                                        validate81.errors = [
                                            {
                                                instancePath: instancePath + '/persToken',
                                                schemaPath: 'urn:wisepipe-common-connection:UserPassword/required',
                                                keyword: 'required',
                                                params: { missingProperty: missing1 },
                                                message: "must have required property '" + missing1 + "'"
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        if (data2.user !== undefined) {
                                            let data3 = data2.user;
                                            const _errs8 = errors;
                                            if (errors === _errs8) {
                                                if (typeof data3 === 'string') {
                                                    if (func2(data3) < 1) {
                                                        validate81.errors = [
                                                            {
                                                                instancePath: instancePath + '/persToken/user',
                                                                schemaPath: 'urn:wisepipe-common-connection:UserPassword/properties/user/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate81.errors = [
                                                        {
                                                            instancePath: instancePath + '/persToken/user',
                                                            schemaPath: 'urn:wisepipe-common-connection:UserPassword/properties/user/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid2 = _errs8 === errors;
                                        }
                                        else {
                                            var valid2 = true;
                                        }
                                        if (valid2) {
                                            if (data2.password !== undefined) {
                                                let data4 = data2.password;
                                                const _errs10 = errors;
                                                if (errors === _errs10) {
                                                    if (typeof data4 === 'string') {
                                                        if (func2(data4) < 1) {
                                                            validate81.errors = [
                                                                {
                                                                    instancePath: instancePath + '/persToken/password',
                                                                    schemaPath: 'urn:wisepipe-common-connection:UserPassword/properties/password/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate81.errors = [
                                                            {
                                                                instancePath: instancePath + '/persToken/password',
                                                                schemaPath: 'urn:wisepipe-common-connection:UserPassword/properties/password/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid2 = _errs10 === errors;
                                            }
                                            else {
                                                var valid2 = true;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate81.errors = [
                                        {
                                            instancePath: instancePath + '/persToken',
                                            schemaPath: 'urn:wisepipe-common-connection:UserPassword/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate81.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate81.errors = vErrors;
    return errors === 0;
}
export const tableauConnectionSchemaValidation = validate82;
const schema123 = {
    $id: 'urn:wisepipe-common-connection:TableauConnection',
    type: 'object',
    properties: { serverAddress: { type: 'string' }, siteName: { type: 'string' } },
    required: ['serverAddress', 'siteName']
};
function validate82(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:TableauConnection" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.serverAddress === undefined && (missing0 = 'serverAddress')) ||
                (data.siteName === undefined && (missing0 = 'siteName'))) {
                validate82.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.serverAddress !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.serverAddress !== 'string') {
                        validate82.errors = [
                            {
                                instancePath: instancePath + '/serverAddress',
                                schemaPath: '#/properties/serverAddress/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.siteName !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.siteName !== 'string') {
                            validate82.errors = [
                                {
                                    instancePath: instancePath + '/siteName',
                                    schemaPath: '#/properties/siteName/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate82.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate82.errors = vErrors;
    return errors === 0;
}
export const tokenBasedAuthenticationSchemaValidation = validate83;
function validate83(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:TokenBasedAuthentication" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.consumerKey === undefined && (missing0 = 'consumerKey')) ||
                (data.consumerSecret === undefined && (missing0 = 'consumerSecret')) ||
                (data.tokenKey === undefined && (missing0 = 'tokenKey')) ||
                (data.tokenSecret === undefined && (missing0 = 'tokenSecret'))) {
                validate83.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.consumerKey !== undefined) {
                    let data0 = data.consumerKey;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate83.errors = [
                                    {
                                        instancePath: instancePath + '/consumerKey',
                                        schemaPath: '#/properties/consumerKey/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate83.errors = [
                                {
                                    instancePath: instancePath + '/consumerKey',
                                    schemaPath: '#/properties/consumerKey/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.consumerSecret !== undefined) {
                        let data1 = data.consumerSecret;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate83.errors = [
                                        {
                                            instancePath: instancePath + '/consumerSecret',
                                            schemaPath: '#/properties/consumerSecret/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate83.errors = [
                                    {
                                        instancePath: instancePath + '/consumerSecret',
                                        schemaPath: '#/properties/consumerSecret/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.tokenKey !== undefined) {
                            let data2 = data.tokenKey;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) < 1) {
                                        validate83.errors = [
                                            {
                                                instancePath: instancePath + '/tokenKey',
                                                schemaPath: '#/properties/tokenKey/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate83.errors = [
                                        {
                                            instancePath: instancePath + '/tokenKey',
                                            schemaPath: '#/properties/tokenKey/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.tokenSecret !== undefined) {
                                let data3 = data.tokenSecret;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 === 'string') {
                                        if (func2(data3) < 1) {
                                            validate83.errors = [
                                                {
                                                    instancePath: instancePath + '/tokenSecret',
                                                    schemaPath: '#/properties/tokenSecret/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate83.errors = [
                                            {
                                                instancePath: instancePath + '/tokenSecret',
                                                schemaPath: '#/properties/tokenSecret/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate83.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate83.errors = vErrors;
    return errors === 0;
}
export const tqPostgresConnectionSchemaValidation = validate84;
const schema125 = {
    $id: 'urn:wisepipe-common-connection:TqPostgresConnection',
    type: 'object',
    properties: {},
    required: []
};
function validate84(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:TqPostgresConnection" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate84.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate84.errors = vErrors;
    return errors === 0;
}
export const tqpAuthSchemaValidation = validate85;
const schema126 = {
    $id: 'urn:wisepipe-common-connection:TqpAuth',
    type: 'object',
    properties: {
        apiKey: { $ref: 'urn:wisepipe-common-connection:ApiKey' },
        domainName: { type: 'string', minLength: 6 }
    },
    required: ['apiKey']
};
function validate85(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:TqpAuth" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.apiKey === undefined && (missing0 = 'apiKey')) {
                validate85.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.apiKey !== undefined) {
                    let data0 = data.apiKey;
                    const _errs1 = errors;
                    const _errs2 = errors;
                    if (errors === _errs2) {
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            let missing1;
                            if (data0.value === undefined && (missing1 = 'value')) {
                                validate85.errors = [
                                    {
                                        instancePath: instancePath + '/apiKey',
                                        schemaPath: 'urn:wisepipe-common-connection:ApiKey/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing1 },
                                        message: "must have required property '" + missing1 + "'"
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0.value !== undefined) {
                                    let data1 = data0.value;
                                    const _errs4 = errors;
                                    if (errors === _errs4) {
                                        if (typeof data1 === 'string') {
                                            if (func2(data1) < 1) {
                                                validate85.errors = [
                                                    {
                                                        instancePath: instancePath + '/apiKey/value',
                                                        schemaPath: 'urn:wisepipe-common-connection:ApiKey/properties/value/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate85.errors = [
                                                {
                                                    instancePath: instancePath + '/apiKey/value',
                                                    schemaPath: 'urn:wisepipe-common-connection:ApiKey/properties/value/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            validate85.errors = [
                                {
                                    instancePath: instancePath + '/apiKey',
                                    schemaPath: 'urn:wisepipe-common-connection:ApiKey/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.domainName !== undefined) {
                        let data2 = data.domainName;
                        const _errs6 = errors;
                        if (errors === _errs6) {
                            if (typeof data2 === 'string') {
                                if (func2(data2) < 6) {
                                    validate85.errors = [
                                        {
                                            instancePath: instancePath + '/domainName',
                                            schemaPath: '#/properties/domainName/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 6 },
                                            message: 'must NOT have fewer than 6 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate85.errors = [
                                    {
                                        instancePath: instancePath + '/domainName',
                                        schemaPath: '#/properties/domainName/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs6 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate85.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate85.errors = vErrors;
    return errors === 0;
}
export const tqpConnectionInfoEntrySchemaValidation = validate86;
function validate86(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:TqpConnectionInfoEntry" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.url === undefined && (missing0 = 'url')) {
                validate86.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.url !== undefined) {
                    let data0 = data.url;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate86.errors = [
                                    {
                                        instancePath: instancePath + '/url',
                                        schemaPath: '#/properties/url/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate86.errors = [
                                {
                                    instancePath: instancePath + '/url',
                                    schemaPath: '#/properties/url/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate86.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate86.errors = vErrors;
    return errors === 0;
}
export const tqpConnectionSchemaValidation = validate87;
const schema129 = {
    $id: 'urn:wisepipe-common-connection:TqpConnection',
    type: 'object',
    properties: { url: { type: 'string', minLength: 6 }, tenantGlobalId: { type: 'string', format: 'uuid' } },
    required: ['url']
};
const formats20 = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
function validate87(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:TqpConnection" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.url === undefined && (missing0 = 'url')) {
                validate87.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.url !== undefined) {
                    let data0 = data.url;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 6) {
                                validate87.errors = [
                                    {
                                        instancePath: instancePath + '/url',
                                        schemaPath: '#/properties/url/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 6 },
                                        message: 'must NOT have fewer than 6 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate87.errors = [
                                {
                                    instancePath: instancePath + '/url',
                                    schemaPath: '#/properties/url/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.tenantGlobalId !== undefined) {
                        let data1 = data.tenantGlobalId;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (errors === _errs3) {
                                if (typeof data1 === 'string') {
                                    if (!formats20.test(data1)) {
                                        validate87.errors = [
                                            {
                                                instancePath: instancePath + '/tenantGlobalId',
                                                schemaPath: '#/properties/tenantGlobalId/format',
                                                keyword: 'format',
                                                params: { format: 'uuid' },
                                                message: 'must match format "' + 'uuid' + '"'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate87.errors = [
                                        {
                                            instancePath: instancePath + '/tenantGlobalId',
                                            schemaPath: '#/properties/tenantGlobalId/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate87.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate87.errors = vErrors;
    return errors === 0;
}
export const userPasswordSchemaValidation = validate88;
function validate88(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:UserPassword" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.user === undefined && (missing0 = 'user')) ||
                (data.password === undefined && (missing0 = 'password'))) {
                validate88.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.user !== undefined) {
                    let data0 = data.user;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate88.errors = [
                                    {
                                        instancePath: instancePath + '/user',
                                        schemaPath: '#/properties/user/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate88.errors = [
                                {
                                    instancePath: instancePath + '/user',
                                    schemaPath: '#/properties/user/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.password !== undefined) {
                        let data1 = data.password;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate88.errors = [
                                        {
                                            instancePath: instancePath + '/password',
                                            schemaPath: '#/properties/password/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate88.errors = [
                                    {
                                        instancePath: instancePath + '/password',
                                        schemaPath: '#/properties/password/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate88.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate88.errors = vErrors;
    return errors === 0;
}
export const workdayAuthSchemaValidation = validate89;
const schema131 = {
    $id: 'urn:wisepipe-common-connection:WorkdayAuth',
    type: 'object',
    properties: {
        userPassword: { $ref: 'urn:wisepipe-common-connection:UserPassword' },
        tenant: { type: 'string' },
        domain: { type: 'string' },
        countryCode: { type: 'string' },
        excludeInactiveWorkers: { type: 'boolean' },
        excludeContingentWorkers: { type: 'boolean' }
    },
    required: ['userPassword', 'tenant', 'domain']
};
function validate89(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:WorkdayAuth" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.userPassword === undefined && (missing0 = 'userPassword')) ||
                (data.tenant === undefined && (missing0 = 'tenant')) ||
                (data.domain === undefined && (missing0 = 'domain'))) {
                validate89.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.userPassword !== undefined) {
                    let data0 = data.userPassword;
                    const _errs1 = errors;
                    const _errs2 = errors;
                    if (errors === _errs2) {
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            let missing1;
                            if ((data0.user === undefined && (missing1 = 'user')) ||
                                (data0.password === undefined && (missing1 = 'password'))) {
                                validate89.errors = [
                                    {
                                        instancePath: instancePath + '/userPassword',
                                        schemaPath: 'urn:wisepipe-common-connection:UserPassword/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing1 },
                                        message: "must have required property '" + missing1 + "'"
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0.user !== undefined) {
                                    let data1 = data0.user;
                                    const _errs4 = errors;
                                    if (errors === _errs4) {
                                        if (typeof data1 === 'string') {
                                            if (func2(data1) < 1) {
                                                validate89.errors = [
                                                    {
                                                        instancePath: instancePath + '/userPassword/user',
                                                        schemaPath: 'urn:wisepipe-common-connection:UserPassword/properties/user/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate89.errors = [
                                                {
                                                    instancePath: instancePath + '/userPassword/user',
                                                    schemaPath: 'urn:wisepipe-common-connection:UserPassword/properties/user/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid2 = _errs4 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                                if (valid2) {
                                    if (data0.password !== undefined) {
                                        let data2 = data0.password;
                                        const _errs6 = errors;
                                        if (errors === _errs6) {
                                            if (typeof data2 === 'string') {
                                                if (func2(data2) < 1) {
                                                    validate89.errors = [
                                                        {
                                                            instancePath: instancePath + '/userPassword/password',
                                                            schemaPath: 'urn:wisepipe-common-connection:UserPassword/properties/password/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate89.errors = [
                                                    {
                                                        instancePath: instancePath + '/userPassword/password',
                                                        schemaPath: 'urn:wisepipe-common-connection:UserPassword/properties/password/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid2 = _errs6 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                }
                            }
                        }
                        else {
                            validate89.errors = [
                                {
                                    instancePath: instancePath + '/userPassword',
                                    schemaPath: 'urn:wisepipe-common-connection:UserPassword/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.tenant !== undefined) {
                        const _errs8 = errors;
                        if (typeof data.tenant !== 'string') {
                            validate89.errors = [
                                {
                                    instancePath: instancePath + '/tenant',
                                    schemaPath: '#/properties/tenant/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs8 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.domain !== undefined) {
                            const _errs10 = errors;
                            if (typeof data.domain !== 'string') {
                                validate89.errors = [
                                    {
                                        instancePath: instancePath + '/domain',
                                        schemaPath: '#/properties/domain/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs10 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.countryCode !== undefined) {
                                const _errs12 = errors;
                                if (typeof data.countryCode !== 'string') {
                                    validate89.errors = [
                                        {
                                            instancePath: instancePath + '/countryCode',
                                            schemaPath: '#/properties/countryCode/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs12 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.excludeInactiveWorkers !== undefined) {
                                    const _errs14 = errors;
                                    if (typeof data.excludeInactiveWorkers !== 'boolean') {
                                        validate89.errors = [
                                            {
                                                instancePath: instancePath + '/excludeInactiveWorkers',
                                                schemaPath: '#/properties/excludeInactiveWorkers/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs14 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.excludeContingentWorkers !== undefined) {
                                        const _errs16 = errors;
                                        if (typeof data.excludeContingentWorkers !== 'boolean') {
                                            validate89.errors = [
                                                {
                                                    instancePath: instancePath + '/excludeContingentWorkers',
                                                    schemaPath: '#/properties/excludeContingentWorkers/type',
                                                    keyword: 'type',
                                                    params: { type: 'boolean' },
                                                    message: 'must be boolean'
                                                }
                                            ];
                                            return false;
                                        }
                                        var valid0 = _errs16 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate89.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate89.errors = vErrors;
    return errors === 0;
}
export const workdayConnectionSchemaValidation = validate90;
const schema133 = {
    $id: 'urn:wisepipe-common-connection:WorkdayConnection',
    type: 'object',
    properties: {
        tenant: { type: 'string' },
        domain: { type: 'string' },
        countryCode: { type: 'string' },
        excludeInactiveWorkers: { type: 'boolean' },
        excludeContingentWorkers: { type: 'boolean' }
    },
    required: ['tenant', 'domain']
};
function validate90(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:WorkdayConnection" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.tenant === undefined && (missing0 = 'tenant')) ||
                (data.domain === undefined && (missing0 = 'domain'))) {
                validate90.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.tenant !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.tenant !== 'string') {
                        validate90.errors = [
                            {
                                instancePath: instancePath + '/tenant',
                                schemaPath: '#/properties/tenant/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.domain !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.domain !== 'string') {
                            validate90.errors = [
                                {
                                    instancePath: instancePath + '/domain',
                                    schemaPath: '#/properties/domain/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.countryCode !== undefined) {
                            const _errs5 = errors;
                            if (typeof data.countryCode !== 'string') {
                                validate90.errors = [
                                    {
                                        instancePath: instancePath + '/countryCode',
                                        schemaPath: '#/properties/countryCode/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.excludeInactiveWorkers !== undefined) {
                                const _errs7 = errors;
                                if (typeof data.excludeInactiveWorkers !== 'boolean') {
                                    validate90.errors = [
                                        {
                                            instancePath: instancePath + '/excludeInactiveWorkers',
                                            schemaPath: '#/properties/excludeInactiveWorkers/type',
                                            keyword: 'type',
                                            params: { type: 'boolean' },
                                            message: 'must be boolean'
                                        }
                                    ];
                                    return false;
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.excludeContingentWorkers !== undefined) {
                                    const _errs9 = errors;
                                    if (typeof data.excludeContingentWorkers !== 'boolean') {
                                        validate90.errors = [
                                            {
                                                instancePath: instancePath + '/excludeContingentWorkers',
                                                schemaPath: '#/properties/excludeContingentWorkers/type',
                                                keyword: 'type',
                                                params: { type: 'boolean' },
                                                message: 'must be boolean'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate90.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate90.errors = vErrors;
    return errors === 0;
}
export const workdayExportAuthSchemaValidation = validate91;
const schema134 = {
    $id: 'urn:wisepipe-common-connection:WorkdayExportAuth',
    type: 'object',
    properties: {
        userPassword: { $ref: 'urn:wisepipe-common-connection:UserPassword' },
        tenant: { type: 'string' },
        domain: { type: 'string' }
    },
    required: ['userPassword', 'tenant', 'domain']
};
function validate91(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:WorkdayExportAuth" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.userPassword === undefined && (missing0 = 'userPassword')) ||
                (data.tenant === undefined && (missing0 = 'tenant')) ||
                (data.domain === undefined && (missing0 = 'domain'))) {
                validate91.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.userPassword !== undefined) {
                    let data0 = data.userPassword;
                    const _errs1 = errors;
                    const _errs2 = errors;
                    if (errors === _errs2) {
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            let missing1;
                            if ((data0.user === undefined && (missing1 = 'user')) ||
                                (data0.password === undefined && (missing1 = 'password'))) {
                                validate91.errors = [
                                    {
                                        instancePath: instancePath + '/userPassword',
                                        schemaPath: 'urn:wisepipe-common-connection:UserPassword/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing1 },
                                        message: "must have required property '" + missing1 + "'"
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0.user !== undefined) {
                                    let data1 = data0.user;
                                    const _errs4 = errors;
                                    if (errors === _errs4) {
                                        if (typeof data1 === 'string') {
                                            if (func2(data1) < 1) {
                                                validate91.errors = [
                                                    {
                                                        instancePath: instancePath + '/userPassword/user',
                                                        schemaPath: 'urn:wisepipe-common-connection:UserPassword/properties/user/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate91.errors = [
                                                {
                                                    instancePath: instancePath + '/userPassword/user',
                                                    schemaPath: 'urn:wisepipe-common-connection:UserPassword/properties/user/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid2 = _errs4 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                                if (valid2) {
                                    if (data0.password !== undefined) {
                                        let data2 = data0.password;
                                        const _errs6 = errors;
                                        if (errors === _errs6) {
                                            if (typeof data2 === 'string') {
                                                if (func2(data2) < 1) {
                                                    validate91.errors = [
                                                        {
                                                            instancePath: instancePath + '/userPassword/password',
                                                            schemaPath: 'urn:wisepipe-common-connection:UserPassword/properties/password/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate91.errors = [
                                                    {
                                                        instancePath: instancePath + '/userPassword/password',
                                                        schemaPath: 'urn:wisepipe-common-connection:UserPassword/properties/password/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid2 = _errs6 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                }
                            }
                        }
                        else {
                            validate91.errors = [
                                {
                                    instancePath: instancePath + '/userPassword',
                                    schemaPath: 'urn:wisepipe-common-connection:UserPassword/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.tenant !== undefined) {
                        const _errs8 = errors;
                        if (typeof data.tenant !== 'string') {
                            validate91.errors = [
                                {
                                    instancePath: instancePath + '/tenant',
                                    schemaPath: '#/properties/tenant/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs8 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.domain !== undefined) {
                            const _errs10 = errors;
                            if (typeof data.domain !== 'string') {
                                validate91.errors = [
                                    {
                                        instancePath: instancePath + '/domain',
                                        schemaPath: '#/properties/domain/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs10 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate91.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate91.errors = vErrors;
    return errors === 0;
}
export const workdayExportConnectionSchemaValidation = validate92;
const schema136 = {
    $id: 'urn:wisepipe-common-connection:WorkdayExportConnection',
    type: 'object',
    properties: { tenant: { type: 'string' }, domain: { type: 'string' } },
    required: ['tenant', 'domain']
};
function validate92(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:WorkdayExportConnection" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.tenant === undefined && (missing0 = 'tenant')) ||
                (data.domain === undefined && (missing0 = 'domain'))) {
                validate92.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.tenant !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.tenant !== 'string') {
                        validate92.errors = [
                            {
                                instancePath: instancePath + '/tenant',
                                schemaPath: '#/properties/tenant/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.domain !== undefined) {
                        const _errs3 = errors;
                        if (typeof data.domain !== 'string') {
                            validate92.errors = [
                                {
                                    instancePath: instancePath + '/domain',
                                    schemaPath: '#/properties/domain/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate92.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate92.errors = vErrors;
    return errors === 0;
}
export const workdayRaaSAuthSchemaValidation = validate93;
const schema137 = {
    $id: 'urn:wisepipe-common-connection:WorkdayRaaSAuth',
    type: 'object',
    properties: { userPassword: { $ref: 'urn:wisepipe-common-connection:UserPassword' } },
    required: ['userPassword']
};
function validate93(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:WorkdayRaaSAuth" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.userPassword === undefined && (missing0 = 'userPassword')) {
                validate93.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.userPassword !== undefined) {
                    let data0 = data.userPassword;
                    const _errs2 = errors;
                    if (errors === _errs2) {
                        if (data0 && typeof data0 == 'object' && !Array.isArray(data0)) {
                            let missing1;
                            if ((data0.user === undefined && (missing1 = 'user')) ||
                                (data0.password === undefined && (missing1 = 'password'))) {
                                validate93.errors = [
                                    {
                                        instancePath: instancePath + '/userPassword',
                                        schemaPath: 'urn:wisepipe-common-connection:UserPassword/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing1 },
                                        message: "must have required property '" + missing1 + "'"
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data0.user !== undefined) {
                                    let data1 = data0.user;
                                    const _errs4 = errors;
                                    if (errors === _errs4) {
                                        if (typeof data1 === 'string') {
                                            if (func2(data1) < 1) {
                                                validate93.errors = [
                                                    {
                                                        instancePath: instancePath + '/userPassword/user',
                                                        schemaPath: 'urn:wisepipe-common-connection:UserPassword/properties/user/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate93.errors = [
                                                {
                                                    instancePath: instancePath + '/userPassword/user',
                                                    schemaPath: 'urn:wisepipe-common-connection:UserPassword/properties/user/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid2 = _errs4 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                                if (valid2) {
                                    if (data0.password !== undefined) {
                                        let data2 = data0.password;
                                        const _errs6 = errors;
                                        if (errors === _errs6) {
                                            if (typeof data2 === 'string') {
                                                if (func2(data2) < 1) {
                                                    validate93.errors = [
                                                        {
                                                            instancePath: instancePath + '/userPassword/password',
                                                            schemaPath: 'urn:wisepipe-common-connection:UserPassword/properties/password/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate93.errors = [
                                                    {
                                                        instancePath: instancePath + '/userPassword/password',
                                                        schemaPath: 'urn:wisepipe-common-connection:UserPassword/properties/password/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid2 = _errs6 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                }
                            }
                        }
                        else {
                            validate93.errors = [
                                {
                                    instancePath: instancePath + '/userPassword',
                                    schemaPath: 'urn:wisepipe-common-connection:UserPassword/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        else {
            validate93.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate93.errors = vErrors;
    return errors === 0;
}
export const workdayRaaSConnectionSchemaValidation = validate94;
const schema139 = {
    $id: 'urn:wisepipe-common-connection:WorkdayRaaSConnection',
    type: 'object',
    properties: {},
    required: []
};
function validate94(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-connection:WorkdayRaaSConnection" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate94.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate94.errors = vErrors;
    return errors === 0;
}
//# sourceMappingURL=validations.generated.js.map